var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBit1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.67,82.55c0,.69,0,1.39,0,2.09-.77,20-12.41,42.39-27,52.12l-.39.26c-.52.33-1,.65-1.55.95a25.17,25.17,0,0,1-9.12,3.31c-6.8.93-12.49-2.05-16-8.16a31.8,31.8,0,0,1-3.76-13.82c-.07-1-.11-2.14-.11-3.25s0-2.06.09-3.1a59.85,59.85,0,0,1,.74-6.59c2.56-15.44,10.8-31.19,21.27-40.65a44.34,44.34,0,0,1,4.63-3.65c.75-.51,1.51-1,2.28-1.43s1.3-.73,1.94-1l.55-.26a19.67,19.67,0,0,1,12-1.91c6.11,1.18,10.81,6,13.06,13.82A40.78,40.78,0,0,1,106.67,82.55Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-78",
    d: "M83.62,253.83c-92.44,53.37-92.44,139.91,0,193.28s242.33,53.37,334.76,0,92.45-139.9,0-193.28S176.06,200.46,83.62,253.83Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-78",
    d: "M359,391.76c-28.17,16.26-28.17,42.63,0,58.9s73.84,16.26,102,0,28.17-42.64,0-58.9S387.15,375.49,359,391.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-78",
    d: "M38.14,412.51c-15.41,8.9-15.41,23.32,0,32.22s40.39,8.9,55.8,0,15.41-23.32,0-32.22S53.55,403.61,38.14,412.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-78",
    d: "M143.57,466.61l-10.18-6a6.38,6.38,0,0,0-5.74,0l-15.79,9.12a6.31,6.31,0,0,1-5.74,0L52.65,438.87c-1.59-.92-1.59-2.4,0-3.31L229.92,333.21a6.31,6.31,0,0,1,5.74,0l53.47,30.87c1.58.92,1.59,2.41,0,3.34l-15.82,9.29c-1.57.93-1.56,2.41,0,3.32l10.16,5.79c1.59.91,1.59,2.38,0,3.3L149.3,466.61A6.35,6.35,0,0,1,143.57,466.61Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.61,49.15l3-6.17L91.63,35.52h0a19.93,19.93,0,0,0-4.88-2c-.59-.16-1.2-.29-1.81-.4a24.28,24.28,0,0,0-9.11.25,30.91,30.91,0,0,0-3.28.89,31.71,31.71,0,0,0-3.39,1.3,42.87,42.87,0,0,0-4.36,2.23,52.81,52.81,0,0,0-4.54,3c-1.12.82-2.23,1.69-3.33,2.62-16.06,13.56-28.69,37.72-31.9,61-.22,1.58-.39,3.16-.52,4.72q-.29,3.38-.27,6.68c0,1.8.07,3.55.21,5.24.12,1.46.28,2.87.49,4.23s.47,2.67.76,3.93h0a38.45,38.45,0,0,0,3.76,10q.52.93,1.08,1.8a24.22,24.22,0,0,0,5.73,6.19,20.09,20.09,0,0,0,2.11,1.38h0l12.23,7.06,2.71-5.64c.72-.16,1.44-.35,2.18-.57A39.6,39.6,0,0,0,64,145.52a50.93,50.93,0,0,0,5-3.32A65.73,65.73,0,0,0,75.15,137c13.4-12.9,24-33.08,27.83-53.17a89.82,89.82,0,0,0,1.26-8.92c.22-2.46.34-4.91.33-7.32a62.39,62.39,0,0,0-.86-10.39A44.7,44.7,0,0,0,101.61,49.15Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,90.56l26.25,15.16,3.46-10L31.41,80.56C30.11,83.84,29,87.19,28,90.56Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.63,35.52h0a19.93,19.93,0,0,0-4.88-2c-.59-.16-1.2-.29-1.81-.4a24.28,24.28,0,0,0-9.11.25c-.39.08-.8.19-1.2.29l27,15.6a.14.14,0,0,0,0-.07l3-6.17Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.82,73.85l3.46-4.16L52.92,47c-1.25,1.24-2.48,2.54-3.67,3.9Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.89,62.07,75,81.76l3.76-9.82L47,53.61A93.6,93.6,0,0,0,40.89,62.07Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.63,35.52h0a19.93,19.93,0,0,0-4.88-2c-.59-.16-1.2-.29-1.81-.4a24.28,24.28,0,0,0-9.11.25,30.91,30.91,0,0,0-3.28.89,31.71,31.71,0,0,0-3.39,1.3,42.87,42.87,0,0,0-4.36,2.23,52.81,52.81,0,0,0-4.54,3c-1.12.82-2.23,1.69-3.33,2.62C42,56,30,77.8,25.83,99.52l54.76,31.62A106.87,106.87,0,0,0,103,83.8a89.82,89.82,0,0,0,1.26-8.92c.22-2.46.34-4.91.33-7.32a62.39,62.39,0,0,0-.86-10.39,44.7,44.7,0,0,0-2.1-8l3-6.17Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,155.51l2.71-5.64c.72-.16,1.44-.35,2.18-.57A39.6,39.6,0,0,0,64,145.52a50.93,50.93,0,0,0,5-3.32A65.73,65.73,0,0,0,75.15,137c1.87-1.8,3.68-3.76,5.44-5.83L25.83,99.52c-.31,1.6-.58,3.19-.8,4.79s-.39,3.16-.52,4.72q-.29,3.38-.27,6.68c0,1.8.07,3.55.21,5.24.12,1.46.28,2.87.49,4.23s.47,2.67.76,3.93h0a38.45,38.45,0,0,0,3.76,10q.52.93,1.08,1.8a24.22,24.22,0,0,0,5.73,6.19,20.09,20.09,0,0,0,2.11,1.38h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.46,139.08q.52.93,1.08,1.8a24.22,24.22,0,0,0,5.73,6.19,20.09,20.09,0,0,0,2.11,1.38h0l12.23,7.06,2.71-5.64.11,0,.19-2.32-27.19-15.7A35.49,35.49,0,0,0,29.46,139.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.55,65.16a43.27,43.27,0,0,0-3-10.32,26.48,26.48,0,0,0-7.94-10.5,20.36,20.36,0,0,0-7.13-3.53c-.6-.16-1.2-.29-1.81-.39a24.06,24.06,0,0,0-9.11.24,30.27,30.27,0,0,0-3.28.89,34.15,34.15,0,0,0-3.4,1.3,42.74,42.74,0,0,0-4.35,2.23,52.28,52.28,0,0,0-4.55,3c-1.12.81-2.23,1.69-3.32,2.61-16.06,13.56-28.7,37.72-31.9,61-.22,1.59-.4,3.16-.52,4.73-.19,2.24-.29,4.47-.28,6.67,0,1.81.08,3.55.22,5.24.11,1.46.28,2.87.49,4.23s.46,2.67.76,3.94h0a38.16,38.16,0,0,0,3.76,10c.34.61.7,1.21,1.08,1.79A24,24,0,0,0,49,154.4a20.3,20.3,0,0,0,11.32,4.06,26.11,26.11,0,0,0,9-1.18,39.11,39.11,0,0,0,8.51-3.77,53.45,53.45,0,0,0,5-3.32A63.17,63.17,0,0,0,89,145c13.41-12.89,24-33.08,27.83-53.17a89.26,89.26,0,0,0,1.27-8.91c.22-2.47.33-4.92.32-7.33A62.22,62.22,0,0,0,117.55,65.16Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.55,65.16a43.27,43.27,0,0,0-3-10.32,26.48,26.48,0,0,0-7.94-10.5,20.36,20.36,0,0,0-7.13-3.53c-.6-.16-1.2-.29-1.81-.39a24.06,24.06,0,0,0-9.11.24,30.27,30.27,0,0,0-3.28.89,34.15,34.15,0,0,0-3.4,1.3,42.74,42.74,0,0,0-4.35,2.23,52.28,52.28,0,0,0-4.55,3c-1.12.81-2.23,1.69-3.32,2.61-16.06,13.56-28.7,37.72-31.9,61-.22,1.59-.4,3.16-.52,4.73-.19,2.24-.29,4.47-.28,6.67,0,1.81.08,3.55.22,5.24.11,1.46.28,2.87.49,4.23s.46,2.67.76,3.94h0a38.16,38.16,0,0,0,3.76,10c.34.61.7,1.21,1.08,1.79A24,24,0,0,0,49,154.4a20.3,20.3,0,0,0,11.32,4.06,26.11,26.11,0,0,0,9-1.18,39.11,39.11,0,0,0,8.51-3.77,53.45,53.45,0,0,0,5-3.32A63.17,63.17,0,0,0,89,145c13.41-12.89,24-33.08,27.83-53.17a89.26,89.26,0,0,0,1.27-8.91c.22-2.47.33-4.92.32-7.33A62.22,62.22,0,0,0,117.55,65.16Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.53,106.82c-.31,1.61-.58,3.22-.8,4.82s-.4,3.16-.52,4.73c-.19,2.24-.29,4.47-.28,6.67,0,1.81.08,3.55.22,5.24.11,1.46.28,2.87.49,4.23s.46,2.67.76,3.94h0a38.16,38.16,0,0,0,3.76,10c.34.61.7,1.21,1.08,1.79A24,24,0,0,0,49,154.4a20.3,20.3,0,0,0,11.32,4.06,26.11,26.11,0,0,0,9-1.18,39.11,39.11,0,0,0,8.51-3.77,53.24,53.24,0,0,0,4.45-2.93Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.16,139.26a36.15,36.15,0,0,0,3,7.16c.34.61.7,1.21,1.08,1.79A24,24,0,0,0,49,154.4a20.32,20.32,0,0,0,9.15,3.83Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1,87.91c-1.31,3.28-2.45,6.62-3.42,10l47.65,47.66c.22-.2.44-.4.65-.61a76.9,76.9,0,0,0,5.84-6.31Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68,60.94a95,95,0,0,0-6.1,8.46L106,121.86a107.8,107.8,0,0,0,4.66-9.9Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,54.35q-1.89,1.88-3.7,3.93l50.16,50.16c.7-1.88,1.36-3.77,2-5.68Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.29,71.92h0c-.06-1-.13-1.92-.23-2.85l-.09-.93-.12-1c-.09-.68-.19-1.37-.3-2a43.27,43.27,0,0,0-3-10.32,26.48,26.48,0,0,0-7.94-10.5,20.36,20.36,0,0,0-7.13-3.53c-.6-.16-1.2-.29-1.81-.39a24.06,24.06,0,0,0-9.11.24L87.32,41Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,81.77c0,21.45-12.5,46.2-28.32,56.73-.67.45-1.35.87-2,1.27-16.77,9.68-30.36-.59-30.36-23s13.59-48.32,30.36-58c.68-.39,1.36-.75,2-1.08C95.52,50,108,60.33,108,81.77Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,81.77c0,21.45-12.5,46.2-28.32,56.73-.67.45-1.35.87-2,1.27-16.77,9.68-30.36-.59-30.36-23s13.59-48.32,30.36-58c.68-.39,1.36-.75,2-1.08C95.52,50,108,60.33,108,81.77Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,82.55c0,.69,0,1.39,0,2.09-.77,20-12.41,42.39-27,52.12l-.39.26c-.52.33-1,.65-1.55.95a25.17,25.17,0,0,1-9.12,3.31c-6.8.93-12.49-2.05-16-8.16a31.8,31.8,0,0,1-3.76-13.82c-.07-1-.11-2.14-.11-3.25s0-2.06.09-3.1a59.85,59.85,0,0,1,.74-6.59c2.56-15.44,10.8-31.19,21.27-40.65a44.34,44.34,0,0,1,4.63-3.65c.75-.51,1.51-1,2.28-1.43s1.3-.73,1.94-1l.55-.26a19.67,19.67,0,0,1,12-1.91c6.11,1.18,10.81,6,13.06,13.82A40.78,40.78,0,0,1,106.67,82.55Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67,82.55c0,.69,0,1.39,0,2.09-.77,20-12.41,42.39-27,52.12l-.39.26c-.52.33-1,.65-1.55.95a25.17,25.17,0,0,1-9.12,3.31c-6.8.93-12.49-2.05-16-8.16a31.8,31.8,0,0,1-3.76-13.82c-.07-1-.11-2.14-.11-3.25s0-2.06.09-3.1a59.85,59.85,0,0,1,.74-6.59c2.56-15.44,10.8-31.19,21.27-40.65a44.34,44.34,0,0,1,4.63-3.65c.75-.51,1.51-1,2.28-1.43s1.3-.73,1.94-1l.55-.26a19.67,19.67,0,0,1,12-1.91c6.11,1.18,10.81,6,13.06,13.82A40.78,40.78,0,0,1,106.67,82.55Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,81.84c0-.7,0-1.4,0-2.08a40.8,40.8,0,0,0-1.46-11.32A21.55,21.55,0,0,0,94.16,58a14.88,14.88,0,0,0-2-.55,19.67,19.67,0,0,0-12,1.91l-.55.26c-.64.31-1.29.66-1.94,1s-1.53.92-2.28,1.43a43,43,0,0,0-4.63,3.65c-10.47,9.46-18.71,25.21-21.27,40.65a59.85,59.85,0,0,0-.74,6.59c-.06,1-.09,2.07-.09,3.1s0,2.2.11,3.25a31.8,31.8,0,0,0,3.76,13.82,18.1,18.1,0,0,0,3.82,4.7,15.73,15.73,0,0,0,7.39.67,25.16,25.16,0,0,0,9.11-3.32c.52-.3,1-.62,1.55-.95l.4-.26C89.41,124.23,101.05,101.83,101.81,81.84Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,81.84c0-.7,0-1.4,0-2.08a40.8,40.8,0,0,0-1.46-11.32A21.55,21.55,0,0,0,94.16,58a14.88,14.88,0,0,0-2-.55,19.67,19.67,0,0,0-12,1.91l-.55.26c-.64.31-1.29.66-1.94,1s-1.53.92-2.28,1.43a43,43,0,0,0-4.63,3.65c-10.47,9.46-18.71,25.21-21.27,40.65a59.85,59.85,0,0,0-.74,6.59c-.06,1-.09,2.07-.09,3.1s0,2.2.11,3.25a31.8,31.8,0,0,0,3.76,13.82,18.1,18.1,0,0,0,3.82,4.7,15.73,15.73,0,0,0,7.39.67,25.16,25.16,0,0,0,9.11-3.32c.52-.3,1-.62,1.55-.95l.4-.26C89.41,124.23,101.05,101.83,101.81,81.84Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.64,40.42C80.1,38.44,65.85,53,56.33,66c-13.75,20.26-22.45,45.91-17.7,70.44v0c1.55,6.82,4.67,13.66,10.35,18-5.8-4.25-9.16-11.09-10.8-18v0C33.8,116.41,39.3,95.32,48.49,77.35,58.33,59.57,75,38,97.64,40.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-78)"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "70.93 68.24 75.94 71.14 83.14 66.99 78.13 64.08 70.93 68.24",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.93 68.24 75.94 71.14 83.14 66.99 78.13 64.08 70.93 68.24",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.43 72.59 68.42 69.69 61.22 73.85 66.23 76.75 73.43 72.59",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.43 72.59 68.42 69.69 61.22 73.85 66.23 76.75 73.43 72.59",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.22 79.01 66.23 81.91 61.21 84.81 56.2 81.91 61.22 79.01",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.22 79.01 66.23 81.91 61.21 84.81 56.2 81.91 61.22 79.01",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.2 91.51 61.21 94.41 61.21 84.81 56.2 81.91 56.2 91.51",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.2 91.51 61.21 94.41 61.21 84.81 56.2 81.91 56.2 91.51",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.22 73.85 61.22 79.01 66.23 81.91 66.23 76.75 61.22 73.85",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.22 73.85 61.22 79.01 66.23 81.91 66.23 76.75 61.22 73.85",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.93 68.24 70.93 71.14 73.43 72.59 73.43 77.75 75.94 76.31 75.94 71.14 70.93 68.24",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.93 68.24 70.93 71.14 73.43 72.59 73.43 77.75 75.94 76.31 75.94 71.14 70.93 68.24",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.2 121.23 61.21 124.13 64.63 122.16 59.61 119.26 56.2 121.23",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.2 121.23 61.21 124.13 64.63 122.16 59.61 119.26 56.2 121.23",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.61 119.26 64.63 122.16 64.63 92.44 61.21 94.41 59.61 93.49 59.61 119.26",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.61 119.26 64.63 122.16 64.63 92.44 61.21 94.41 59.61 93.49 59.61 119.26",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.2 121.23 61.21 124.13 61.21 133.73 56.2 130.83 56.2 121.23",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.2 121.23 61.21 124.13 61.21 133.73 56.2 130.83 56.2 121.23",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.23 130.83 66.23 135.05 62.58 132.94 66.23 130.83",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.23 130.83 66.23 135.05 62.58 132.94 66.23 130.83",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.94 125.23 75.94 129.45 73.43 128 73.43 126.67 75.94 125.23",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.94 125.23 75.94 129.45 73.43 128 73.43 126.67 75.94 125.23",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.47,71.46a5.72,5.72,0,0,1,.9-.09,5.29,5.29,0,0,1,2.71.63l-4.87-2.83h0a5.11,5.11,0,0,0-1.07-.47v3.5a9.74,9.74,0,0,1,1.37-.52,6.3,6.3,0,0,1,.69-.17Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.47,71.46a5.72,5.72,0,0,1,.9-.09,5.29,5.29,0,0,1,2.71.63l-4.87-2.83h0a5.11,5.11,0,0,0-1.07-.47v3.5a9.74,9.74,0,0,1,1.37-.52,6.3,6.3,0,0,1,.69-.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,103.58v.8c0,2.7-1.64,5.86-3.68,7l-10.11,5.84-1.3.75v-5.79l6.4-3.7c2-1.15,3.65-4.25,3.68-6.94l.45-.25.88-.52C85.28,99.63,86.92,100.88,86.92,103.58Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92,103.58v.8c0,2.7-1.64,5.86-3.68,7l-10.11,5.84-1.3.75v-5.79l6.4-3.7c2-1.15,3.65-4.25,3.68-6.94l.45-.25.88-.52C85.28,99.63,86.92,100.88,86.92,103.58Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.64,84.69v.75a7.88,7.88,0,0,1-3.28,6.27L71.83,97.79V92l5.51-3.17a7.83,7.83,0,0,0,3.24-5.6l1.78-1C84.17,81.16,85.64,82.27,85.64,84.69Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.64,84.69v.75a7.88,7.88,0,0,1-3.28,6.27L71.83,97.79V92l5.51-3.17a7.83,7.83,0,0,0,3.24-5.6l1.78-1C84.17,81.16,85.64,82.27,85.64,84.69Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.73,90.89a24.9,24.9,0,0,0,2.11-9.61v-.75c0-7.31-4.25-10.93-9.7-8.32V67l-7.2,4.15v5.17l-2.51,1.44V72.59l-7.2,4.16v5.16l-5,2.9v9.6l3.42-2v29.72l-3.42,2v9.6l5-2.9v4.22l7.2-4.16v-4.22l2.51-1.44v4.22l7.2-4.16v-4.22l.1-.06c6-3.46,10.88-12.79,10.88-20.79v-.79C94.12,95.48,92.89,92.38,90.73,90.89Zm-5.09-6.2v.75a7.86,7.86,0,0,1-3.28,6.27L71.83,97.79V88.28l1.3-.75,9.23-5.33C84.17,81.16,85.64,82.27,85.64,84.69Zm-13.81,22.7,10.53-6.08.88-.51c2-1.17,3.68.08,3.68,2.78v.8c0,2.71-1.65,5.86-3.68,7l-10.11,5.84-1.3.75Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.73,90.89a24.9,24.9,0,0,0,2.11-9.61v-.75c0-7.31-4.25-10.93-9.7-8.32V67l-7.2,4.15v5.17l-2.51,1.44V72.59l-7.2,4.16v5.16l-5,2.9v9.6l3.42-2v29.72l-3.42,2v9.6l5-2.9v4.22l7.2-4.16v-4.22l2.51-1.44v4.22l7.2-4.16v-4.22l.1-.06c6-3.46,10.88-12.79,10.88-20.79v-.79C94.12,95.48,92.89,92.38,90.73,90.89Zm-5.09-6.2v.75a7.86,7.86,0,0,1-3.28,6.27L71.83,97.79V88.28l1.3-.75,9.23-5.33C84.17,81.16,85.64,82.27,85.64,84.69Zm-13.81,22.7,10.53-6.08.88-.51c2-1.17,3.68.08,3.68,2.78v.8c0,2.71-1.65,5.86-3.68,7l-10.11,5.84-1.3.75Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.14,72.21V69.48L81.56,67.9l-4.84,2.79L92.25,86.23a22.12,22.12,0,0,0,.59-5v-.75c0-.48,0-1-.06-1.4l-7.61-7.62A8.75,8.75,0,0,0,83.14,72.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.63,84.52a1,1,0,0,1,0,.17v.75a7.86,7.86,0,0,1-3.28,6.27l-2.59,1.5,13.42,13.42a24.35,24.35,0,0,0,.93-6.41v-.79c0-4-1.23-7.05-3.39-8.54.13-.3.24-.61.36-.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.83 116.27 73.13 117.25 71.83 118 71.83 113.27 64.63 106.07 64.63 119.48 73.43 128.29 73.43 126.67 75.94 125.23 75.94 129.45 83.14 125.29 83.14 124.58 74.83 116.27",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.74,87.18l8.62-5a3.09,3.09,0,0,1,.66-.29l-7.08-7.09v1.49l-2.51,1.44V72.59l-7.2,4.16v2.93Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.63,92.44v29.72c.08-1.24.12-2.48.18-3.72s.08-2.47.12-3.71c.07-2.48.11-5,.11-7.43s0-5,0-7.43c0-1.24,0-2.48-.08-3.72l-.11-3.71v-.36l-.28.19c-1.11.71-2.22,1.41-3.32,2.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.15,75.92c.63-.3,1.25-.61,1.87-.93s1.22-.65,1.82-1c.42-.22.82-.46,1.22-.7,0,.62,0,1.25.09,1.88,0,.43.07.86.12,1.29s.09.86.16,1.29V72.59l-7.2,4.16h0l1-.41C67.52,76.2,67.84,76.07,68.15,75.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86,70.31c.63-.29,1.25-.6,1.86-.92,1-.54,2-1.12,3-1.71,0,.64,0,1.28.09,1.91,0,.44.07.87.12,1.31s.1.87.17,1.3h0V67l-7.2,4.15c.33-.12.65-.26,1-.4S77.55,70.47,77.86,70.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.64,84.69v.75a7.86,7.86,0,0,1-3.28,6.27L71.84,97.78h0l1-.47c.62-.32,1.53-.75,2.59-1.32s2.3-1.2,3.61-1.93L81,93l1-.59.52-.29a4.27,4.27,0,0,0,.54-.37,7.1,7.1,0,0,0,1.64-1.92,8.67,8.67,0,0,0,.93-2.21A7,7,0,0,0,86,85.33a6.76,6.76,0,0,0-.24-2,2.36,2.36,0,0,0-1-1.39,1.81,1.81,0,0,0-1.3-.21,2.55,2.55,0,0,0-.77.3l-.24.15h0C84.18,81.17,85.64,82.28,85.64,84.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.23,104.2a6.76,6.76,0,0,0-.29-2.18,2.56,2.56,0,0,0-1.16-1.5,2,2,0,0,0-1.42-.21,2.62,2.62,0,0,0-.85.33l-.27.16.06,0c2-1.11,3.62.13,3.62,2.81v.8c0,2.71-1.65,5.86-3.68,7l-10.11,5.84-1.29.74,1.08-.52c.68-.36,1.68-.83,2.84-1.46s2.53-1.33,4-2.14c.72-.4,1.47-.81,2.22-1.24a18,18,0,0,0,2.3-1.41A9.16,9.16,0,0,0,87,106.64,8.29,8.29,0,0,0,87.23,104.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.12,100.22v-.79c0-4-1.23-7.05-3.39-8.54h0l.29.25a7.9,7.9,0,0,1,.75.8,9.11,9.11,0,0,1,1.61,3.48A13.84,13.84,0,0,1,93.75,98a28,28,0,0,1,0,2.89,13,13,0,0,1-.13,1.51c-.06.51-.12,1-.23,1.55a14.72,14.72,0,0,1-.32,1.55c-.12.52-.26,1-.42,1.54a15.89,15.89,0,0,1-.5,1.52c-.17.51-.36,1-.57,1.48s-.41,1-.64,1.43-.44.93-.69,1.37-.47.87-.73,1.28-.48.83-.75,1.2c-.51.77-1,1.46-1.55,2.08s-1,1.17-1.49,1.62-.92.81-1.27,1.13c-.75.58-1.2.89-1.2.89C89.24,117.55,94.12,108.22,94.12,100.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,132.64a36.24,36.24,0,0,0-3.41,2.41l7.2-4.16v-4.22a33.63,33.63,0,0,0-.37,4Q71.32,131.59,69.64,132.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.14,121.07h0c-.19,1.33-.28,2.67-.35,4-1.17.6-2.32,1.26-3.45,2a30.48,30.48,0,0,0-3.4,2.42l7.2-4.16Z",
    style: {
      fill: "#f5f5f5"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.92,431.82c-12.36-12.76-19.63-64.7-7.57-74.82H96.73c12.06,10.12,4.8,62-7.56,74.8-.1.12-.23.24-.34.36l-.42.42c-.35.34-.72.67-1.12,1l-.3.24c-.3.24-.6.48-.93.71a16.62,16.62,0,0,1-1.6,1c-10.17,5.94-26.66,5.94-36.84,0h0a16.87,16.87,0,0,1-1.61-1c-.31-.21-.58-.44-.87-.66l-.36-.29c-.39-.32-.74-.64-1.08-1l-.49-.49C43.12,432,43,431.92,42.92,431.82Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.92,431.82c-12.36-12.76-19.63-64.7-7.57-74.82H96.73c12.06,10.12,4.8,62-7.56,74.8-.1.12-.23.24-.34.36l-.42.42c-.35.34-.72.67-1.12,1l-.3.24c-.3.24-.6.48-.93.71a16.62,16.62,0,0,1-1.6,1c-10.17,5.94-26.66,5.94-36.84,0h0a16.87,16.87,0,0,1-1.61-1c-.31-.21-.58-.44-.87-.66l-.36-.29c-.39-.32-.74-.64-1.08-1l-.49-.49C43.12,432,43,431.92,42.92,431.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4,352.93c14,8.17,14,21.43,0,29.6s-36.71,8.18-50.71,0-14-21.43,0-29.6S77.4,344.75,91.4,352.93Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4,352.93c14,8.17,14,21.43,0,29.6s-36.71,8.18-50.71,0-14-21.43,0-29.6S77.4,344.75,91.4,352.93Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.66,356.86c10.29,6,10.29,15.74,0,21.74s-26.95,6-37.24,0-10.28-15.74,0-21.74S74.38,350.86,84.66,356.86Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.66,356.86c10.29,6,10.29,15.74,0,21.74s-26.95,6-37.24,0-10.28-15.74,0-21.74S74.38,350.86,84.66,356.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.42,367.18c10.29-6,27-6,37.24,0a17.18,17.18,0,0,1,6.16,5.71,17.18,17.18,0,0,1-6.16,5.71c-10.28,6-26.95,6-37.24,0a17.26,17.26,0,0,1-6.16-5.71A17.26,17.26,0,0,1,47.42,367.18Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.38,308.26c-2.28-4.12-6.48-7.28-3.64-16.55s3.86-22.6,6.5-25.28,6.71,5.5,8.27,15.17S83.84,303.93,72.38,308.26Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.56,277.68c-3.3-1-14.39-8.64-13-25.6S53.43,210,60.69,210.24,66,224,65.31,241.88,63.6,265.7,52.56,277.68Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,293.46c-6.37,2-11.27.91-15.43-7.58s-5.19-19-2.94-20.49,8.89,8.05,11.67,12C41.5,283.44,43.41,284.94,44,293.46Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.05,331.26c-3.73-.78-5.79-1.34-7.65-6.95s-6-12.61-5.68-14.87,5.27.37,9.46,4.62S59.17,328.12,55.05,331.26Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.42,326.68c-5.24,0-8.4-.61-12.27-8.22s-5.18-21.57-2-23.37,5.9,4.47,10.3,12.26S37.61,318,34.42,326.68Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.61,339.72c-2.21,2.1-4.93,2.42-8.94-.1s-7.22-6.75-6.65-8,5.91,1.09,8.15,2C33.55,335.17,35.8,334.76,37.61,339.72Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.79,322c4.84-1.35,8.17-1.94,10.06-10.25s-.22-22.19-3.72-23.17-4.63,5.77-7,14.4S87.87,315,90.79,322Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,336.06c3.41,1.58,5.45,1.55,8.32-2.21s4.41-8.85,3.44-9.79-5.15,3.09-6.91,4.77C93.8,331.38,92,331.78,91.6,336.06Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.75,330.5c-2.06,1.15-3.78,2.86-5.79,4.1a40,40,0,0,1-5.5,2.7c-2,.85-4,1.61-5.92,2.55-.54.27-1.11.55-1.68.86,3.93-4.59,7.81-9.22,10.56-14.64a46,46,0,0,0,4.26-13,107.32,107.32,0,0,0,1-14.33c0-.21-.28-.47-.33-.15-.88,5.76-1.91,11.54-3.3,17.2a44.14,44.14,0,0,1-5.3,12.91,95.4,95.4,0,0,1-8.34,11c-2.14,2.54-4.29,5.22-6.32,7.9a43.88,43.88,0,0,0-4.54,6.84c-.14-2.81-.37-5.62-.71-8.42-.6-4.93-1.52-9.81-2.56-14.66a32.17,32.17,0,0,1,1.67-8A70.42,70.42,0,0,1,69.73,315c2.72-5.38,5.38-10.71,6.72-16.62a42.37,42.37,0,0,0,.85-5.14,49.21,49.21,0,0,0,.42-5.82c0-.15-.16-.08-.18,0-.27,1.52-.4,3.06-.73,4.57s-.77,3.17-1.21,4.75a74.68,74.68,0,0,1-3.1,9c-2.34,5.6-5.6,10.78-7.74,16.46a36.94,36.94,0,0,0-1.44,4.65c-.67-2.95-1.36-5.89-2-8.84-4.22-18.36-8.21-37-8.72-55.86A157.62,157.62,0,0,1,53,245.26c.21-2.54.45-5.08.79-7.61s.85-5.23,1.35-7.84c0-.15-.13-.23-.18-.07-.73,2.27-1.21,4.6-1.82,6.9a62.21,62.21,0,0,0-1.3,6.93,109.5,109.5,0,0,0-1.08,14.36A178.32,178.32,0,0,0,53,286.57c.91,6,2,12,3.29,17.95q-.47-.67-1-1.32A45.8,45.8,0,0,0,50,297.43c-3.52-3.24-7.61-5.7-11.35-8.65A19.07,19.07,0,0,1,33,282c-.07-.13-.17.06-.14.14,1.49,4.26,5,7.7,8.48,10.4,2,1.51,4,3,5.82,4.55a47.1,47.1,0,0,1,5.51,5.61c1,1.17,1.89,2.39,2.74,3.65.4.58.78,1.17,1.15,1.77a9,9,0,0,0,.61.94q.6,2.81,1.23,5.59c2.08,9.3,4.48,18.56,5.92,28,.5,3.27.84,6.56,1.07,9.86a31.62,31.62,0,0,0-4-4.16l-.61-.52c-.34-.6-.77-1.19-1-1.72a29.83,29.83,0,0,1-1.46-3.89c-.82-2.73-1.35-5.54-1.92-8.32-1.1-5.31-2.71-10.86-6.91-14.57-.06-.05-.13.11-.09.16,3.49,4.31,4.57,9.93,5.6,15.24a64,64,0,0,0,1.94,8.12A28.22,28.22,0,0,0,58,345.5c-2.4-1.89-4.88-3.68-7.35-5.46a96.12,96.12,0,0,1-10.76-8.63,44.35,44.35,0,0,1-8.29-11.22c-2.73-5.16-5.13-10.51-7.39-15.88-.12-.3-.34,0-.28.23a107.15,107.15,0,0,0,4.51,13.63,46.28,46.28,0,0,0,7.3,11.61c4,4.58,8.88,8.13,13.82,11.62-.63-.16-1.26-.3-1.85-.42-2.1-.45-4.24-.7-6.36-1a40.94,40.94,0,0,1-6-1.28c-2.25-.71-4.34-2-6.61-2.57-.13,0-.17.22-.09.28A29.82,29.82,0,0,0,41,341.27c2,.36,4,.6,5.94,1a62.67,62.67,0,0,1,6.32,1.85.65.65,0,0,0,.19,0c1,.75,2.07,1.5,3.09,2.28a62.82,62.82,0,0,1,5.85,5,18.58,18.58,0,0,1,2.93,3.51c.11.18.21.38.31.57,0,1,.09,2,.11,3,.1,5.44-.36,10.8-.67,16.22-.06,1.11,1.66,1,1.82,0a90.9,90.9,0,0,0,.93-14.57c0-.64,0-1.28,0-1.92.05-.21.1-.43.17-.64a17.9,17.9,0,0,1,2-4.11,62.63,62.63,0,0,1,4.47-6.24c.8-1,1.62-2,2.45-3a.44.44,0,0,0,.17-.06,64.48,64.48,0,0,1,5.68-3.34c1.82-.85,3.69-1.57,5.52-2.39a29.89,29.89,0,0,0,10.72-7.74C99,330.67,98.86,330.44,98.75,330.5Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.75,330.5c-2.06,1.15-3.78,2.86-5.79,4.1a40,40,0,0,1-5.5,2.7c-2,.85-4,1.61-5.92,2.55-.54.27-1.11.55-1.68.86,3.93-4.59,7.81-9.22,10.56-14.64a46,46,0,0,0,4.26-13,107.32,107.32,0,0,0,1-14.33c0-.21-.28-.47-.33-.15-.88,5.76-1.91,11.54-3.3,17.2a44.14,44.14,0,0,1-5.3,12.91,95.4,95.4,0,0,1-8.34,11c-2.14,2.54-4.29,5.22-6.32,7.9a43.88,43.88,0,0,0-4.54,6.84c-.14-2.81-.37-5.62-.71-8.42-.6-4.93-1.52-9.81-2.56-14.66a32.17,32.17,0,0,1,1.67-8A70.42,70.42,0,0,1,69.73,315c2.72-5.38,5.38-10.71,6.72-16.62a42.37,42.37,0,0,0,.85-5.14,49.21,49.21,0,0,0,.42-5.82c0-.15-.16-.08-.18,0-.27,1.52-.4,3.06-.73,4.57s-.77,3.17-1.21,4.75a74.68,74.68,0,0,1-3.1,9c-2.34,5.6-5.6,10.78-7.74,16.46a36.94,36.94,0,0,0-1.44,4.65c-.67-2.95-1.36-5.89-2-8.84-4.22-18.36-8.21-37-8.72-55.86A157.62,157.62,0,0,1,53,245.26c.21-2.54.45-5.08.79-7.61s.85-5.23,1.35-7.84c0-.15-.13-.23-.18-.07-.73,2.27-1.21,4.6-1.82,6.9a62.21,62.21,0,0,0-1.3,6.93,109.5,109.5,0,0,0-1.08,14.36A178.32,178.32,0,0,0,53,286.57c.91,6,2,12,3.29,17.95q-.47-.67-1-1.32A45.8,45.8,0,0,0,50,297.43c-3.52-3.24-7.61-5.7-11.35-8.65A19.07,19.07,0,0,1,33,282c-.07-.13-.17.06-.14.14,1.49,4.26,5,7.7,8.48,10.4,2,1.51,4,3,5.82,4.55a47.1,47.1,0,0,1,5.51,5.61c1,1.17,1.89,2.39,2.74,3.65.4.58.78,1.17,1.15,1.77a9,9,0,0,0,.61.94q.6,2.81,1.23,5.59c2.08,9.3,4.48,18.56,5.92,28,.5,3.27.84,6.56,1.07,9.86a31.62,31.62,0,0,0-4-4.16l-.61-.52c-.34-.6-.77-1.19-1-1.72a29.83,29.83,0,0,1-1.46-3.89c-.82-2.73-1.35-5.54-1.92-8.32-1.1-5.31-2.71-10.86-6.91-14.57-.06-.05-.13.11-.09.16,3.49,4.31,4.57,9.93,5.6,15.24a64,64,0,0,0,1.94,8.12A28.22,28.22,0,0,0,58,345.5c-2.4-1.89-4.88-3.68-7.35-5.46a96.12,96.12,0,0,1-10.76-8.63,44.35,44.35,0,0,1-8.29-11.22c-2.73-5.16-5.13-10.51-7.39-15.88-.12-.3-.34,0-.28.23a107.15,107.15,0,0,0,4.51,13.63,46.28,46.28,0,0,0,7.3,11.61c4,4.58,8.88,8.13,13.82,11.62-.63-.16-1.26-.3-1.85-.42-2.1-.45-4.24-.7-6.36-1a40.94,40.94,0,0,1-6-1.28c-2.25-.71-4.34-2-6.61-2.57-.13,0-.17.22-.09.28A29.82,29.82,0,0,0,41,341.27c2,.36,4,.6,5.94,1a62.67,62.67,0,0,1,6.32,1.85.65.65,0,0,0,.19,0c1,.75,2.07,1.5,3.09,2.28a62.82,62.82,0,0,1,5.85,5,18.58,18.58,0,0,1,2.93,3.51c.11.18.21.38.31.57,0,1,.09,2,.11,3,.1,5.44-.36,10.8-.67,16.22-.06,1.11,1.66,1,1.82,0a90.9,90.9,0,0,0,.93-14.57c0-.64,0-1.28,0-1.92.05-.21.1-.43.17-.64a17.9,17.9,0,0,1,2-4.11,62.63,62.63,0,0,1,4.47-6.24c.8-1,1.62-2,2.45-3a.44.44,0,0,0,.17-.06,64.48,64.48,0,0,1,5.68-3.34c1.82-.85,3.69-1.57,5.52-2.39a29.89,29.89,0,0,0,10.72-7.74C99,330.67,98.86,330.44,98.75,330.5Z",
    style: {
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.21,366.22V47.69c0-8.2-4.07-10.46-7.69-12.55s-9.56-3.35-14.7-.38L108.28,110.7c-5.13,3-9.3,10.18-9.3,16.11V445.35c0,5.93,3.72,9.43,7.34,11.51s9.92,4.38,15.05,1.42l131.54-75.95A17.48,17.48,0,0,0,262.21,366.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.85,369.24,118.59,447.33l0-319.92-16.93-9.77A19.08,19.08,0,0,0,99,126.81V445.35c0,5.93,3.72,9.43,7.34,11.51s9.92,4.38,15.05,1.42l131.54-75.95a17.7,17.7,0,0,0,8-9l-.52-.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.67,44.93,120.75,121.1a14.46,14.46,0,0,0-6.53,11.3v316c0,6.36,4.52,9,10,5.78L252.67,380a16.42,16.42,0,0,0,7.39-12.81V49.2C260.06,44.5,256.73,42.58,252.67,44.93Z",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.63,64.3V359.65a15.58,15.58,0,0,1-7,12.18L127.68,440.49c-3.88,2.25-7,.44-7-4.05V138.93a15.68,15.68,0,0,1,4.93-10.59l.66-.61a13.87,13.87,0,0,1,1.43-1l33.45-19.32,2.18-1.25c1.2-.7,2.18-.14,2.18,1.25s1,1.93,2.33,1.17l39-22.5a5,5,0,0,0,2.34-3.86,4.92,4.92,0,0,1,2-3.65l.23-.14L244,59.58l.69-.41C249.63,56.34,253.63,58.65,253.63,64.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.4,363.94a15.57,15.57,0,0,0,7-12.18V59.93l-32.1,18.53-.23.14a4.92,4.92,0,0,0-2,3.65,5,5,0,0,1-2.34,3.86l-39,22.5c-1.29.76-2.33.22-2.33-1.17s-1-2-2.18-1.25l-2.18,1.25-33.45,19.32a12.87,12.87,0,0,0-1.43,1l-.66.61a15.68,15.68,0,0,0-4.93,10.59V430.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.74,96.73l17.87-10.32c1.07-.62,1.93-.18,1.93,1a4.12,4.12,0,0,1-1.93,3.2l-17.87,10.32c-1.06.61-1.93.18-1.93-1A4.14,4.14,0,0,1,173.74,96.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.78,80.27c1.2-.7,2.17-.13,2.18,1.25a4.81,4.81,0,0,1-2.18,3.77c-1.2.69-2.17.13-2.17-1.26A4.8,4.8,0,0,1,200.78,80.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.18,165a7.84,7.84,0,0,0-3.43-6.22,2.31,2.31,0,0,0-2.36-.2c-.43.26-2.13,1.21-2.58,1.48a2.7,2.7,0,0,0-1.06,2.44v26a7.85,7.85,0,0,0,3.44,6.21,2.3,2.3,0,0,0,2.27.24c.47-.25,2.21-1.25,2.66-1.52a2.68,2.68,0,0,0,1.06-2.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.63,166.5v26c0,2.33-1.54,3.34-3.44,2.24a7.85,7.85,0,0,1-3.44-6.21v-26c0-2.34,1.54-3.34,3.44-2.25A7.86,7.86,0,0,1,108.63,166.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.18,210.45a7.84,7.84,0,0,0-3.43-6.21,2.28,2.28,0,0,0-2.36-.2c-.43.26-2.13,1.21-2.58,1.48a2.7,2.7,0,0,0-1.06,2.44v25.95a7.86,7.86,0,0,0,3.44,6.22,2.33,2.33,0,0,0,2.27.24c.47-.25,2.21-1.25,2.66-1.52a2.68,2.68,0,0,0,1.06-2.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.63,211.93v25.95c0,2.34-1.54,3.35-3.44,2.25a7.86,7.86,0,0,1-3.44-6.22V208c0-2.34,1.54-3.35,3.44-2.25A7.86,7.86,0,0,1,108.63,211.93Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wintow--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.39,68.85l-128.2,73.92a6.39,6.39,0,0,0-2.88,5V448.14a6.32,6.32,0,0,0,2.89,5l1.8,1a6.43,6.43,0,0,0,5.78,0l128.2-74a6.4,6.4,0,0,0,2.89-5V74.86a6.36,6.36,0,0,0-2.9-5l-1.8-1A6.43,6.43,0,0,0,267.39,68.85Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.39,68.85l-128.2,73.92a6.39,6.39,0,0,0-2.88,5V448.14a6.32,6.32,0,0,0,2.89,5l1.8,1a6.43,6.43,0,0,0,5.78,0l128.2-74a6.4,6.4,0,0,0,2.89-5V74.86a6.36,6.36,0,0,0-2.9-5l-1.8-1A6.43,6.43,0,0,0,267.39,68.85Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.87,375.32c0,2.53-1.78,4.15-4,5.42l-126,72.75c-2.19,1.27-4,.24-4-2.31V153.36h0a8,8,0,0,1,4-6.88l126-72.78a2.66,2.66,0,0,1,4,2.3h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.2,75.42a.58.58,0,0,1,.59.58V375.32c0,.95-.35,2.12-3,3.62l-126,72.75a1.5,1.5,0,0,1-.73.26,1.75,1.75,0,0,1-.13-.77V153.36a5.88,5.88,0,0,1,2.93-5.08l126-72.78a.53.53,0,0,1,.29-.08m0-2.08a2.64,2.64,0,0,0-1.33.36l-126,72.78a8,8,0,0,0-4,6.88V451.18c0,1.81.91,2.85,2.21,2.85a3.56,3.56,0,0,0,1.78-.54l126-72.75c2.21-1.27,4-2.89,4-5.42V76a2.67,2.67,0,0,0-2.67-2.66Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.87,74.86V76a2.67,2.67,0,0,0-4-2.3l-126,72.79a7.76,7.76,0,0,0-2.9,2.9.25.25,0,0,0,0,.09l-7.8-4.5a5.82,5.82,0,0,1,2.08-2.2L267.39,68.85a6.43,6.43,0,0,1,5.78,0l1.8,1A6.33,6.33,0,0,1,277.87,74.86Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.87,74.86V76a2.67,2.67,0,0,0-4-2.3l-126,72.79a7.76,7.76,0,0,0-2.9,2.9.25.25,0,0,0,0,.09l-7.8-4.5a5.82,5.82,0,0,1,2.08-2.2L267.39,68.85a6.43,6.43,0,0,1,5.78,0l1.8,1A6.33,6.33,0,0,1,277.87,74.86Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.32,182.86a.08.08,0,0,1-.11,0,.2.2,0,0,1,0-.14V177a.43.43,0,0,1,0-.19.29.29,0,0,1,.11-.13l1.53-.89a1.05,1.05,0,0,1,.61-.18.6.6,0,0,1,.38.21,1,1,0,0,1,.2.42,2.1,2.1,0,0,1,.06.48,3.12,3.12,0,0,1,0,.55,2.28,2.28,0,0,1-.14.44,2.63,2.63,0,0,1-.15.33l-.11.18a.9.9,0,0,1,.38.39,1.51,1.51,0,0,1,.16.78,3,3,0,0,1-.08.7,3.91,3.91,0,0,1-.23.71,2.93,2.93,0,0,1-.4.63,1.89,1.89,0,0,1-.55.47Zm.39-5.59v1.78l1.08-.63a1.43,1.43,0,0,0,.58-.56,1.49,1.49,0,0,0,.19-.77c0-.28-.06-.47-.19-.55s-.32,0-.58.11Zm0,2.57v2l1.17-.68a1.22,1.22,0,0,0,.33-.27,1.78,1.78,0,0,0,.25-.36,2.12,2.12,0,0,0,.14-.4,1.44,1.44,0,0,0,.05-.41,1.29,1.29,0,0,0,0-.35.61.61,0,0,0-.14-.24.36.36,0,0,0-.24-.09.7.7,0,0,0-.35.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.36,178l-2,1.14-.3,1.34a.64.64,0,0,1-.06.18.37.37,0,0,1-.16.17l-.21.12s-.07,0-.09,0a.15.15,0,0,1,0-.12,1.05,1.05,0,0,1,0-.13l1.4-6.36a1.17,1.17,0,0,1,.09-.24.38.38,0,0,1,.17-.2l.34-.2c.08,0,.14,0,.17,0a.42.42,0,0,1,.09.14l1.39,4.75a.26.26,0,0,1,0,.11.53.53,0,0,1,0,.16c0,.05-.05.09-.09.11l-.21.12c-.08,0-.13,0-.16,0a.21.21,0,0,1-.06-.1Zm-1.78.24,1.58-.92-.79-2.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.28,176.32c.05,0,.08,0,.11,0a.18.18,0,0,1,.05.14v.32a.49.49,0,0,1-.05.19.24.24,0,0,1-.11.13L165,178.45a.08.08,0,0,1-.11,0,.2.2,0,0,1,0-.14v-5.69a.43.43,0,0,1,0-.19.29.29,0,0,1,.11-.13l.23-.14c.05,0,.08,0,.11,0a.2.2,0,0,1,0,.14v5.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.48,173.88l-2,1.14-.3,1.34a.64.64,0,0,1-.06.18.37.37,0,0,1-.16.17l-.21.12s-.07,0-.09,0a.15.15,0,0,1,0-.12,1.05,1.05,0,0,1,0-.13l1.4-6.36a1.17,1.17,0,0,1,.09-.24.38.38,0,0,1,.17-.2l.34-.2c.08,0,.14,0,.17,0a.42.42,0,0,1,.09.14l1.39,4.75a.26.26,0,0,1,0,.11.53.53,0,0,1,0,.16.35.35,0,0,1-.09.11L171,175c-.08,0-.13.05-.16,0a.21.21,0,0,1-.06-.1Zm-1.78.23,1.58-.91-.79-2.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,172.92a.1.1,0,0,1-.13,0,.64.64,0,0,1-.1-.13l-1.85-3.23v4.33a.49.49,0,0,1-.05.2.36.36,0,0,1-.11.13l-.23.13a.08.08,0,0,1-.11,0,.2.2,0,0,1-.05-.14v-5.69a.45.45,0,0,1,.05-.19.25.25,0,0,1,.11-.13l.2-.12a.09.09,0,0,1,.13,0,.4.4,0,0,1,.1.12l1.85,3.23V167.1a.49.49,0,0,1,0-.19.29.29,0,0,1,.11-.13l.23-.14a.09.09,0,0,1,.11,0,.2.2,0,0,1,0,.14v5.68a.49.49,0,0,1,0,.2.29.29,0,0,1-.11.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.28,168.1c0,.27,0,.51,0,.74s0,.48,0,.74a1.58,1.58,0,0,0,.29,1c.18.2.44.2.78,0a1.73,1.73,0,0,0,.46-.38,2.31,2.31,0,0,0,.32-.45,2.22,2.22,0,0,0,.18-.49,3,3,0,0,0,.1-.49.48.48,0,0,1,.06-.18.22.22,0,0,1,.09-.1l.27-.16a.06.06,0,0,1,.08,0s0,.06,0,.12a2.79,2.79,0,0,1-.1.69,4.07,4.07,0,0,1-.77,1.59,2.62,2.62,0,0,1-.73.63,1.27,1.27,0,0,1-.66.2.76.76,0,0,1-.5-.21,1.22,1.22,0,0,1-.32-.56,3.28,3.28,0,0,1-.13-.89q0-.77,0-1.56a4.91,4.91,0,0,1,.13-1,4.08,4.08,0,0,1,.32-.95,3.47,3.47,0,0,1,.5-.78,2.38,2.38,0,0,1,.66-.57,1.3,1.3,0,0,1,.73-.21.72.72,0,0,1,.49.22,1.15,1.15,0,0,1,.28.48,1.69,1.69,0,0,1,.1.58.34.34,0,0,1,0,.16.21.21,0,0,1-.08.1l-.27.16a.14.14,0,0,1-.09,0s-.05,0-.06-.11a1.51,1.51,0,0,0-.1-.38.54.54,0,0,0-.18-.27.49.49,0,0,0-.32-.1,1.09,1.09,0,0,0-.46.17,1.83,1.83,0,0,0-.78.9A3.65,3.65,0,0,0,176.28,168.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16,167.73a.09.09,0,0,1,.11,0,.18.18,0,0,1,0,.14v.32a.49.49,0,0,1,0,.19.29.29,0,0,1-.11.13l-2.31,1.33s-.07,0-.1,0a.2.2,0,0,1-.05-.14V164a.45.45,0,0,1,.05-.19.28.28,0,0,1,.1-.13l2.27-1.31a.09.09,0,0,1,.11,0,.18.18,0,0,1,0,.14v.32a.46.46,0,0,1,0,.19.37.37,0,0,1-.11.13l-1.88,1.08v1.86l1.75-1a.09.09,0,0,1,.11,0,.18.18,0,0,1,.05.14v.32a.45.45,0,0,1-.05.19.29.29,0,0,1-.11.13l-1.75,1v1.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.78,188a2.35,2.35,0,0,1,1.28-.13,2,2,0,0,1,.95.5,2.5,2.5,0,0,1,.58.88,2.71,2.71,0,0,1,.22,1,.66.66,0,0,1-.08.4.72.72,0,0,1-.24.29l-.6.34a.31.31,0,0,1-.26.06c-.06,0-.13-.12-.2-.29a2.89,2.89,0,0,0-.24-.44,1.33,1.33,0,0,0-.46-.42,1.48,1.48,0,0,0-.7-.16,2,2,0,0,0-.95.32,3.67,3.67,0,0,0-.79.6,4.59,4.59,0,0,0-.67.83,4.36,4.36,0,0,0-.47,1,3.67,3.67,0,0,0-.18,1.14,2,2,0,0,0,.17.9.92.92,0,0,0,.55.42,2.57,2.57,0,0,0,.95.05c.38,0,.84-.1,1.39-.19a5.17,5.17,0,0,1,1.42-.08,1.9,1.9,0,0,1,1,.37,1.67,1.67,0,0,1,.54.87,5.13,5.13,0,0,1,.17,1.41,7.42,7.42,0,0,1-.24,1.86,7.87,7.87,0,0,1-.67,1.77,8.19,8.19,0,0,1-1,1.58,7.58,7.58,0,0,1-1.37,1.29v1.47a1.29,1.29,0,0,1-.11.5.76.76,0,0,1-.28.34l-.61.35a.21.21,0,0,1-.28,0,.46.46,0,0,1-.11-.36v-1.52a2.5,2.5,0,0,1-1.29.15,2.21,2.21,0,0,1-1-.42,2.09,2.09,0,0,1-.65-.86,2.94,2.94,0,0,1-.25-1.16,1,1,0,0,1,.09-.4.55.55,0,0,1,.23-.28l.6-.35a.34.34,0,0,1,.26-.06c.07,0,.14.12.2.29a2.27,2.27,0,0,0,.27.54,1.25,1.25,0,0,0,.49.42,1.49,1.49,0,0,0,.75.12,2.54,2.54,0,0,0,1.05-.38,5.21,5.21,0,0,0,1-.75,6,6,0,0,0,.82-1,5.48,5.48,0,0,0,.56-1.14,3.75,3.75,0,0,0,.2-1.18,1.39,1.39,0,0,0-.23-.87,1.11,1.11,0,0,0-.68-.37,3.24,3.24,0,0,0-1.08,0c-.43.06-.91.14-1.45.24a3.07,3.07,0,0,1-1.25,0,1.59,1.59,0,0,1-.84-.47,2.14,2.14,0,0,1-.47-.94,5.9,5.9,0,0,1-.14-1.35,7.42,7.42,0,0,1,.18-1.57,8.73,8.73,0,0,1,.52-1.62,8.17,8.17,0,0,1,.88-1.5,6.43,6.43,0,0,1,1.24-1.26v-1.49a1.13,1.13,0,0,1,.11-.5.7.7,0,0,1,.28-.34l.61-.35a.21.21,0,0,1,.28,0,.52.52,0,0,1,.11.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,190.3a10,10,0,0,0,.66-1.63,6.28,6.28,0,0,0,.22-1.78,2.65,2.65,0,0,0-.46-1.74q-.45-.54-1.44,0a3.25,3.25,0,0,0-.87.73,4.19,4.19,0,0,0-.61,1,6.26,6.26,0,0,0-.38,1.13c-.09.39-.17.79-.23,1.18a1.51,1.51,0,0,1-.15.48.8.8,0,0,1-.23.27l-.68.39a.18.18,0,0,1-.23,0,.4.4,0,0,1-.09-.29,8.59,8.59,0,0,1,.25-1.85,9.62,9.62,0,0,1,.68-1.95,8.72,8.72,0,0,1,1.08-1.78,5,5,0,0,1,1.46-1.3,2.71,2.71,0,0,1,1.43-.44,1.5,1.5,0,0,1,1,.45,2.81,2.81,0,0,1,.63,1.18,6.56,6.56,0,0,1,.21,1.75,11.45,11.45,0,0,1-.08,1.36,9.31,9.31,0,0,1-.24,1.26,11.33,11.33,0,0,1-.43,1.28c-.18.44-.4.9-.65,1.4L168.63,198l4.5-2.6a.2.2,0,0,1,.28,0,.46.46,0,0,1,.12.36v.81a1.11,1.11,0,0,1-.12.5.79.79,0,0,1-.28.35l-6.34,3.66a.22.22,0,0,1-.28,0,.49.49,0,0,1-.12-.36v-.82a1.45,1.45,0,0,1,.07-.47c0-.15.14-.34.25-.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.09,193.41a.22.22,0,0,1-.28,0,.54.54,0,0,1-.11-.37V189.9l-4.63,2.67a.22.22,0,0,1-.28,0,.54.54,0,0,1-.11-.37v-.81a1.74,1.74,0,0,1,0-.41,2.21,2.21,0,0,1,.15-.48l4.65-12.07a3.41,3.41,0,0,1,.26-.54.85.85,0,0,1,.32-.33l.59-.34a.2.2,0,0,1,.28,0,.46.46,0,0,1,.12.36v9.47l1.26-.73a.21.21,0,0,1,.28,0,.47.47,0,0,1,.12.36v.82a1.18,1.18,0,0,1-.12.5.75.75,0,0,1-.28.34l-1.26.73v3.13a1.18,1.18,0,0,1-.12.5.82.82,0,0,1-.28.34Zm-.39-5.55v-6.39l-3.2,8.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,189.29a2.41,2.41,0,0,1,.18-.7,1.08,1.08,0,0,1,.45-.55l.85-.49a.18.18,0,0,1,.23,0,.37.37,0,0,1,.1.29.88.88,0,0,1,0,.17l-.76,3.48a3.74,3.74,0,0,1-.2.59,1,1,0,0,1-.44.5l-.36.21a.18.18,0,0,1-.23,0,.38.38,0,0,1-.1-.3v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.07,178.15a9.23,9.23,0,0,0,.67-1.63,6.71,6.71,0,0,0,.22-1.78,2.65,2.65,0,0,0-.46-1.74q-.45-.54-1.44,0a3.12,3.12,0,0,0-.88.73,4.15,4.15,0,0,0-.6,1,6,6,0,0,0-.38,1.13c-.1.39-.17.79-.23,1.18a1.36,1.36,0,0,1-.16.48.66.66,0,0,1-.22.26l-.68.4a.18.18,0,0,1-.23,0,.41.41,0,0,1-.1-.3,9.24,9.24,0,0,1,.26-1.84,9.77,9.77,0,0,1,.67-2,9.38,9.38,0,0,1,1.08-1.78,5,5,0,0,1,1.47-1.3,2.69,2.69,0,0,1,1.43-.44,1.54,1.54,0,0,1,1,.44,2.75,2.75,0,0,1,.62,1.18,6.67,6.67,0,0,1,.22,1.76,11.45,11.45,0,0,1-.08,1.36,9.31,9.31,0,0,1-.24,1.26,11.33,11.33,0,0,1-.43,1.28c-.18.44-.4.9-.65,1.4l-3.28,6.61,4.5-2.6a.21.21,0,0,1,.28,0,.5.5,0,0,1,.12.37v.81a1.11,1.11,0,0,1-.12.5.7.7,0,0,1-.28.34l-6.34,3.67a.22.22,0,0,1-.28,0,.5.5,0,0,1-.12-.37v-.81a1.45,1.45,0,0,1,.07-.47,4.57,4.57,0,0,1,.25-.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.28,179.65a2.92,2.92,0,0,0,.21.61.8.8,0,0,0,.4.41,1.11,1.11,0,0,0,.7.06,3.47,3.47,0,0,0,1.12-.46,4.32,4.32,0,0,0,1.59-1.62,5.66,5.66,0,0,0,.5-1.18,5.14,5.14,0,0,0,.18-1.39,2.87,2.87,0,0,0-.18-1.13.89.89,0,0,0-.47-.54,1.09,1.09,0,0,0-.72,0,3.3,3.3,0,0,0-.9.38l-1.22.7a.2.2,0,0,1-.28,0,.46.46,0,0,1-.11-.36v-.81a1,1,0,0,1,.08-.42c0-.15.1-.28.15-.4l2.65-5.93L196.74,170a.21.21,0,0,1-.28,0,.46.46,0,0,1-.12-.36v-.82a1.11,1.11,0,0,1,.12-.49.79.79,0,0,1,.28-.35l5.8-3.34a.21.21,0,0,1,.28,0,.5.5,0,0,1,.12.37v.81a1.41,1.41,0,0,1-.08.44,3.78,3.78,0,0,1-.19.49l-2.6,5.83a3.15,3.15,0,0,1,1.34-.43,1.57,1.57,0,0,1,1.05.33,2.27,2.27,0,0,1,.68,1.06,5.56,5.56,0,0,1,.24,1.77,8.48,8.48,0,0,1-.3,2.25,8.77,8.77,0,0,1-.78,2,8.11,8.11,0,0,1-1.17,1.64,6.08,6.08,0,0,1-1.42,1.16,4.21,4.21,0,0,1-1.7.63,1.82,1.82,0,0,1-1.17-.25,1.86,1.86,0,0,1-.69-.9,3.57,3.57,0,0,1-.25-1.32.85.85,0,0,1,.1-.4.55.55,0,0,1,.23-.28l.67-.39c.11-.07.2-.07.26,0A.4.4,0,0,1,197.28,179.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9,176.16a1.11,1.11,0,0,1-.12.5.79.79,0,0,1-.28.35l-.6.34a.2.2,0,0,1-.28,0,.46.46,0,0,1-.12-.36V164.49l-2.38,4.16a.6.6,0,0,1-.3.31.23.23,0,0,1-.26-.08l-.36-.5a.6.6,0,0,1-.08-.4,1.28,1.28,0,0,1,.16-.5l3.15-5.54a.89.89,0,0,1,.23-.29l.24-.16.6-.35a.22.22,0,0,1,.28,0,.5.5,0,0,1,.12.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.3,172.07a.22.22,0,0,1,.28,0,.49.49,0,0,1,.12.36V174a1.15,1.15,0,0,1-.12.5.7.7,0,0,1-.28.34l-1,.57a.21.21,0,0,1-.28,0,.46.46,0,0,1-.12-.36v-1.52a1.18,1.18,0,0,1,.12-.5.75.75,0,0,1,.28-.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.64,168.76a1.46,1.46,0,0,0,.84,1.2,1.7,1.7,0,0,0,1.5-.24,4.11,4.11,0,0,0,.91-.73,4.68,4.68,0,0,0,.75-1,6,6,0,0,0,.68-2.87,4.15,4.15,0,0,0-.18-1.33,1.56,1.56,0,0,0-.5-.74,1.06,1.06,0,0,0-.75-.18,2.13,2.13,0,0,0-.91.32,3.45,3.45,0,0,0-.89.7,5.9,5.9,0,0,0-.54.73q-.23.33-.39.63a1,1,0,0,1-.39.41l-.75.44a.18.18,0,0,1-.23,0,.4.4,0,0,1-.09-.29l.44-7.83a1.18,1.18,0,0,1,.12-.5.75.75,0,0,1,.28-.34l5.19-3a.22.22,0,0,1,.28,0,.49.49,0,0,1,.12.36v.82a1.15,1.15,0,0,1-.12.5.75.75,0,0,1-.28.34l-4.28,2.47-.24,4.06a7.21,7.21,0,0,1,.69-.75,5.59,5.59,0,0,1,1.08-.79,3.26,3.26,0,0,1,1.45-.48,1.71,1.71,0,0,1,1.19.37,2.6,2.6,0,0,1,.8,1.21,6.08,6.08,0,0,1,.3,2.07,9.51,9.51,0,0,1-.3,2.4,9.75,9.75,0,0,1-.8,2.14,8.35,8.35,0,0,1-1.19,1.74,6.13,6.13,0,0,1-1.45,1.2,3.51,3.51,0,0,1-1.41.49,1.89,1.89,0,0,1-1.17-.21,2.09,2.09,0,0,1-.82-.91,3.62,3.62,0,0,1-.32-1.57,1,1,0,0,1,.09-.41.67.67,0,0,1,.23-.28l.68-.39a.21.21,0,0,1,.23,0A.39.39,0,0,1,215.64,168.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.22,165.58a1.25,1.25,0,0,1-.11.5.86.86,0,0,1-.28.35l-.61.34a.2.2,0,0,1-.28,0,.46.46,0,0,1-.11-.36V153.91l-2.39,4.16a.63.63,0,0,1-.29.31.25.25,0,0,1-.27-.08l-.35-.5a.55.55,0,0,1-.08-.4,1.12,1.12,0,0,1,.15-.5l3.15-5.54a1.05,1.05,0,0,1,.24-.29l.23-.16.61-.35a.22.22,0,0,1,.28,0,.54.54,0,0,1,.11.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notification--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.66,97.85l-3.44-2h0c-1.5-.85-3.56-.72-5.83.6-4.58,2.64-8.3,9.08-8.3,14.37,0,2.64.93,4.5,2.42,5.37h0l3.13,1.8.74-1.23a8.47,8.47,0,0,0,2.38-.92c4.58-2.65,8.3-9.09,8.3-14.38a9.18,9.18,0,0,0-.26-2.12Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.66,97.85l-3.44-2h0c-1.5-.85-3.56-.72-5.83.6-4.58,2.64-8.3,9.08-8.3,14.37,0,2.64.93,4.5,2.42,5.37h0l3.13,1.8.74-1.23a8.47,8.47,0,0,0,2.38-.92c4.58-2.65,8.3-9.09,8.3-14.38a9.18,9.18,0,0,0-.26-2.12Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36,108a13.62,13.62,0,0,0-.31,2.79c0,2.64.93,4.5,2.42,5.37h0l3.13,1.8.74-1.23a8.47,8.47,0,0,0,2.38-.92,14,14,0,0,0,2.26-1.67Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.36,108a13.62,13.62,0,0,0-.31,2.79c0,2.64.93,4.5,2.42,5.37h0l3.13,1.8.74-1.23a8.47,8.47,0,0,0,2.38-.92,14,14,0,0,0,2.26-1.67Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.62,98.32c-4.59,2.64-8.3,9.08-8.3,14.37s3.71,7.44,8.3,4.8,8.3-9.09,8.3-14.38S266.2,95.67,261.62,98.32Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.9,105.69v-2c0-2.32-1.42-3.38-3.16-2.38h0a7.55,7.55,0,0,0-3.15,6v1.82a7.15,7.15,0,0,1-1.06,3.55h0a2,2,0,0,0-.26.93h0c0,.58.36.85.79.6l7.36-4.25a1.91,1.91,0,0,0,.8-1.52h0a.75.75,0,0,0-.23-.61h0A2.15,2.15,0,0,1,264.9,105.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.26,111.83a3.63,3.63,0,0,1-1.52,2.89c-.83.48-1.51,0-1.51-1.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.56,148.43c0,.38,0,.72,0,1s0,.66,0,1a2.25,2.25,0,0,0,.41,1.43c.26.28.62.28,1.1,0a2.61,2.61,0,0,0,.65-.52,3.32,3.32,0,0,0,.44-.64,3.38,3.38,0,0,0,.26-.69,4.69,4.69,0,0,0,.14-.69.67.67,0,0,1,.09-.26.43.43,0,0,1,.12-.14l.37-.21a.09.09,0,0,1,.13,0,.22.22,0,0,1,0,.16,4.26,4.26,0,0,1-.14,1,5.5,5.5,0,0,1-.39,1.14,5,5,0,0,1-.7,1.11,3.61,3.61,0,0,1-1,.88,1.78,1.78,0,0,1-.93.28,1.08,1.08,0,0,1-.71-.29,1.91,1.91,0,0,1-.45-.8,4.39,4.39,0,0,1-.18-1.24c0-.72,0-1.46,0-2.2a6.92,6.92,0,0,1,.18-1.44,6.71,6.71,0,0,1,.45-1.33,5.26,5.26,0,0,1,.71-1.11,3.49,3.49,0,0,1,.93-.79,1.86,1.86,0,0,1,1-.31,1.12,1.12,0,0,1,.7.32,1.52,1.52,0,0,1,.39.68,2.56,2.56,0,0,1,.14.81.59.59,0,0,1,0,.22.28.28,0,0,1-.13.15l-.37.22a.11.11,0,0,1-.12,0c-.05,0-.07-.07-.09-.15a2.38,2.38,0,0,0-.14-.54.89.89,0,0,0-.26-.38.7.7,0,0,0-.44-.13,1.38,1.38,0,0,0-.65.23,2.66,2.66,0,0,0-1.1,1.27A5,5,0,0,0,180.56,148.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.41,143.41a.12.12,0,0,1,.15,0,.28.28,0,0,1,.07.2v.4a.68.68,0,0,1-.07.27.42.42,0,0,1-.15.19l-.47.27a2.05,2.05,0,0,0-.92,1.95v3.62a.54.54,0,0,1-.07.27.42.42,0,0,1-.15.19l-.3.17a.12.12,0,0,1-.15,0,.28.28,0,0,1-.06-.2V145a.66.66,0,0,1,.06-.27.42.42,0,0,1,.15-.19l.3-.17a.12.12,0,0,1,.15,0,.24.24,0,0,1,.07.2v.38a2.57,2.57,0,0,1,.38-.76,1.86,1.86,0,0,1,.59-.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.56,150.67a1.68,1.68,0,0,1-.08.24.38.38,0,0,1-.16.19l-.33.19a.09.09,0,0,1-.13,0,.24.24,0,0,1-.06-.18.28.28,0,0,1,0-.09l.77-3L188,143.46a.19.19,0,0,1,0-.08.5.5,0,0,1,.06-.24.34.34,0,0,1,.13-.17l.33-.19a.12.12,0,0,1,.16,0,.71.71,0,0,1,.08.15l1.24,3.5,1.25-4.94a1.68,1.68,0,0,1,.08-.24.42.42,0,0,1,.15-.19l.33-.19c.06,0,.1,0,.14,0a.22.22,0,0,1,.06.18s0,.06,0,.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.79,145.72a1.08,1.08,0,0,1-.8.19.8.8,0,0,1-.45-.32v2.74a.54.54,0,0,1-.07.27.38.38,0,0,1-.15.19l-.3.17a.11.11,0,0,1-.15,0,.28.28,0,0,1-.06-.2v-8.12a.66.66,0,0,1,.06-.27.38.38,0,0,1,.15-.19l.3-.17a.11.11,0,0,1,.15,0,.24.24,0,0,1,.07.2v.38a3.94,3.94,0,0,1,.46-.85,2.27,2.27,0,0,1,.79-.71,1.23,1.23,0,0,1,.7-.2.8.8,0,0,1,.57.26,1.66,1.66,0,0,1,.38.7,4,4,0,0,1,.17,1.13c0,.12,0,.26,0,.4s0,.28,0,.41a6.27,6.27,0,0,1-.17,1.32,5.54,5.54,0,0,1-.38,1.15,4.38,4.38,0,0,1-.57.91A2.81,2.81,0,0,1,194.79,145.72Zm-1.25-3.16c0,.13,0,.29,0,.49s0,.37,0,.49a1.7,1.7,0,0,0,.34,1.16.66.66,0,0,0,.82,0,2,2,0,0,0,.84-1,4.18,4.18,0,0,0,.34-1.6v-.7a1.9,1.9,0,0,0-.34-1.21c-.2-.23-.48-.24-.84,0a2.19,2.19,0,0,0-.82.94A3.7,3.7,0,0,0,193.54,142.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.65,141.19a2.58,2.58,0,0,0,0,.42.7.7,0,0,0,.1.3.25.25,0,0,0,.21.11.73.73,0,0,0,.34-.12l.43-.24a.11.11,0,0,1,.15,0,.28.28,0,0,1,.06.2v.39a.74.74,0,0,1-.06.28.4.4,0,0,1-.15.18l-.51.29c-.47.27-.81.28-1,0a2.31,2.31,0,0,1-.32-1.43v-3.2l-.59.34a.13.13,0,0,1-.16,0,.28.28,0,0,1-.06-.2v-.39a.67.67,0,0,1,.06-.28.41.41,0,0,1,.16-.18l.59-.35v-2a.54.54,0,0,1,.07-.27.42.42,0,0,1,.15-.19l.3-.17a.12.12,0,0,1,.15,0,.28.28,0,0,1,.06.2v2l1-.59a.11.11,0,0,1,.15,0,.28.28,0,0,1,.06.2v.39a.67.67,0,0,1-.06.28.4.4,0,0,1-.15.18l-1,.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.49,134.58a1.45,1.45,0,0,1,.77-.24.82.82,0,0,1,.58.23,1.4,1.4,0,0,1,.38.65,3.72,3.72,0,0,1,.18,1v1.16a7.91,7.91,0,0,1-.18,1.23,5,5,0,0,1-.38,1.09,4.2,4.2,0,0,1-.58.9,3,3,0,0,1-.77.65,1.65,1.65,0,0,1-.77.24.86.86,0,0,1-.58-.23,1.46,1.46,0,0,1-.38-.65,4,4,0,0,1-.18-1c0-.07,0-.15,0-.25v-.64c0-.11,0-.2,0-.28a7.18,7.18,0,0,1,.18-1.22,5.19,5.19,0,0,1,.38-1.09,4.2,4.2,0,0,1,.58-.9A2.81,2.81,0,0,1,202.49,134.58Zm1.17,3.19a4.19,4.19,0,0,0,0-.53,3.86,3.86,0,0,0,0-.51,3,3,0,0,0-.1-.64,1,1,0,0,0-.22-.42.51.51,0,0,0-.36-.17.88.88,0,0,0-.49.15,1.6,1.6,0,0,0-.49.41,2.63,2.63,0,0,0-.35.58,2.94,2.94,0,0,0-.23.69,4.52,4.52,0,0,0-.1.75c0,.16,0,.33,0,.54s0,.37,0,.5a2.77,2.77,0,0,0,.1.63.93.93,0,0,0,.23.43.51.51,0,0,0,.35.17.88.88,0,0,0,.49-.15,1.79,1.79,0,0,0,.49-.42,2.76,2.76,0,0,0,.36-.57,3.71,3.71,0,0,0,.22-.69A4.82,4.82,0,0,0,203.66,137.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.71,128.31a1.93,1.93,0,0,1,.75-.28.89.89,0,0,1,.61.12,1.1,1.1,0,0,1,.42.58,2.93,2.93,0,0,1,.16,1.08,4.65,4.65,0,0,1-.16,1.27,4.34,4.34,0,0,1-.42,1.08,3.62,3.62,0,0,1-.61.85,3.47,3.47,0,0,1-.75.6l-1.48.85v3a.67.67,0,0,1-.06.28.4.4,0,0,1-.15.18l-.33.19a.12.12,0,0,1-.16,0,.25.25,0,0,1-.06-.19v-8a.67.67,0,0,1,.06-.28.41.41,0,0,1,.16-.18Zm-1.48,5,1.44-.84a2.29,2.29,0,0,0,.9-.9,2.76,2.76,0,0,0,.32-1.36c0-.53-.11-.85-.32-1a1,1,0,0,0-.9.16l-1.44.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.18,127.83a1.62,1.62,0,0,1,.77-.24.88.88,0,0,1,.58.23,1.51,1.51,0,0,1,.38.65,4.17,4.17,0,0,1,.17,1,2.18,2.18,0,0,1,0,.27v.64a2,2,0,0,1,0,.26,6.88,6.88,0,0,1-.17,1.23,5.72,5.72,0,0,1-.38,1.08,4.62,4.62,0,0,1-.58.9,3,3,0,0,1-.77.65,1.45,1.45,0,0,1-.78.24.86.86,0,0,1-.57-.23,1.43,1.43,0,0,1-.39-.64,4.17,4.17,0,0,1-.17-1c0-.06,0-.15,0-.25s0-.21,0-.32,0-.22,0-.32,0-.2,0-.28a6.92,6.92,0,0,1,.17-1.21,5.09,5.09,0,0,1,.39-1.1,4.58,4.58,0,0,1,.57-.9A3.22,3.22,0,0,1,214.18,127.83Zm1.17,3.19c0-.15,0-.32,0-.52s0-.38,0-.52a3.74,3.74,0,0,0-.1-.64,1,1,0,0,0-.23-.42.53.53,0,0,0-.35-.17.86.86,0,0,0-.49.15,1.79,1.79,0,0,0-.49.42,2.76,2.76,0,0,0-.36.57,4,4,0,0,0-.22.69,4.8,4.8,0,0,0-.11.76c0,.15,0,.33,0,.53s0,.37,0,.51a3,3,0,0,0,.11.63,1,1,0,0,0,.22.42.51.51,0,0,0,.36.17.88.88,0,0,0,.49-.15,1.73,1.73,0,0,0,.49-.41,3.08,3.08,0,0,0,.35-.58,3.49,3.49,0,0,0,.23-.69A5.9,5.9,0,0,0,215.35,131Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.23,125a.12.12,0,0,1,.15,0,.28.28,0,0,1,.06.2v.4a.66.66,0,0,1-.06.27.42.42,0,0,1-.15.19l-.47.27a2,2,0,0,0-.92,2V132a.68.68,0,0,1-.07.27.42.42,0,0,1-.15.19l-.3.17a.12.12,0,0,1-.15,0,.28.28,0,0,1-.07-.2V126.6a.68.68,0,0,1,.07-.27.42.42,0,0,1,.15-.19l.3-.17a.12.12,0,0,1,.15,0,.28.28,0,0,1,.07.2v.38a2.77,2.77,0,0,1,.38-.77,2,2,0,0,1,.59-.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.24,128.15a2.81,2.81,0,0,0,0,.43.7.7,0,0,0,.1.29.23.23,0,0,0,.2.11.73.73,0,0,0,.34-.12l.43-.24a.11.11,0,0,1,.15,0,.24.24,0,0,1,.07.2v.39a.61.61,0,0,1-.07.28.35.35,0,0,1-.15.18l-.51.3c-.46.26-.8.27-1,0a2.32,2.32,0,0,1-.31-1.43v-3.2l-.6.34a.11.11,0,0,1-.15,0,.28.28,0,0,1-.07-.2v-.39a.72.72,0,0,1,.07-.28.35.35,0,0,1,.15-.18l.6-.35v-2a.66.66,0,0,1,.06-.27.42.42,0,0,1,.15-.19l.3-.17a.12.12,0,0,1,.15,0,.24.24,0,0,1,.07.2v2l1-.59a.12.12,0,0,1,.15,0,.24.24,0,0,1,.07.2v.4a.54.54,0,0,1-.07.27.42.42,0,0,1-.15.19l-1,.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.54,122l1-.59a.11.11,0,0,1,.15,0,.27.27,0,0,1,.06.2V122a.66.66,0,0,1-.06.27.38.38,0,0,1-.15.19l-1,.59v5a.68.68,0,0,1-.07.27.38.38,0,0,1-.15.19l-.3.17a.11.11,0,0,1-.15,0,.28.28,0,0,1-.07-.2v-5l-.67.39a.11.11,0,0,1-.15,0,.23.23,0,0,1-.07-.2v-.39A.54.54,0,0,1,223,123a.38.38,0,0,1,.15-.19l.67-.39v-.62a4.33,4.33,0,0,1,.32-1.76,2.36,2.36,0,0,1,1-1.11l.51-.29c.06,0,.11,0,.15,0a.25.25,0,0,1,.06.19v.4a.66.66,0,0,1-.06.27.38.38,0,0,1-.15.19l-.43.25a1.19,1.19,0,0,0-.34.28,1.2,1.2,0,0,0-.21.34,2.73,2.73,0,0,0-.1.41c0,.15,0,.3,0,.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.13,119.78a1.45,1.45,0,0,1,.77-.24.85.85,0,0,1,.58.22,1.5,1.5,0,0,1,.38.66,3.72,3.72,0,0,1,.18,1v1.16a7.91,7.91,0,0,1-.18,1.23,5.39,5.39,0,0,1-.38,1.09,3.9,3.9,0,0,1-.58.89,2.64,2.64,0,0,1-.77.65,1.57,1.57,0,0,1-.77.25.91.91,0,0,1-.58-.23,1.51,1.51,0,0,1-.38-.65,4.06,4.06,0,0,1-.18-1,2.27,2.27,0,0,0,0-.24v-.65a2.62,2.62,0,0,0,0-.27,7,7,0,0,1,.18-1.22,5,5,0,0,1,.38-1.09,3.76,3.76,0,0,1,.58-.9A2.64,2.64,0,0,1,228.13,119.78Zm1.18,3.18c0-.14,0-.32,0-.52s0-.37,0-.52a3.41,3.41,0,0,0-.11-.63,1.09,1.09,0,0,0-.22-.43.61.61,0,0,0-.36-.17,1,1,0,0,0-.49.15,1.79,1.79,0,0,0-.49.42,2.24,2.24,0,0,0-.35.58,3,3,0,0,0-.23.68,4.79,4.79,0,0,0-.1.76c0,.15,0,.33,0,.53s0,.37,0,.51a2.77,2.77,0,0,0,.1.63.93.93,0,0,0,.23.43.51.51,0,0,0,.35.17.88.88,0,0,0,.49-.15,1.79,1.79,0,0,0,.49-.42,2.58,2.58,0,0,0,.36-.58,3.61,3.61,0,0,0,.22-.68A6.32,6.32,0,0,0,229.31,123Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,123.89a.74.74,0,0,1-.06.28.41.41,0,0,1-.16.18l-.3.17a.11.11,0,0,1-.15,0,.25.25,0,0,1-.06-.19v-8.13a.66.66,0,0,1,.06-.27.63.63,0,0,1,.15-.19l.3-.17a.13.13,0,0,1,.16,0,.28.28,0,0,1,.06.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.81,115.31a.54.54,0,0,1-.07.27.38.38,0,0,1-.15.19l-.46.26c-.06,0-.11,0-.15,0a.25.25,0,0,1-.06-.19v-.71a.66.66,0,0,1,.06-.27.38.38,0,0,1,.15-.19l.46-.26c.06,0,.11,0,.15,0a.22.22,0,0,1,.07.19Zm-.08,7.46a.58.58,0,0,1-.07.28.35.35,0,0,1-.15.18l-.3.18a.12.12,0,0,1-.15,0,.3.3,0,0,1-.06-.2v-5.77a.71.71,0,0,1,.06-.28.35.35,0,0,1,.15-.18l.3-.18a.11.11,0,0,1,.15,0,.22.22,0,0,1,.07.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,114.86a1.45,1.45,0,0,1,.77-.24.82.82,0,0,1,.58.23,1.4,1.4,0,0,1,.38.65,3.74,3.74,0,0,1,.17,1,2,2,0,0,1,0,.26v.65a1.78,1.78,0,0,1,0,.25,6.88,6.88,0,0,1-.17,1.23A5.19,5.19,0,0,1,238,120a4.2,4.2,0,0,1-.58.9,3,3,0,0,1-.77.65,1.65,1.65,0,0,1-.77.24.86.86,0,0,1-.58-.23,1.56,1.56,0,0,1-.39-.65,4,4,0,0,1-.17-1c0-.07,0-.15,0-.25V119c0-.1,0-.19,0-.27a7,7,0,0,1,.17-1.22,5.59,5.59,0,0,1,.39-1.09,4.2,4.2,0,0,1,.58-.9A2.81,2.81,0,0,1,236.65,114.86Zm1.17,3.19c0-.15,0-.33,0-.53s0-.37,0-.51a3,3,0,0,0-.1-.64,1.17,1.17,0,0,0-.23-.43.5.5,0,0,0-.35-.16,1,1,0,0,0-.49.14,1.79,1.79,0,0,0-.49.42,3.13,3.13,0,0,0-.36.58,3.49,3.49,0,0,0-.22.69,4.52,4.52,0,0,0-.11.75c0,.16,0,.33,0,.54s0,.37,0,.5a2.74,2.74,0,0,0,.11.63,1,1,0,0,0,.22.43.56.56,0,0,0,.36.17.88.88,0,0,0,.49-.15,1.79,1.79,0,0,0,.49-.42,2.36,2.36,0,0,0,.35-.57,4,4,0,0,0,.23-.69A4.82,4.82,0,0,0,237.82,118.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,168.31a.36.36,0,0,1-.32-.18.38.38,0,0,1,.13-.52l9.86-5.68a.37.37,0,0,1,.37.65l-9.85,5.68A.34.34,0,0,1,156.62,168.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,163.62a.36.36,0,0,1-.32-.18.38.38,0,0,1,.13-.52l9.86-5.68a.37.37,0,0,1,.51.13.39.39,0,0,1-.14.52l-9.85,5.68A.34.34,0,0,1,156.62,163.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.62,158.93a.38.38,0,0,1-.19-.7l9.86-5.68a.37.37,0,0,1,.51.13.39.39,0,0,1-.14.52l-9.85,5.68A.34.34,0,0,1,156.62,158.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199,192.87s.07,0,.11,0a.18.18,0,0,1,0,.14v.31a.48.48,0,0,1,0,.2.37.37,0,0,1-.11.13l-1.07.62v5.13a.49.49,0,0,1,0,.19.24.24,0,0,1-.11.13l-.23.14a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.14v-5.13l-1.07.62a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.14v-.32a.45.45,0,0,1,0-.19.25.25,0,0,1,.11-.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,194.86a4.94,4.94,0,0,1,.11-1,4.07,4.07,0,0,1,.31-.93,3.37,3.37,0,0,1,.49-.79,2.32,2.32,0,0,1,.67-.58,1.16,1.16,0,0,1,.66-.19.72.72,0,0,1,.49.22,1.28,1.28,0,0,1,.31.58,3.23,3.23,0,0,1,.11.87q0,.77,0,1.56a5.58,5.58,0,0,1-.12,1,4.6,4.6,0,0,1-.3.93,3.57,3.57,0,0,1-.49.8,2.56,2.56,0,0,1-.66.57,1.32,1.32,0,0,1-.67.2.75.75,0,0,1-.49-.23,1.42,1.42,0,0,1-.3-.59,2.79,2.79,0,0,1-.12-.86Q199.47,195.66,199.48,194.86Zm2.61-1.47a2.94,2.94,0,0,0-.09-.67.81.81,0,0,0-.21-.38.5.5,0,0,0-.33-.12.85.85,0,0,0-.4.13,1.65,1.65,0,0,0-.41.34,1.91,1.91,0,0,0-.33.49,2.83,2.83,0,0,0-.21.64,3.07,3.07,0,0,0-.09.77c0,.27,0,.51,0,.74s0,.48,0,.74a2.13,2.13,0,0,0,.09.67.81.81,0,0,0,.21.38.48.48,0,0,0,.33.12.84.84,0,0,0,.41-.14,1.53,1.53,0,0,0,.4-.33,2.21,2.21,0,0,0,.33-.49,2.83,2.83,0,0,0,.21-.64,4.4,4.4,0,0,0,.09-.77c0-.27,0-.51,0-.74S202.1,193.65,202.09,193.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57,190.85v1.39a5.31,5.31,0,0,1-.13,1.07,4.43,4.43,0,0,1-.33.95,3.7,3.7,0,0,1-.5.76,2.48,2.48,0,0,1-.65.53l-1.34.78a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.14V190.5a.48.48,0,0,1,0-.2.29.29,0,0,1,.11-.13l1.31-.75a1.43,1.43,0,0,1,.65-.22.74.74,0,0,1,.52.17,1.22,1.22,0,0,1,.34.56A3.33,3.33,0,0,1,206.57,190.85Zm-.54.36a3.17,3.17,0,0,0-.07-.57.91.91,0,0,0-.19-.42.48.48,0,0,0-.34-.16.93.93,0,0,0-.52.16l-.9.52v4.57l.92-.53a1.87,1.87,0,0,0,.52-.44,2.46,2.46,0,0,0,.34-.56,3.38,3.38,0,0,0,.18-.62c0-.22.05-.44.06-.65v-1.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.76,191.39l-2,1.15-.3,1.34a.94.94,0,0,1-.06.18.37.37,0,0,1-.16.17l-.21.12s-.07,0-.09,0a.12.12,0,0,1,0-.11.5.5,0,0,1,0-.14l1.4-6.36a1,1,0,0,1,.08-.24.48.48,0,0,1,.17-.2l.35-.19c.07,0,.13,0,.17,0a.71.71,0,0,1,.08.15l1.4,4.74a.65.65,0,0,1,0,.11.29.29,0,0,1,0,.16.2.2,0,0,1-.09.11l-.21.12c-.07.05-.13.05-.16,0a.24.24,0,0,1-.06-.11Zm-1.78.24,1.58-.91-.79-2.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.41,191a.45.45,0,0,1,0,.19.24.24,0,0,1-.11.13l-.23.14a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.14v-2.06l-1.36-2.75a.3.3,0,0,1,0-.11.32.32,0,0,1,0-.16.2.2,0,0,1,.09-.11l.24-.14c.08,0,.13-.05.17,0a.26.26,0,0,1,.07.1l1,2.19,1.06-3.41a1,1,0,0,1,.08-.19.31.31,0,0,1,.16-.16l.25-.15a.06.06,0,0,1,.08,0s0,.06,0,.12a.53.53,0,0,1,0,.13L212.41,189Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.88,211.92a4.2,4.2,0,0,0,.31-.76,2.88,2.88,0,0,0,.11-.83,1.26,1.26,0,0,0-.22-.81c-.14-.17-.36-.16-.67,0a1.55,1.55,0,0,0-.41.35,2,2,0,0,0-.28.45,4,4,0,0,0-.18.52c0,.19-.07.37-.1.56a1.42,1.42,0,0,1-.07.22.33.33,0,0,1-.11.12l-.32.18a.08.08,0,0,1-.1,0,.2.2,0,0,1-.05-.14,4.67,4.67,0,0,1,.12-.86,4.48,4.48,0,0,1,.32-.91,3.67,3.67,0,0,1,.5-.83,2.43,2.43,0,0,1,.68-.61,1.27,1.27,0,0,1,.67-.2.71.71,0,0,1,.48.21,1.36,1.36,0,0,1,.29.55,3.28,3.28,0,0,1,.1.82,4.26,4.26,0,0,1,0,.63,4.34,4.34,0,0,1-.11.59,5.14,5.14,0,0,1-.2.59c-.08.21-.19.42-.3.65l-1.53,3.08,2.09-1.21a.09.09,0,0,1,.13,0,.21.21,0,0,1,.06.17v.38a.49.49,0,0,1-.06.23.31.31,0,0,1-.13.16l-3,1.71a.1.1,0,0,1-.13,0,.22.22,0,0,1-.06-.17v-.38a.78.78,0,0,1,0-.22,1.41,1.41,0,0,1,.12-.27Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,212.62a1.33,1.33,0,0,0,.1.28.39.39,0,0,0,.18.2.57.57,0,0,0,.33,0,2,2,0,0,0,.52-.22,2.4,2.4,0,0,0,.41-.32,1.64,1.64,0,0,0,.33-.44,2.06,2.06,0,0,0,.23-.55,2.2,2.2,0,0,0,.09-.64,1.48,1.48,0,0,0-.08-.53.44.44,0,0,0-.23-.25.51.51,0,0,0-.33,0,2.41,2.41,0,0,0-.42.18l-.57.33a.09.09,0,0,1-.13,0,.25.25,0,0,1-.05-.17v-.38a.43.43,0,0,1,0-.19,1.07,1.07,0,0,1,.07-.19L174,207l-2,1.14a.09.09,0,0,1-.13,0,.21.21,0,0,1-.06-.17v-.38a.53.53,0,0,1,.06-.23.31.31,0,0,1,.13-.16l2.7-1.56a.1.1,0,0,1,.13,0,.22.22,0,0,1,.05.17v.38a.88.88,0,0,1,0,.21,1.28,1.28,0,0,1-.09.22l-1.21,2.72a1.4,1.4,0,0,1,.62-.2.69.69,0,0,1,.49.15,1,1,0,0,1,.32.49,2.78,2.78,0,0,1,.11.83,4.09,4.09,0,0,1-.14,1,4.72,4.72,0,0,1-.36.93,4.21,4.21,0,0,1-.55.76,2.79,2.79,0,0,1-.66.54,2.08,2.08,0,0,1-.79.29.82.82,0,0,1-.55-.12.84.84,0,0,1-.32-.41,1.71,1.71,0,0,1-.11-.62.46.46,0,0,1,0-.19.36.36,0,0,1,.11-.13l.31-.18q.08,0,.12,0A.23.23,0,0,1,172.31,212.62Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.54,210.69a.1.1,0,0,1,.13,0,.24.24,0,0,1,.06.17v.71a.46.46,0,0,1-.06.23.36.36,0,0,1-.13.16l-.46.27a.1.1,0,0,1-.13,0,.22.22,0,0,1,0-.17v-.71a.5.5,0,0,1,0-.23.36.36,0,0,1,.13-.16Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53,209.29a3.93,3.93,0,0,1,.17-1.1,4.31,4.31,0,0,1,.49-1,.94.94,0,0,1-.39-.46,1.91,1.91,0,0,1-.14-.8,3.37,3.37,0,0,1,.12-.87,4,4,0,0,1,.83-1.59,2.86,2.86,0,0,1,.64-.53,1.31,1.31,0,0,1,.63-.2.85.85,0,0,1,.51.15,1.06,1.06,0,0,1,.34.47,2,2,0,0,1,.12.73,3.2,3.2,0,0,1-.15,1,4.71,4.71,0,0,1-.39.92.93.93,0,0,1,.48.48,2,2,0,0,1,.18.9,3.3,3.3,0,0,1-.13.92,4.18,4.18,0,0,1-.35.91,4.45,4.45,0,0,1-.55.79,2.62,2.62,0,0,1-.69.57,1.37,1.37,0,0,1-.69.23.85.85,0,0,1-.55-.16,1.14,1.14,0,0,1-.36-.5A2.24,2.24,0,0,1,177.53,209.29Zm.65-.37a1.15,1.15,0,0,0,.08.44.54.54,0,0,0,.22.27.58.58,0,0,0,.33.08,1,1,0,0,0,.44-.16,2,2,0,0,0,.43-.34,2.55,2.55,0,0,0,.34-.47,2.62,2.62,0,0,0,.22-.52,2,2,0,0,0,.08-.54,1.15,1.15,0,0,0-.08-.44A.51.51,0,0,0,180,207a.54.54,0,0,0-.34-.08,1,1,0,0,0-.43.15,2.12,2.12,0,0,0-.44.35,2.49,2.49,0,0,0-.33.47,2,2,0,0,0-.22.52A2,2,0,0,0,178.18,208.92Zm.13-3.4a.94.94,0,0,0,.07.39.54.54,0,0,0,.2.24.58.58,0,0,0,.3.07.87.87,0,0,0,.37-.13,1.48,1.48,0,0,0,.37-.3,2.26,2.26,0,0,0,.3-.41,2.14,2.14,0,0,0,.2-.47,1.69,1.69,0,0,0,.07-.48,1,1,0,0,0-.07-.4.46.46,0,0,0-.5-.3,1,1,0,0,0-.37.12,1.53,1.53,0,0,0-.37.31,2.06,2.06,0,0,0-.3.41,2.22,2.22,0,0,0-.2.47A1.59,1.59,0,0,0,178.31,205.52Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.26,202.35c0,.31,0,.61,0,.88s0,.58,0,.9a6.89,6.89,0,0,1-.11,1.21,5.32,5.32,0,0,1-.32,1.11,3.65,3.65,0,0,1-.54.92,2.65,2.65,0,0,1-.78.67,1.31,1.31,0,0,1-.77.23.75.75,0,0,1-.54-.3,1.88,1.88,0,0,1-.32-.74,4.92,4.92,0,0,1-.11-1.08c0-.31,0-.61,0-.89s0-.58,0-.89a7,7,0,0,1,.11-1.22,5.4,5.4,0,0,1,.32-1.1,3.9,3.9,0,0,1,.54-.93,2.64,2.64,0,0,1,.77-.68,1.31,1.31,0,0,1,.78-.22.79.79,0,0,1,.54.31,1.82,1.82,0,0,1,.32.74A4.92,4.92,0,0,1,185.26,202.35Zm-2.85,3.43a2.22,2.22,0,0,0,.29,1.31q.28.32.81,0a2,2,0,0,0,.82-.94,4.4,4.4,0,0,0,.29-1.65v-1.78a2.28,2.28,0,0,0-.29-1.32c-.19-.21-.46-.21-.82,0a2,2,0,0,0-.81,1,4.48,4.48,0,0,0-.29,1.65c0,.32,0,.62,0,.9S182.4,205.46,182.41,205.78Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,198.48c.32-.18.57-.19.73,0a1.45,1.45,0,0,1,.27.89v.88a3.39,3.39,0,0,1-.27,1.2,1.7,1.7,0,0,1-.73.83c-.33.19-.57.2-.74,0a1.39,1.39,0,0,1-.26-.89,2,2,0,0,1,0-.23,1.21,1.21,0,0,1,0-.19,1.41,1.41,0,0,1,0-.2,2.54,2.54,0,0,1,0-.26,3.28,3.28,0,0,1,.26-1.21A1.79,1.79,0,0,1,187,198.48Zm2.77-1.34a1,1,0,0,1,.1-.21.35.35,0,0,1,.14-.13l.26-.15s.09,0,.12,0a.17.17,0,0,1,.05.13.18.18,0,0,1,0,.06.19.19,0,0,1,0,.07L187,205.71a1,1,0,0,1-.1.21.35.35,0,0,1-.14.13l-.26.15c-.05,0-.09,0-.12,0a.14.14,0,0,1-.05-.12.13.13,0,0,1,0-.06.19.19,0,0,1,0-.07Zm-2.3,2.57a.93.93,0,0,0-.12-.45c-.08-.1-.19-.11-.35,0a.83.83,0,0,0-.35.43,1.69,1.69,0,0,0-.13.59,1.55,1.55,0,0,1,0,.23v.34a1.63,1.63,0,0,1,0,.24.77.77,0,0,0,.13.44c.07.1.19.11.35,0a.83.83,0,0,0,.35-.41,1.94,1.94,0,0,0,.12-.59c0-.1,0-.18,0-.24v-.35C187.48,199.87,187.47,199.8,187.47,199.71Zm2.37.83c.33-.19.57-.19.74,0a1.4,1.4,0,0,1,.26.9,2.18,2.18,0,0,1,0,.25v.39a2,2,0,0,1,0,.23,3.18,3.18,0,0,1-.26,1.2,1.79,1.79,0,0,1-.74.84c-.32.18-.57.19-.73,0a1.33,1.33,0,0,1-.27-.89c0-.09,0-.17,0-.23v-.39c0-.07,0-.16,0-.26a3,3,0,0,1,.27-1.2A1.68,1.68,0,0,1,189.84,200.54Zm.47,1.22a.7.7,0,0,0-.12-.44c-.07-.11-.19-.12-.35,0a.82.82,0,0,0-.35.42,2.65,2.65,0,0,0-.13.82c0,.06,0,.12,0,.17s0,.11,0,.17a2.18,2.18,0,0,0,0,.24.85.85,0,0,0,.12.44c.08.1.19.11.35,0a.85.85,0,0,0,.35-.42,1.48,1.48,0,0,0,.12-.59,2.27,2.27,0,0,0,0-.24V202A1.94,1.94,0,0,0,190.31,201.76Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.62 220.34 160.2 214.15 163.77 216.21 156.62 220.34",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.78,241.53a.41.41,0,0,1,0,.19.33.33,0,0,1-.11.14l-.24.13a.07.07,0,0,1-.1,0,.17.17,0,0,1,0-.14v-2.05L156.87,237a.52.52,0,0,1,0-.11.5.5,0,0,1,0-.16.3.3,0,0,1,.09-.1l.25-.15c.07,0,.13,0,.16,0a.31.31,0,0,1,.08.11l1,2.19,1.06-3.41c0-.06,0-.13.07-.2a.44.44,0,0,1,.17-.16l.24-.14s.07,0,.09,0a.16.16,0,0,1,0,.12.5.5,0,0,1,0,.14l-1.37,4.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,235.53a1.08,1.08,0,0,1,.55-.17.67.67,0,0,1,.41.16,1.17,1.17,0,0,1,.27.47,2.46,2.46,0,0,1,.12.72,1,1,0,0,1,0,.19v.46a1,1,0,0,1,0,.18,6.08,6.08,0,0,1-.12.87,4.09,4.09,0,0,1-.27.77,3.18,3.18,0,0,1-.41.64,2.17,2.17,0,0,1-.55.46,1,1,0,0,1-.55.17.56.56,0,0,1-.41-.16.94.94,0,0,1-.27-.46,2.47,2.47,0,0,1-.12-.73.81.81,0,0,1,0-.17,2.65,2.65,0,0,1,0-.46,1.09,1.09,0,0,1,0-.19,4.15,4.15,0,0,1,.12-.87,3.27,3.27,0,0,1,.27-.78A3,3,0,0,1,161,236,2,2,0,0,1,161.51,235.53Zm.83,2.26c0-.1,0-.22,0-.37s0-.26,0-.36a1.93,1.93,0,0,0-.07-.45.82.82,0,0,0-.16-.31.39.39,0,0,0-.25-.12.67.67,0,0,0-.35.11,1.43,1.43,0,0,0-.35.3,1.87,1.87,0,0,0-.25.41,2.46,2.46,0,0,0-.16.48,5,5,0,0,0-.08.54c0,.11,0,.24,0,.38s0,.26,0,.36a2.6,2.6,0,0,0,.08.45.71.71,0,0,0,.16.3.39.39,0,0,0,.25.12.65.65,0,0,0,.35-.1,1.43,1.43,0,0,0,.35-.3,1.87,1.87,0,0,0,.25-.41,2.35,2.35,0,0,0,.16-.49A3.06,3.06,0,0,0,162.34,237.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.56,234.67a.45.45,0,0,1,.05-.19.28.28,0,0,1,.1-.13l.22-.12s.07,0,.1,0a.2.2,0,0,1,.05.14v2.33a1.39,1.39,0,0,0,.2.89c.13.15.32.15.57,0a1.44,1.44,0,0,0,.57-.66,2.91,2.91,0,0,0,.2-1.14v-2.32a.45.45,0,0,1,0-.19.25.25,0,0,1,.11-.13L166,233a.09.09,0,0,1,.11,0,.2.2,0,0,1,0,.14v4.1a.48.48,0,0,1,0,.2.36.36,0,0,1-.11.13l-.21.12a.09.09,0,0,1-.11,0,.18.18,0,0,1,0-.14v-.27a2.81,2.81,0,0,1-.31.59,1.53,1.53,0,0,1-.54.5,1,1,0,0,1-.5.15.58.58,0,0,1-.38-.17,1,1,0,0,1-.24-.47,2.88,2.88,0,0,1-.09-.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.51,231.58a.09.09,0,0,1,.11,0,.18.18,0,0,1,0,.14V232a.43.43,0,0,1,0,.19.33.33,0,0,1-.11.14l-.33.19a1.45,1.45,0,0,0-.66,1.39v2.57a.45.45,0,0,1-.05.19.21.21,0,0,1-.11.13l-.21.13a.08.08,0,0,1-.1,0,.2.2,0,0,1-.05-.14v-4.1a.49.49,0,0,1,.05-.2.34.34,0,0,1,.1-.13l.21-.12a.08.08,0,0,1,.11,0,.18.18,0,0,1,.05.14v.27a2.56,2.56,0,0,1,.27-.55,1.48,1.48,0,0,1,.42-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.88,231c0,.27,0,.51,0,.74s0,.48,0,.74a1.56,1.56,0,0,0,.29,1q.27.3.78,0a1.87,1.87,0,0,0,.46-.37,2.3,2.3,0,0,0,.5-.94,4.42,4.42,0,0,0,.1-.5.49.49,0,0,1,.06-.17.22.22,0,0,1,.09-.1l.26-.16a.07.07,0,0,1,.09,0,.16.16,0,0,1,0,.11,4,4,0,0,1-.1.69,4.33,4.33,0,0,1-.28.81,3.84,3.84,0,0,1-.49.79,2.77,2.77,0,0,1-.73.63,1.27,1.27,0,0,1-.67.2.78.78,0,0,1-.5-.21,1.4,1.4,0,0,1-.32-.57,3.17,3.17,0,0,1-.12-.88q0-.77,0-1.56a5.08,5.08,0,0,1,.12-1,5.47,5.47,0,0,1,.32-.94,3.85,3.85,0,0,1,.5-.78,2.57,2.57,0,0,1,.67-.57,1.39,1.39,0,0,1,.73-.22.78.78,0,0,1,.49.23,1.27,1.27,0,0,1,.28.48,2.35,2.35,0,0,1,.1.58.53.53,0,0,1,0,.16.22.22,0,0,1-.09.1l-.26.15a.1.1,0,0,1-.09,0s0,0-.06-.11a2.11,2.11,0,0,0-.1-.38.55.55,0,0,0-.19-.27.46.46,0,0,0-.31-.1,1,1,0,0,0-.46.16,1.9,1.9,0,0,0-.78.91A3.43,3.43,0,0,0,170.88,231Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.45,227.48a1.19,1.19,0,0,1,.55-.17.65.65,0,0,1,.41.16,1.17,1.17,0,0,1,.27.47,2.46,2.46,0,0,1,.12.72,1.09,1.09,0,0,1,0,.19v.46a1,1,0,0,1,0,.18,5.71,5.71,0,0,1-.12.87,4.09,4.09,0,0,1-.27.77,2.8,2.8,0,0,1-.41.64,2,2,0,0,1-.55.46,1.14,1.14,0,0,1-.55.18.61.61,0,0,1-.41-.17,1,1,0,0,1-.27-.46,2.47,2.47,0,0,1-.12-.73.81.81,0,0,1,0-.17,1.69,1.69,0,0,1,0-.23,1.77,1.77,0,0,1,0-.23,1.09,1.09,0,0,1,0-.19,4.15,4.15,0,0,1,.12-.87,3.77,3.77,0,0,1,.27-.78,3,3,0,0,1,.41-.63A2.05,2.05,0,0,1,175.45,227.48Zm.83,2.27c0-.11,0-.23,0-.37a3.57,3.57,0,0,0,0-.37,1.93,1.93,0,0,0-.07-.45.82.82,0,0,0-.16-.31.34.34,0,0,0-.25-.11.57.57,0,0,0-.35.1,1.43,1.43,0,0,0-.35.3,1.87,1.87,0,0,0-.25.41,2.35,2.35,0,0,0-.16.49,4.51,4.51,0,0,0-.08.53c0,.11,0,.24,0,.38s0,.26,0,.36a2.6,2.6,0,0,0,.08.45.71.71,0,0,0,.16.3.35.35,0,0,0,.25.12.65.65,0,0,0,.35-.1,1.43,1.43,0,0,0,.35-.3,1.87,1.87,0,0,0,.25-.41,2.35,2.35,0,0,0,.16-.49A3.07,3.07,0,0,0,176.28,229.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,225.11a.49.49,0,0,1-.05.19.29.29,0,0,1-.11.13l-.32.19s-.08,0-.11,0a.18.18,0,0,1-.05-.14V225a.45.45,0,0,1,.05-.19.27.27,0,0,1,.11-.14l.32-.18a.08.08,0,0,1,.11,0,.2.2,0,0,1,.05.14Zm-.06,5.3a.45.45,0,0,1-.05.19.21.21,0,0,1-.11.13l-.21.13a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.14v-4.1a.41.41,0,0,1,0-.19.33.33,0,0,1,.11-.14l.21-.12c.05,0,.08,0,.11,0a.18.18,0,0,1,.05.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.55,228.39a.45.45,0,0,1-.05.19.33.33,0,0,1-.11.14l-.21.12a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.14v-2.32a1.26,1.26,0,0,0-.22-.89c-.14-.14-.33-.14-.58,0a1.43,1.43,0,0,0-.58.67,2.61,2.61,0,0,0-.22,1.14v2.32a.49.49,0,0,1-.05.2.29.29,0,0,1-.11.13l-.21.12a.08.08,0,0,1-.11,0,.18.18,0,0,1,0-.14v-4.1a.43.43,0,0,1,0-.19.29.29,0,0,1,.11-.13l.21-.12a.08.08,0,0,1,.11,0,.2.2,0,0,1,.05.14v.28a2.52,2.52,0,0,1,.32-.6,1.62,1.62,0,0,1,.56-.51.87.87,0,0,1,.5-.15.53.53,0,0,1,.39.16,1,1,0,0,1,.25.47,2.51,2.51,0,0,1,.1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,225.91a.41.41,0,0,0-.05-.25.23.23,0,0,0-.18-.08,1.17,1.17,0,0,0-.31,0l-.43.1c-.31.08-.53,0-.65-.12a1.16,1.16,0,0,1-.19-.71,2.67,2.67,0,0,1,.07-.54,3,3,0,0,1,.21-.54,2.27,2.27,0,0,1,.34-.49,2,2,0,0,1,.49-.38,1.39,1.39,0,0,1,.49-.19.64.64,0,0,1,.35,0,.48.48,0,0,1,.22.2.54.54,0,0,1,.08.28.41.41,0,0,1,0,.19.34.34,0,0,1-.11.14l-.19.11-.09,0s-.06,0-.08-.05a.3.3,0,0,0-.22-.12.73.73,0,0,0-.41.13,1.34,1.34,0,0,0-.42.4.88.88,0,0,0-.17.5.49.49,0,0,0,0,.25.2.2,0,0,0,.15.09.9.9,0,0,0,.27,0l.42-.1a1.15,1.15,0,0,1,.44,0,.58.58,0,0,1,.29.15.62.62,0,0,1,.15.29,1.62,1.62,0,0,1,.05.4,1.87,1.87,0,0,1-.09.56,2.35,2.35,0,0,1-.23.57,3.14,3.14,0,0,1-.38.52,2.15,2.15,0,0,1-.5.4,1.17,1.17,0,0,1-.5.18.88.88,0,0,1-.37,0,.5.5,0,0,1-.23-.2.52.52,0,0,1-.09-.29.33.33,0,0,1,0-.19.4.4,0,0,1,.11-.14l.21-.12.08,0s.06,0,.08.05a.32.32,0,0,0,.25.16.76.76,0,0,0,.42-.14,1.1,1.1,0,0,0,.25-.19,1.7,1.7,0,0,0,.22-.24,1.51,1.51,0,0,0,.15-.28A.68.68,0,0,0,184.06,225.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.41,182.92a2.38,2.38,0,0,1-1.23-.32,3.18,3.18,0,0,1-1.36-2.93,9.4,9.4,0,0,1,4.25-7.35,2.81,2.81,0,0,1,4.58,2.64,9.4,9.4,0,0,1-4.25,7.36A4,4,0,0,1,260.41,182.92Zm3.65-10.53a3.4,3.4,0,0,0-1.66.51,8.66,8.66,0,0,0-3.91,6.77,2.17,2.17,0,0,0,3.58,2.07A8.69,8.69,0,0,0,266,175a2.57,2.57,0,0,0-1-2.35A1.75,1.75,0,0,0,264.06,172.39Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.6,178.61a.33.33,0,0,1-.17-.62l3.28-1.89a.32.32,0,0,1,.45.12.33.33,0,0,1-.12.46l-3.28,1.89A.32.32,0,0,1,260.6,178.61Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.24,179.56a.34.34,0,0,1-.34-.34v-3.78a.34.34,0,0,1,.67,0v3.78A.34.34,0,0,1,262.24,179.56Z",
    style: {
      fill: "#508C9B"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--info-box--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.84,288.16v-31.4a5.81,5.81,0,0,1,2.64-4.56l108.74-62.65c1.45-.84,2.63-.16,2.63,1.52v31.4a5.83,5.83,0,0,1-2.63,4.56L154.48,289.68C153,290.52,151.84,289.84,151.84,288.16Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,290.44V259a5.83,5.83,0,0,1,2.63-4.56l108.74-62.65c1.46-.84,2.64-.16,2.64,1.52v31.4a5.81,5.81,0,0,1-2.64,4.56L158.54,292C157.09,292.8,155.91,292.12,155.91,290.44Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,290.44V259a5.83,5.83,0,0,1,2.63-4.56l108.74-62.65c1.46-.84,2.64-.16,2.64,1.52v31.4a5.81,5.81,0,0,1-2.64,4.56L158.54,292C157.09,292.8,155.91,292.12,155.91,290.44Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,281a5.68,5.68,0,0,1-2.84-.74c-2.39-1.39-3.77-4.58-3.77-8.76,0-7.84,4.79-17,10.68-20.38,2.62-1.51,5.16-1.71,7.15-.56,2.4,1.39,3.78,4.58,3.78,8.76,0,7.83-4.79,17-10.68,20.38A8.78,8.78,0,0,1,168,281Zm8.39-30.68a8.3,8.3,0,0,0-4.07,1.23c-5.75,3.32-10.43,12.27-10.43,20,0,4,1.28,7,3.52,8.32,1.84,1.06,4.2.86,6.66-.56,5.75-3.32,10.43-12.26,10.43-19.94,0-4-1.29-7-3.53-8.32A5.07,5.07,0,0,0,176.35,250.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,276.72a.24.24,0,0,1-.25-.25v-2.6l-2.5,1.45a.28.28,0,0,1-.25,0,.26.26,0,0,1-.13-.22v-2.23a.26.26,0,0,1,.13-.22l1.41-.81v-8.7l-1.16.68a.28.28,0,0,1-.25,0,.26.26,0,0,1-.13-.22v-2.23a.26.26,0,0,1,.13-.22l2.75-1.59v-3a.27.27,0,0,1,.12-.22l1.68-1a.25.25,0,0,1,.37.22v2.75l.81-.47v-3a.27.27,0,0,1,.12-.22l1.68-1a.25.25,0,0,1,.37.22v2.77a1.7,1.7,0,0,1,1.53,0,2.44,2.44,0,0,1,1,2.19,6.39,6.39,0,0,1-.74,2.83,7.68,7.68,0,0,1-.62,1,1.59,1.59,0,0,1,1.12.19,2.65,2.65,0,0,1,1.06,2.41,6.89,6.89,0,0,1-.82,3.12,5.58,5.58,0,0,1-2,2.27l-.49.28v2.88a.27.27,0,0,1-.12.22l-1.68,1a.25.25,0,0,1-.37-.22v-2.6l-.81.47v2.88a.27.27,0,0,1-.12.22l-1.68,1Zm0-3.53a.19.19,0,0,1,.12,0,.23.23,0,0,1,.13.21V276l1.17-.68v-2.89a.24.24,0,0,1,.13-.21l1.3-.76a.28.28,0,0,1,.25,0,.26.26,0,0,1,.13.22v2.6l1.17-.68v-2.89a.23.23,0,0,1,.13-.21l.61-.35a5.14,5.14,0,0,0,1.82-2.07,6.43,6.43,0,0,0,.76-2.89,2.19,2.19,0,0,0-.81-2,1.5,1.5,0,0,0-1.52.14h0l-.56.32a.25.25,0,0,1-.25-.43h0a4.6,4.6,0,0,0,1.62-1.85,5.68,5.68,0,0,0,.69-2.6,1.92,1.92,0,0,0-.72-1.75,1.32,1.32,0,0,0-1.35.12l-.05,0a.28.28,0,0,1-.25,0,.26.26,0,0,1-.13-.22v-2.75l-1.17.68v3a.23.23,0,0,1-.13.21l-1.3.76a.28.28,0,0,1-.25,0,.26.26,0,0,1-.13-.22V256l-1.17.68v3a.23.23,0,0,1-.13.21l-2.75,1.59v1.66l1.17-.68a.28.28,0,0,1,.25,0,.25.25,0,0,1,.12.22V272a.25.25,0,0,1-.12.22l-1.42.82v1.65l2.5-1.44A.2.2,0,0,1,170,273.19Zm1.67-2.7a.27.27,0,0,1-.12,0,.25.25,0,0,1-.13-.22v-3.87a.25.25,0,0,1,.13-.22l1.52-.88a1.17,1.17,0,0,1,1.2-.08,1.53,1.53,0,0,1,.63,1.39,3.88,3.88,0,0,1-.45,1.74h0a3.19,3.19,0,0,1-1.13,1.26l-1.52.88A.28.28,0,0,1,171.65,270.49Zm.25-4v3.3l1.15-.66a2.62,2.62,0,0,0,.93-1.07,3.24,3.24,0,0,0,.4-1.5,1,1,0,0,0-.38-.95.7.7,0,0,0-.7.07Zm2.31,1.69Zm-2.56-3.82-.12,0a.26.26,0,0,1-.13-.22V261a.23.23,0,0,1,.13-.21l1.79-1a1,1,0,0,1,1-.06,1.27,1.27,0,0,1,.53,1.17,3.24,3.24,0,0,1-.37,1.44h0a2.6,2.6,0,0,1-.94,1l-1.79,1A.28.28,0,0,1,171.65,264.38Zm.25-3.26v2.58l1.42-.82a2.17,2.17,0,0,0,.74-.85h0a2.6,2.6,0,0,0,.32-1.2.86.86,0,0,0-.28-.74.56.56,0,0,0-.53.06Zm2.38,1h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,249.61c0,1.3,1,1.79,2.17,1.1l28.16-16.26a4.64,4.64,0,0,0,2.17-3.6c0-1.3-1-1.79-2.17-1.1L193,246A4.64,4.64,0,0,0,190.8,249.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,257.18a.47.47,0,0,0,.25-.07l32.5-18.76a.5.5,0,0,0,.18-.68.51.51,0,0,0-.68-.19l-32.5,18.77a.5.5,0,0,0,.25.93Zm41-19.51a.51.51,0,0,0-.68-.19l-40.62,23.46a.5.5,0,0,0,.25.93.47.47,0,0,0,.25-.07l40.62-23.45A.49.49,0,0,0,231.85,237.67Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,222.48a.83.83,0,0,1,.46,0,.7.7,0,0,1,.34.18.89.89,0,0,1,.21.32.94.94,0,0,1,.08.36.39.39,0,0,1,0,.14c0,.05,0,.09-.09.1l-.21.13a.14.14,0,0,1-.1,0s0,0-.07-.1a.89.89,0,0,0-.09-.16.46.46,0,0,0-.16-.15.49.49,0,0,0-.25-.06.78.78,0,0,0-.35.11,1.42,1.42,0,0,0-.28.22,1.76,1.76,0,0,0-.24.3,1.49,1.49,0,0,0-.17.36,1.41,1.41,0,0,0-.07.41.67.67,0,0,0,.06.32.35.35,0,0,0,.2.16.93.93,0,0,0,.34,0,4.07,4.07,0,0,0,.51-.07,1.82,1.82,0,0,1,.51,0,.59.59,0,0,1,.54.44,1.88,1.88,0,0,1,.06.51,2.52,2.52,0,0,1-.09.67,3.25,3.25,0,0,1-.24.64,3,3,0,0,1-.38.57,3.11,3.11,0,0,1-.49.47v.53a.41.41,0,0,1,0,.18.2.2,0,0,1-.1.12l-.21.12a.07.07,0,0,1-.1,0,.17.17,0,0,1-.05-.13v-.55a.84.84,0,0,1-.46,0,.73.73,0,0,1-.59-.46,1,1,0,0,1-.09-.41.4.4,0,0,1,0-.15.21.21,0,0,1,.08-.1l.22-.13s.07,0,.09,0,.05,0,.08.11a.82.82,0,0,0,.09.19.65.65,0,0,0,.18.15.48.48,0,0,0,.27,0,.86.86,0,0,0,.38-.13,1.73,1.73,0,0,0,.35-.27,2.6,2.6,0,0,0,.3-.36,2.22,2.22,0,0,0,.2-.41,1.25,1.25,0,0,0,.07-.43.52.52,0,0,0-.08-.31.4.4,0,0,0-.25-.13,1.26,1.26,0,0,0-.39,0l-.52.08a1.15,1.15,0,0,1-.45,0,.54.54,0,0,1-.3-.18.65.65,0,0,1-.17-.33,2.31,2.31,0,0,1,0-.49,2.91,2.91,0,0,1,.06-.57,4.36,4.36,0,0,1,.19-.58,2.48,2.48,0,0,1,.32-.54,2.08,2.08,0,0,1,.44-.45v-.54a.41.41,0,0,1,.05-.18.27.27,0,0,1,.1-.13l.21-.12a.07.07,0,0,1,.1,0,.2.2,0,0,1,0,.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.25,226.15a.34.34,0,0,1,0,.18.24.24,0,0,1-.1.13l-.22.12a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-4.51l-.86,1.51a.23.23,0,0,1-.11.11.08.08,0,0,1-.09,0l-.13-.18a.28.28,0,0,1,0-.15.64.64,0,0,1,.06-.18l1.13-2a.53.53,0,0,1,.09-.11l.08,0,.22-.13a.08.08,0,0,1,.1,0s0,.07,0,.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,224.24a.54.54,0,0,0,.31.44.62.62,0,0,0,.54-.09,2.5,2.5,0,0,0,.33-.26,2,2,0,0,0,.44-.86,2,2,0,0,0,.07-.55,1.28,1.28,0,0,0-.07-.48.46.46,0,0,0-.18-.27.38.38,0,0,0-.26-.07.74.74,0,0,0-.33.12,1.23,1.23,0,0,0-.32.25,2.07,2.07,0,0,0-.2.27l-.14.22a.41.41,0,0,1-.14.15l-.27.16a.06.06,0,0,1-.08,0,.13.13,0,0,1,0-.1l.16-2.82a.58.58,0,0,1,0-.18.36.36,0,0,1,.11-.13l1.87-1.08a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.29a.39.39,0,0,1,0,.18.34.34,0,0,1-.1.13l-1.54.89-.09,1.46a1.94,1.94,0,0,1,.25-.27,1.8,1.8,0,0,1,.39-.29,1.22,1.22,0,0,1,.52-.17.65.65,0,0,1,.43.14.93.93,0,0,1,.29.43,2.31,2.31,0,0,1,.1.75,3.46,3.46,0,0,1-.39,1.63,2.91,2.91,0,0,1-.43.63,2.24,2.24,0,0,1-.52.43,1.12,1.12,0,0,1-.51.18.65.65,0,0,1-.42-.08.63.63,0,0,1-.3-.32,1.51,1.51,0,0,1-.12-.57.42.42,0,0,1,0-.15.27.27,0,0,1,.08-.1l.24-.14h.09A.15.15,0,0,1,240.37,224.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.15,223.46a.86.86,0,0,1,.07-.25.41.41,0,0,1,.16-.2l.31-.18a.08.08,0,0,1,.08,0,.16.16,0,0,1,0,.11s0,0,0,.06l-.28,1.25a.65.65,0,0,1-.07.21.34.34,0,0,1-.15.18l-.14.08a.05.05,0,0,1-.08,0,.13.13,0,0,1,0-.1v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,219.45a3.05,3.05,0,0,0,.24-.59,2.43,2.43,0,0,0,.08-.64,1,1,0,0,0-.17-.63c-.11-.13-.28-.13-.52,0a1.3,1.3,0,0,0-.31.26,1.59,1.59,0,0,0-.22.35,2.83,2.83,0,0,0-.14.41c0,.14-.06.28-.08.43a.84.84,0,0,1-.05.17.19.19,0,0,1-.09.09l-.24.14a.06.06,0,0,1-.08,0,.12.12,0,0,1,0-.11,3.35,3.35,0,0,1,.09-.66,3.75,3.75,0,0,1,.25-.71,2.81,2.81,0,0,1,.39-.64,1.92,1.92,0,0,1,.52-.47,1.1,1.1,0,0,1,.52-.16.56.56,0,0,1,.37.17,1,1,0,0,1,.23.42,2.43,2.43,0,0,1,.07.63c0,.18,0,.34,0,.49a3.4,3.4,0,0,1-.09.46,3.16,3.16,0,0,1-.16.46,4.38,4.38,0,0,1-.23.5l-1.19,2.39,1.63-.94a.08.08,0,0,1,.1,0s0,.07,0,.13v.29a.39.39,0,0,1,0,.18.25.25,0,0,1-.1.12l-2.29,1.32a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-.3a.51.51,0,0,1,0-.17.81.81,0,0,1,.09-.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.05,220.5a.39.39,0,0,1,0,.18.25.25,0,0,1-.1.12l-.22.13a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-4.5l-.86,1.5a.19.19,0,0,1-.11.11.08.08,0,0,1-.09,0l-.13-.18a.26.26,0,0,1,0-.14.35.35,0,0,1,.06-.18l1.13-2a.3.3,0,0,1,.09-.1.21.21,0,0,1,.08-.06l.22-.13a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.48,215.19c0,.25,0,.48,0,.69s0,.45,0,.69a4.91,4.91,0,0,1-.09.94,3.89,3.89,0,0,1-.24.86,3,3,0,0,1-.42.71,2.13,2.13,0,0,1-.6.52,1,1,0,0,1-.6.18.61.61,0,0,1-.42-.24,1.38,1.38,0,0,1-.25-.57,4.9,4.9,0,0,1-.09-.83v-1.38a7.3,7.3,0,0,1,.09-.94,4.53,4.53,0,0,1,.25-.86,3.23,3.23,0,0,1,.42-.72,1.88,1.88,0,0,1,.6-.52,1,1,0,0,1,.6-.17.61.61,0,0,1,.42.24,1.31,1.31,0,0,1,.24.57A3.46,3.46,0,0,1,252.48,215.19Zm-2.21,2.66a1.63,1.63,0,0,0,.23,1c.14.16.35.17.63,0a1.62,1.62,0,0,0,.63-.73,3.51,3.51,0,0,0,.22-1.28c0-.25,0-.48,0-.69s0-.44,0-.69a1.78,1.78,0,0,0-.22-1q-.22-.24-.63,0a1.43,1.43,0,0,0-.63.73,3.29,3.29,0,0,0-.23,1.28v1.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.56,217.13a.08.08,0,0,1,.1,0s0,.07,0,.13v.54a.39.39,0,0,1,0,.18.34.34,0,0,1-.1.13l-.36.2a.09.09,0,0,1-.1,0,.18.18,0,0,1,0-.14v-.54a.39.39,0,0,1,0-.18.34.34,0,0,1,.1-.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.76,215.94a.56.56,0,0,0,.3.43.64.64,0,0,0,.55-.09,1.52,1.52,0,0,0,.32-.26,1.46,1.46,0,0,0,.27-.38,1.76,1.76,0,0,0,.18-.47,2,2,0,0,0,.07-.56,1.28,1.28,0,0,0-.07-.48.5.5,0,0,0-.18-.27.39.39,0,0,0-.27-.06.72.72,0,0,0-.32.11,1.12,1.12,0,0,0-.33.26,1.88,1.88,0,0,0-.19.26l-.14.22a.41.41,0,0,1-.14.15l-.27.16a.06.06,0,0,1-.08,0,.14.14,0,0,1,0-.11l.16-2.82a.58.58,0,0,1,0-.18.26.26,0,0,1,.11-.12l1.87-1.09a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.3a.39.39,0,0,1,0,.18.25.25,0,0,1-.1.12l-1.55.89-.08,1.46a2.74,2.74,0,0,1,.25-.27,1.78,1.78,0,0,1,.39-.28,1,1,0,0,1,.52-.17.6.6,0,0,1,.43.13.92.92,0,0,1,.29.44,2.2,2.2,0,0,1,.1.74,3.44,3.44,0,0,1-.1.86,3.81,3.81,0,0,1-.29.78,3.1,3.1,0,0,1-.43.62,2.3,2.3,0,0,1-.52.44,1.23,1.23,0,0,1-.51.17.69.69,0,0,1-.43-.07.73.73,0,0,1-.29-.33,1.51,1.51,0,0,1-.12-.57.23.23,0,0,1,0-.14.17.17,0,0,1,.08-.1l.24-.14a.1.1,0,0,1,.09,0A.19.19,0,0,1,254.76,215.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.22,210.72c0,.25,0,.48,0,.69s0,.45,0,.69a4.91,4.91,0,0,1-.09.94,3.89,3.89,0,0,1-.24.86,3,3,0,0,1-.42.71,2.13,2.13,0,0,1-.6.52,1,1,0,0,1-.6.18.63.63,0,0,1-.42-.23,1.49,1.49,0,0,1-.25-.58,4.1,4.1,0,0,1-.08-.83c0-.25,0-.48,0-.69s0-.45,0-.69a5.86,5.86,0,0,1,.08-.94,4.53,4.53,0,0,1,.25-.86,3.23,3.23,0,0,1,.42-.72,2.15,2.15,0,0,1,.6-.52,1,1,0,0,1,.6-.17.61.61,0,0,1,.42.24,1.31,1.31,0,0,1,.24.57A3.46,3.46,0,0,1,260.22,210.72Zm-2.2,2.66a1.64,1.64,0,0,0,.22,1c.14.16.35.17.63,0a1.56,1.56,0,0,0,.63-.73,3.31,3.31,0,0,0,.22-1.28c0-.24,0-.48,0-.69s0-.44,0-.69a1.7,1.7,0,0,0-.22-1c-.15-.16-.35-.16-.63,0a1.47,1.47,0,0,0-.63.73A3.31,3.31,0,0,0,258,212c0,.25,0,.48,0,.69S258,213.14,258,213.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,227.43v1.19a.31.31,0,0,1,0,.13c0,.05,0,.08-.07.09l-.15.09a.06.06,0,0,1-.07,0,.13.13,0,0,1,0-.1v-1.19l-.77.44a0,0,0,0,1-.07,0,.15.15,0,0,1,0-.1v-.19a.35.35,0,0,1,0-.13.35.35,0,0,1,.07-.09l.77-.44v-1.18a.35.35,0,0,1,0-.13.22.22,0,0,1,.07-.09l.15-.08s.05,0,.07,0a.15.15,0,0,1,0,.1v1.18l.77-.45a.06.06,0,0,1,.07,0,.1.1,0,0,1,0,.09v.19a.22.22,0,0,1,0,.13c0,.05,0,.08-.07.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.59,225l.07-.07.07,0a.83.83,0,0,1,.4-.12.57.57,0,0,1,.32.12.76.76,0,0,1,.21.34,1.64,1.64,0,0,1,.08.53,2.55,2.55,0,0,1-.08.61,2.66,2.66,0,0,1-.21.58,2.07,2.07,0,0,1-.32.49,1.62,1.62,0,0,1-.4.35.86.86,0,0,1-.4.12.45.45,0,0,1-.32-.12.76.76,0,0,1-.21-.34,1.41,1.41,0,0,1-.08-.53c0-.11,0-.23,0-.34s0-.21.07-.32l.09-.3c0-.1.07-.2.1-.29l.71-2,0-.1a.16.16,0,0,1,.07-.09l.23-.13a0,0,0,0,1,.05,0,.11.11,0,0,1,0,.08v.06l0,0Zm-.5,1.7a1.08,1.08,0,0,0,0,.32.54.54,0,0,0,.13.21.34.34,0,0,0,.2.09.63.63,0,0,0,.27-.08A1.18,1.18,0,0,0,250,227a2.49,2.49,0,0,0,.2-.32,2.17,2.17,0,0,0,.12-.36,1.64,1.64,0,0,0,.05-.37,1,1,0,0,0-.05-.31.51.51,0,0,0-.12-.22.32.32,0,0,0-.2-.08.49.49,0,0,0-.27.07,1.18,1.18,0,0,0-.27.23,1.55,1.55,0,0,0-.2.32,2.6,2.6,0,0,0-.13.36A1.61,1.61,0,0,0,249.09,226.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,226.15s0,0-.07,0a.15.15,0,0,1,0-.1v-.83l-1.23.71a.06.06,0,0,1-.07,0,.12.12,0,0,1,0-.09v-.22a.49.49,0,0,1,0-.11.56.56,0,0,1,0-.12l1.23-3.2a.91.91,0,0,1,.07-.14.26.26,0,0,1,.09-.09l.15-.09a.06.06,0,0,1,.08,0,.15.15,0,0,1,0,.1v2.51l.33-.2a.08.08,0,0,1,.08,0,.13.13,0,0,1,0,.1v.21a.28.28,0,0,1,0,.13.15.15,0,0,1-.08.09l-.33.2v.83a.35.35,0,0,1,0,.13.36.36,0,0,1-.08.09Zm-.1-1.47V223l-.85,2.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.78,224.35a.75.75,0,0,0,.05.16.2.2,0,0,0,.11.11.26.26,0,0,0,.18,0,.84.84,0,0,0,.3-.12,1.3,1.3,0,0,0,.23-.18,1.18,1.18,0,0,0,.19-.25,1.2,1.2,0,0,0,.13-.31,1.14,1.14,0,0,0,.05-.37.8.8,0,0,0,0-.3.3.3,0,0,0-.13-.14.25.25,0,0,0-.19,0,1.12,1.12,0,0,0-.24.1l-.32.19a.08.08,0,0,1-.08,0,.13.13,0,0,1,0-.1v-.21a.43.43,0,0,1,0-.11.76.76,0,0,0,0-.11l.71-1.57-1.13.65a0,0,0,0,1-.07,0,.15.15,0,0,1,0-.1v-.22a.35.35,0,0,1,0-.13.35.35,0,0,1,.07-.09l1.54-.89a.06.06,0,0,1,.07,0,.13.13,0,0,1,0,.1v.21a.49.49,0,0,1,0,.12,1.39,1.39,0,0,1-.06.13l-.68,1.54a.74.74,0,0,1,.35-.11.39.39,0,0,1,.28.08.85.85,0,0,1,.18.28,1.63,1.63,0,0,1,.06.47,2,2,0,0,1-.08.6,2.25,2.25,0,0,1-.21.53,1.84,1.84,0,0,1-.3.43,1.79,1.79,0,0,1-.38.31,1.07,1.07,0,0,1-.45.16.51.51,0,0,1-.31-.06.55.55,0,0,1-.18-.24,1,1,0,0,1-.07-.35.26.26,0,0,1,0-.11.11.11,0,0,1,.06-.07l.18-.1s0,0,.07,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.18,223.25a.08.08,0,0,1,.08,0,.12.12,0,0,1,0,.09v.41a.35.35,0,0,1,0,.13.24.24,0,0,1-.08.09l-.26.15s0,0-.07,0a.17.17,0,0,1,0-.1v-.4a.28.28,0,0,1,0-.13.2.2,0,0,1,.07-.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,222.46a2.29,2.29,0,0,1,.1-.62,2.73,2.73,0,0,1,.28-.6.52.52,0,0,1-.22-.26,1.17,1.17,0,0,1-.08-.45,1.77,1.77,0,0,1,.07-.5,1.66,1.66,0,0,1,.19-.48,2.36,2.36,0,0,1,.28-.42,1.69,1.69,0,0,1,.36-.3.78.78,0,0,1,.36-.11.41.41,0,0,1,.29.08.55.55,0,0,1,.19.27,1,1,0,0,1,.07.41,2.15,2.15,0,0,1-.08.55,2.42,2.42,0,0,1-.23.52.56.56,0,0,1,.28.27,1.13,1.13,0,0,1,.1.51,2,2,0,0,1-.07.53,3.28,3.28,0,0,1-.2.52,2.88,2.88,0,0,1-.31.44,1.53,1.53,0,0,1-.4.33.82.82,0,0,1-.39.13.54.54,0,0,1-.31-.09.58.58,0,0,1-.2-.28A1.25,1.25,0,0,1,256.74,222.46Zm.37-.21a.62.62,0,0,0,.05.25.31.31,0,0,0,.12.15.33.33,0,0,0,.2,0,.72.72,0,0,0,.24-.09,1.16,1.16,0,0,0,.25-.2,1.57,1.57,0,0,0,.19-.26,1.25,1.25,0,0,0,.12-.3.79.79,0,0,0,.05-.3.53.53,0,0,0-.05-.26.26.26,0,0,0-.12-.15.3.3,0,0,0-.19,0,.52.52,0,0,0-.25.08,1.16,1.16,0,0,0-.24.2,1.35,1.35,0,0,0-.2.27,1.48,1.48,0,0,0-.12.29A1.18,1.18,0,0,0,257.11,222.25Zm.08-1.93a.51.51,0,0,0,0,.22.31.31,0,0,0,.11.14.32.32,0,0,0,.17,0,.35.35,0,0,0,.21-.07.68.68,0,0,0,.21-.17,1.3,1.3,0,0,0,.18-.23c0-.09.08-.18.11-.27a.88.88,0,0,0,0-.27.53.53,0,0,0,0-.23.29.29,0,0,0-.11-.13.34.34,0,0,0-.18,0,.52.52,0,0,0-.21.07,1.57,1.57,0,0,0-.21.17,2.07,2.07,0,0,0-.17.24,1.19,1.19,0,0,0-.11.26A1,1,0,0,0,257.19,220.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.26,221.46a.28.28,0,0,1,0,.13s0,.08-.07.09l-.16.1a.08.08,0,0,1-.08,0,.12.12,0,0,1,0-.09v-3.31l-.63,1.1c0,.05-.05.08-.08.08a.05.05,0,0,1-.07,0l-.09-.13a.12.12,0,0,1,0-.11.33.33,0,0,1,0-.13l.83-1.46s0-.07.07-.08l.06,0,.16-.1a.06.06,0,0,1,.07,0,.13.13,0,0,1,0,.1Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--info-box--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.84,335v-31.4a5.83,5.83,0,0,1,2.64-4.57l108.74-62.65c1.45-.83,2.63-.15,2.63,1.52v31.41a5.83,5.83,0,0,1-2.63,4.56L154.48,336.56C153,337.4,151.84,336.72,151.84,335Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,337.32v-31.4a5.84,5.84,0,0,1,2.63-4.57L267.28,238.7c1.46-.84,2.64-.15,2.64,1.52v31.41a5.81,5.81,0,0,1-2.64,4.56L158.54,338.84C157.09,339.68,155.91,339,155.91,337.32Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,337.32v-31.4a5.84,5.84,0,0,1,2.63-4.57L267.28,238.7c1.46-.84,2.64-.15,2.64,1.52v31.41a5.81,5.81,0,0,1-2.64,4.56L158.54,338.84C157.09,339.68,155.91,339,155.91,337.32Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,327.84a5.68,5.68,0,0,1-2.84-.74c-2.39-1.39-3.77-4.58-3.77-8.75,0-7.84,4.79-17,10.68-20.39,2.62-1.51,5.16-1.7,7.15-.55,2.4,1.38,3.78,4.57,3.78,8.75,0,7.84-4.79,17-10.68,20.38A8.78,8.78,0,0,1,168,327.84Zm8.39-30.67a8.2,8.2,0,0,0-4.07,1.23c-5.75,3.32-10.43,12.27-10.43,20,0,4,1.28,7,3.52,8.31,1.84,1.06,4.2.87,6.66-.55,5.75-3.32,10.43-12.27,10.43-19.95,0-4-1.29-7-3.53-8.32A5.07,5.07,0,0,0,176.35,297.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.15,315.62h0l-4.62-.72a.23.23,0,0,1-.18-.12.26.26,0,0,1,0-.21l4.62-12.51a.25.25,0,0,1,.28-.16.24.24,0,0,1,.2.25v13.22a.24.24,0,0,1-.08.19A.27.27,0,0,1,172.15,315.62Zm-4.27-1.16,4,.62V303.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54,314.91a.27.27,0,0,1-.17-.06.26.26,0,0,1,0-.36l4.61-5.4a.25.25,0,0,1,.36,0,.25.25,0,0,1,0,.35l-4.61,5.41A.25.25,0,0,1,167.54,314.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.15,322.68a.26.26,0,0,1-.2-.1L167.33,316a.26.26,0,0,1,0-.3.27.27,0,0,1,.28-.09l4.61,1.55a.25.25,0,0,1,.17.24v5a.25.25,0,0,1-.17.24Zm-4-6.36,3.72,5.32v-4.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.15,315.62h-.08a.26.26,0,0,1-.17-.24V302.15a.27.27,0,0,1,.18-.25.26.26,0,0,1,.28.11l4.62,7.18a.26.26,0,0,1,0,.29l-4.62,6A.23.23,0,0,1,172.15,315.62ZM172.4,303v11.63l4.07-5.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.77,309.57h0l-4.62-.07a.26.26,0,0,1-.25-.26.26.26,0,0,1,.25-.24h0l4.62.07a.26.26,0,0,1,.24.26A.24.24,0,0,1,176.77,309.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.15,322.68h0a.26.26,0,0,1-.21-.25v-5a.24.24,0,0,1,0-.14l4.61-6.88a.25.25,0,0,1,.33-.08.26.26,0,0,1,.12.31l-4.62,11.92A.25.25,0,0,1,172.15,322.68Zm.25-5.22v3.63l3.33-8.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,296.49c0,1.29,1,1.78,2.17,1.09l28.16-16.26a4.64,4.64,0,0,0,2.17-3.59c0-1.3-1-1.79-2.17-1.1L193,292.89A4.64,4.64,0,0,0,190.8,296.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,304.05a.57.57,0,0,0,.25-.06l32.5-18.77a.5.5,0,0,0-.5-.86l-32.5,18.76a.5.5,0,0,0,.25.93Zm41-19.51a.49.49,0,0,0-.68-.18l-40.62,23.45a.5.5,0,0,0,.25.93.57.57,0,0,0,.25-.06l40.62-23.46A.49.49,0,0,0,231.85,284.54Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.49,268.5a.83.83,0,0,1,.46,0,.7.7,0,0,1,.34.18.89.89,0,0,1,.21.32.94.94,0,0,1,.08.36.3.3,0,0,1-.12.25l-.21.12a.13.13,0,0,1-.1,0s0,0-.07-.1a.89.89,0,0,0-.09-.16.46.46,0,0,0-.16-.15.49.49,0,0,0-.25-.06.78.78,0,0,0-.35.11,1.42,1.42,0,0,0-.28.22,1.76,1.76,0,0,0-.24.3,1.49,1.49,0,0,0-.17.36,1.14,1.14,0,0,0-.07.41.75.75,0,0,0,.06.33.35.35,0,0,0,.2.15,1.17,1.17,0,0,0,.34,0l.51-.07a1.54,1.54,0,0,1,.51,0,.69.69,0,0,1,.34.13.68.68,0,0,1,.2.32,1.75,1.75,0,0,1,.06.5,2.52,2.52,0,0,1-.09.67,3.25,3.25,0,0,1-.24.64,3,3,0,0,1-.38.57,3.11,3.11,0,0,1-.49.47v.53a.41.41,0,0,1-.05.18.2.2,0,0,1-.1.12l-.21.13a.09.09,0,0,1-.11,0,.22.22,0,0,1,0-.13v-.55a1,1,0,0,1-.46.06.85.85,0,0,1-.36-.16.72.72,0,0,1-.23-.31,1,1,0,0,1-.09-.41.4.4,0,0,1,0-.15.21.21,0,0,1,.08-.1l.22-.13a.18.18,0,0,1,.09,0s.05,0,.08.11a.82.82,0,0,0,.09.19.65.65,0,0,0,.18.15.48.48,0,0,0,.27,0,.86.86,0,0,0,.38-.13,1.73,1.73,0,0,0,.35-.27,2.6,2.6,0,0,0,.3-.36,2.22,2.22,0,0,0,.2-.41,1.25,1.25,0,0,0,.07-.43.52.52,0,0,0-.08-.31.4.4,0,0,0-.25-.13,1.26,1.26,0,0,0-.39,0l-.52.08a1.15,1.15,0,0,1-.45,0,.58.58,0,0,1-.3-.18.65.65,0,0,1-.17-.33,2.31,2.31,0,0,1-.05-.49,2.91,2.91,0,0,1,.06-.57,4.36,4.36,0,0,1,.19-.58,2.48,2.48,0,0,1,.32-.54,2.08,2.08,0,0,1,.44-.45v-.54a.58.58,0,0,1,0-.18.36.36,0,0,1,.11-.13l.21-.12s.08,0,.1,0a.16.16,0,0,1,.05.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.62,271.55a.56.56,0,0,0,.3.44.61.61,0,0,0,.54-.09,1.64,1.64,0,0,0,.33-.26,2.16,2.16,0,0,0,.27-.38,1.71,1.71,0,0,0,.18-.48,2.43,2.43,0,0,0,.07-.55,1.52,1.52,0,0,0-.07-.48.46.46,0,0,0-.18-.27.42.42,0,0,0-.27-.07.83.83,0,0,0-.33.12,1.42,1.42,0,0,0-.32.25,1.93,1.93,0,0,0-.19.27l-.14.22a.41.41,0,0,1-.14.15l-.27.16s-.06,0-.09,0a.13.13,0,0,1,0-.1l.16-2.82a.39.39,0,0,1,0-.18.34.34,0,0,1,.1-.13l1.87-1.08a.09.09,0,0,1,.11,0,.22.22,0,0,1,0,.13v.29a.58.58,0,0,1,0,.18.36.36,0,0,1-.11.13l-1.54.89-.08,1.46a2.6,2.6,0,0,1,.24-.27,2.47,2.47,0,0,1,.39-.29,1.31,1.31,0,0,1,.53-.17.67.67,0,0,1,.43.14.92.92,0,0,1,.28.43,2,2,0,0,1,.11.75,3.07,3.07,0,0,1-.11.86,3.5,3.5,0,0,1-.28.77,3.32,3.32,0,0,1-.43.63,2.09,2.09,0,0,1-.53.43,1.05,1.05,0,0,1-.5.18.68.68,0,0,1-.43-.08.65.65,0,0,1-.29-.32,1.2,1.2,0,0,1-.12-.57.28.28,0,0,1,0-.15.27.27,0,0,1,.08-.1l.24-.14h.08S239.61,271.5,239.62,271.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.4,270.77a.86.86,0,0,1,.07-.25.36.36,0,0,1,.16-.2l.3-.17a.07.07,0,0,1,.09,0,.16.16,0,0,1,0,.11v.06l-.28,1.25a1,1,0,0,1-.07.21.35.35,0,0,1-.16.18l-.13.08a.06.06,0,0,1-.08,0,.14.14,0,0,1,0-.11v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.42,269.69a.09.09,0,0,1-.1,0,.2.2,0,0,1,0-.14v-1.12l-1.66,1a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13V269a.86.86,0,0,1,0-.15.85.85,0,0,1,.06-.17l1.68-4.35a.53.53,0,0,1,.09-.2.32.32,0,0,1,.11-.12l.22-.12a.08.08,0,0,1,.1,0,.2.2,0,0,1,0,.13v3.41l.45-.26a.09.09,0,0,1,.11,0,.25.25,0,0,1,0,.13v.3a.58.58,0,0,1,0,.18.26.26,0,0,1-.11.12l-.45.27v1.12a.58.58,0,0,1,0,.18.49.49,0,0,1-.1.13Zm-.15-2v-2.3l-1.15,3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.27,267.13a.54.54,0,0,0,.31.44.62.62,0,0,0,.54-.09,2,2,0,0,0,.33-.26,2.16,2.16,0,0,0,.27-.38,2.67,2.67,0,0,0,.18-.48,2.44,2.44,0,0,0,.06-.55,1.56,1.56,0,0,0-.06-.48.58.58,0,0,0-.18-.27.42.42,0,0,0-.27-.07.78.78,0,0,0-.33.12,1.23,1.23,0,0,0-.32.25,2.07,2.07,0,0,0-.2.27l-.14.22a.34.34,0,0,1-.14.15l-.27.16a.05.05,0,0,1-.08,0,.13.13,0,0,1,0-.1l.16-2.82a.41.41,0,0,1,0-.18.34.34,0,0,1,.1-.13l1.87-1.08a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.29a.39.39,0,0,1,0,.18.34.34,0,0,1-.1.13l-1.54.89-.09,1.46a1.94,1.94,0,0,1,.25-.27,1.8,1.8,0,0,1,.39-.29,1.27,1.27,0,0,1,.52-.17.64.64,0,0,1,.43.14.93.93,0,0,1,.29.43,2.28,2.28,0,0,1,.11.75,3.63,3.63,0,0,1-.4,1.63,2.59,2.59,0,0,1-.43.63,2.05,2.05,0,0,1-.52.43,1.12,1.12,0,0,1-.51.18.72.72,0,0,1-.42-.07.81.81,0,0,1-.3-.33,1.35,1.35,0,0,1-.11-.57.4.4,0,0,1,0-.15.27.27,0,0,1,.08-.1l.25-.14h.08S247.26,267.08,247.27,267.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.73,261.92c0,.25,0,.47,0,.69s0,.45,0,.69a5.86,5.86,0,0,1-.08.94,4.53,4.53,0,0,1-.25.86,3,3,0,0,1-.42.71,1.88,1.88,0,0,1-.6.52,1,1,0,0,1-.6.18.61.61,0,0,1-.42-.24,1.31,1.31,0,0,1-.24-.57,3.49,3.49,0,0,1-.09-.84c0-.24,0-.47,0-.68s0-.45,0-.7a4.81,4.81,0,0,1,.09-.93,3.89,3.89,0,0,1,.24-.86,3.23,3.23,0,0,1,.42-.72,2.13,2.13,0,0,1,.6-.52,1,1,0,0,1,.6-.17.63.63,0,0,1,.42.23,1.49,1.49,0,0,1,.25.58A4.1,4.1,0,0,1,252.73,261.92Zm-2.2,2.66a1.64,1.64,0,0,0,.22,1c.15.16.36.16.63,0a1.49,1.49,0,0,0,.63-.74,3.39,3.39,0,0,0,.23-1.27v-1.38a1.76,1.76,0,0,0-.23-1c-.14-.16-.35-.17-.63,0a1.6,1.6,0,0,0-.63.74,3.31,3.31,0,0,0-.22,1.28c0,.24,0,.47,0,.69S250.52,264.33,250.53,264.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.81,263.86a.08.08,0,0,1,.1,0,.2.2,0,0,1,0,.14v.54a.39.39,0,0,1,0,.18.34.34,0,0,1-.1.13l-.35.2a.09.09,0,0,1-.11,0,.2.2,0,0,1,0-.13v-.54a.58.58,0,0,1,0-.18.29.29,0,0,1,.11-.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.22,260.45a3.4,3.4,0,0,0,.23-.59,2,2,0,0,0,.08-.64,1,1,0,0,0-.16-.63c-.11-.13-.28-.12-.52,0a1.39,1.39,0,0,0-.32.27,1.36,1.36,0,0,0-.21.35,1.9,1.9,0,0,0-.14.4c0,.15-.06.29-.08.43a.38.38,0,0,1-.06.17.29.29,0,0,1-.08.1l-.25.14a.05.05,0,0,1-.08,0,.13.13,0,0,1,0-.1,2.82,2.82,0,0,1,.09-.67,3.62,3.62,0,0,1,.24-.7,3.77,3.77,0,0,1,.39-.64,1.8,1.8,0,0,1,.53-.47,1,1,0,0,1,.51-.16.57.57,0,0,1,.38.16,1,1,0,0,1,.22.43,2.35,2.35,0,0,1,.08.63,3.68,3.68,0,0,1,0,.49,2.39,2.39,0,0,1-.09.45,4.26,4.26,0,0,1-.15.47c-.07.15-.14.32-.24.5l-1.18,2.38,1.62-.94a.11.11,0,0,1,.11,0,.22.22,0,0,1,0,.13v.3a.58.58,0,0,1,0,.18.26.26,0,0,1-.11.12l-2.28,1.32a.08.08,0,0,1-.1,0,.16.16,0,0,1-.05-.13v-.29a.47.47,0,0,1,0-.17,1.65,1.65,0,0,1,.09-.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.8,258.15l.09-.08.1-.07a1.16,1.16,0,0,1,.55-.17.71.71,0,0,1,.44.17,1.09,1.09,0,0,1,.28.46,2.2,2.2,0,0,1,.1.72,3.42,3.42,0,0,1-.1.83,4.11,4.11,0,0,1-.28.79,3.53,3.53,0,0,1-.44.67,2.19,2.19,0,0,1-.55.47,1,1,0,0,1-.55.16.65.65,0,0,1-.43-.16,1,1,0,0,1-.29-.46,2.2,2.2,0,0,1-.1-.72,3.33,3.33,0,0,1,.12-.9c0-.14.08-.27.13-.41l.13-.39,1-2.75a.81.81,0,0,0,.06-.13.18.18,0,0,1,.1-.12l.31-.18s.05,0,.07,0a.16.16,0,0,1,0,.11.15.15,0,0,1,0,.07s0,0,0,.05Zm-.68,2.32a1.4,1.4,0,0,0,.06.43.74.74,0,0,0,.17.29.42.42,0,0,0,.28.12.62.62,0,0,0,.36-.11,1.32,1.32,0,0,0,.36-.31,2.12,2.12,0,0,0,.28-.43,2.84,2.84,0,0,0,.17-.49,2.2,2.2,0,0,0,.06-.5,1.35,1.35,0,0,0-.06-.43.79.79,0,0,0-.17-.3.41.41,0,0,0-.28-.11.62.62,0,0,0-.36.11,1.17,1.17,0,0,0-.36.31,2.12,2.12,0,0,0-.28.43,2.84,2.84,0,0,0-.17.49A2.2,2.2,0,0,0,258.12,260.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.39,273.23s0,0-.07,0a.13.13,0,0,1,0-.1v-.19a.31.31,0,0,1,0-.13c0-.05,0-.08.07-.09l1.15-.67a.08.08,0,0,1,.08,0,.12.12,0,0,1,0,.09v.2a.35.35,0,0,1,0,.13.24.24,0,0,1-.08.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.12,273a.31.31,0,0,1,0,.13.15.15,0,0,1-.08.09l-.16.09s0,0-.07,0a.13.13,0,0,1,0-.1V270l-.63,1.1c0,.05-.05.07-.08.08a.06.06,0,0,1-.07,0l-.1-.13a.31.31,0,0,1,0-.11.65.65,0,0,1,0-.13l.84-1.47a.22.22,0,0,1,.06-.07l.06-.05.16-.09a.08.08,0,0,1,.08,0,.12.12,0,0,1,0,.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.62,271.72a2,2,0,0,1,.1-.62,2,2,0,0,1,.27-.6.52.52,0,0,1-.22-.26,1.17,1.17,0,0,1-.08-.45,1.77,1.77,0,0,1,.07-.5,2.53,2.53,0,0,1,.19-.48,2,2,0,0,1,.28-.42,1.59,1.59,0,0,1,.36-.3A.88.88,0,0,1,254,268a.45.45,0,0,1,.28.09.51.51,0,0,1,.19.26,1.09,1.09,0,0,1,.07.42,1.79,1.79,0,0,1-.08.55,2.66,2.66,0,0,1-.23.52.52.52,0,0,1,.28.27,1.13,1.13,0,0,1,.1.51,2,2,0,0,1-.07.53,2.25,2.25,0,0,1-.2.51,2.11,2.11,0,0,1-.31.45,1.38,1.38,0,0,1-.4.33.94.94,0,0,1-.39.13.54.54,0,0,1-.31-.09.71.71,0,0,1-.2-.29A1.16,1.16,0,0,1,252.62,271.72Zm.37-.21a.62.62,0,0,0,0,.25.28.28,0,0,0,.13.15.28.28,0,0,0,.19,0,.52.52,0,0,0,.24-.08,1,1,0,0,0,.25-.2,1,1,0,0,0,.19-.27,1.08,1.08,0,0,0,.13-.29,1.1,1.1,0,0,0,0-.31.62.62,0,0,0,0-.25.28.28,0,0,0-.13-.15.24.24,0,0,0-.19,0,.56.56,0,0,0-.25.08.91.91,0,0,0-.24.2,1.15,1.15,0,0,0-.19.26,1.3,1.3,0,0,0-.13.3A1.1,1.1,0,0,0,253,271.51Zm.07-1.94a.53.53,0,0,0,0,.23.26.26,0,0,0,.12.13.29.29,0,0,0,.17,0,.44.44,0,0,0,.2-.07.87.87,0,0,0,.22-.17,2.07,2.07,0,0,0,.17-.24,1.19,1.19,0,0,0,.11-.26,1,1,0,0,0,0-.28.51.51,0,0,0,0-.22.31.31,0,0,0-.11-.14.32.32,0,0,0-.17,0,.51.51,0,0,0-.22.07.79.79,0,0,0-.2.17.91.91,0,0,0-.17.23,1.59,1.59,0,0,0-.12.27A.84.84,0,0,0,253.06,269.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,270.58a.06.06,0,0,1,.07,0,.12.12,0,0,1,0,.09v.41a.35.35,0,0,1,0,.13.35.35,0,0,1-.07.09l-.27.15a0,0,0,0,1-.07,0,.12.12,0,0,1,0-.09V271a.29.29,0,0,1,.1-.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25,270.24a.06.06,0,0,1-.07,0s0-.05,0-.09v-.83l-1.23.71a.06.06,0,0,1-.07,0,.13.13,0,0,1,0-.1v-.21a.49.49,0,0,1,0-.11.93.93,0,0,1,0-.13l1.23-3.19a1.07,1.07,0,0,1,.07-.15.15.15,0,0,1,.08-.08l.16-.09s0,0,.07,0a.13.13,0,0,1,0,.1v2.51l.33-.2a.06.06,0,0,1,.07,0,.13.13,0,0,1,0,.09v.22a.33.33,0,0,1,0,.13s0,.08-.07.09l-.33.2v.82a.37.37,0,0,1,0,.14.22.22,0,0,1-.07.09Zm-.1-1.47v-1.69l-.85,2.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.31,265.87v1a3.93,3.93,0,0,1-.06.69,2.9,2.9,0,0,1-.19.63,2,2,0,0,1-.3.52,1.33,1.33,0,0,1-.44.38.73.73,0,0,1-.45.13.39.39,0,0,1-.3-.17,1,1,0,0,1-.18-.42,2.69,2.69,0,0,1-.07-.61v-1a3.84,3.84,0,0,1,.07-.69,2.9,2.9,0,0,1,.18-.63,2.28,2.28,0,0,1,.3-.53,1.5,1.5,0,0,1,.45-.38.77.77,0,0,1,.44-.13.42.42,0,0,1,.3.17,1.16,1.16,0,0,1,.19.42A2.9,2.9,0,0,1,260.31,265.87Zm-1.62,1.95a1.24,1.24,0,0,0,.16.74c.11.12.26.12.47,0a1.17,1.17,0,0,0,.46-.54,2.45,2.45,0,0,0,.16-.94c0-.18,0-.35,0-.51s0-.32,0-.5a1.25,1.25,0,0,0-.16-.75c-.11-.12-.26-.12-.46,0a1.07,1.07,0,0,0-.47.53,2.52,2.52,0,0,0-.16.94c0,.19,0,.36,0,.51S258.69,267.64,258.69,267.82Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--info-box--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.84,381.91v-31.4a5.81,5.81,0,0,1,2.64-4.56L263.22,283.3c1.45-.84,2.63-.16,2.63,1.52v31.4a5.83,5.83,0,0,1-2.63,4.56L154.48,383.43C153,384.27,151.84,383.59,151.84,381.91Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,384.19v-31.4a5.83,5.83,0,0,1,2.63-4.56l108.74-62.65c1.46-.84,2.64-.16,2.64,1.52v31.4a5.81,5.81,0,0,1-2.64,4.56L158.54,385.71C157.09,386.55,155.91,385.87,155.91,384.19Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,384.19v-31.4a5.83,5.83,0,0,1,2.63-4.56l108.74-62.65c1.46-.84,2.64-.16,2.64,1.52v31.4a5.81,5.81,0,0,1-2.64,4.56L158.54,385.71C157.09,386.55,155.91,385.87,155.91,384.19Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.44,368.4a1.83,1.83,0,0,1-.92-.24,3,3,0,0,1-1.21-2.75,7.32,7.32,0,0,1,.42-2.37.06.06,0,0,1,0,0,2.63,2.63,0,0,0,.16-.9,1,1,0,0,0-.33-.85.6.6,0,0,0-.61.07,2.56,2.56,0,0,0-1,1.4l0,0a7,7,0,0,1-2.81,3.76,2.23,2.23,0,0,1-2.29.16,3,3,0,0,1-1.21-2.75,7.8,7.8,0,0,1,3.25-6.19,2.06,2.06,0,0,1,3,.58v0h0a.54.54,0,0,0,.81.13,2.92,2.92,0,0,0,1.19-2.31,1.33,1.33,0,0,0-.14-.65.08.08,0,0,1,0-.05,4,4,0,0,1-.43-1.92,7.8,7.8,0,0,1,3.25-6.2,2.24,2.24,0,0,1,2.3-.16,3,3,0,0,1,1.21,2.74,7.78,7.78,0,0,1-3.26,6.2h0l0,0a2.93,2.93,0,0,0-1.16,2.29,1,1,0,0,0,.33.85.63.63,0,0,0,.61-.06l.13.21-.13-.22a2.24,2.24,0,0,1,2.3-.16,3,3,0,0,1,1.21,2.75,7.75,7.75,0,0,1-3.26,6.19A2.76,2.76,0,0,1,173.44,368.4Zm-1.21-5.28a.09.09,0,0,0,0,.05,6.82,6.82,0,0,0-.41,2.24,2.55,2.55,0,0,0,1,2.31,1.76,1.76,0,0,0,1.79-.16,7.23,7.23,0,0,0,3-5.76,2.57,2.57,0,0,0-1-2.32,1.78,1.78,0,0,0-1.8.17h0a1.07,1.07,0,0,1-1.11.06,1.4,1.4,0,0,1-.58-1.28,3.39,3.39,0,0,1,1.44-2.74,7.23,7.23,0,0,0,3-5.77,2.55,2.55,0,0,0-1-2.31,1.8,1.8,0,0,0-1.8.16,7.27,7.27,0,0,0-3,5.77,3.36,3.36,0,0,0,.39,1.71s0,0,0,.06a1.78,1.78,0,0,1,.18.85A3.37,3.37,0,0,1,171,358.9a1,1,0,0,1-1.49-.31v0l0,0c-.47-.79-1.35-.94-2.34-.38a7.25,7.25,0,0,0-3,5.76,2.55,2.55,0,0,0,1,2.32,1.77,1.77,0,0,0,1.79-.17,6.58,6.58,0,0,0,2.58-3.46l0-.05h0a3.18,3.18,0,0,1,1.26-1.68,1.09,1.09,0,0,1,1.11-.07,1.42,1.42,0,0,1,.58,1.29A3.35,3.35,0,0,1,172.23,363.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,374.72a5.68,5.68,0,0,1-2.84-.74c-2.39-1.39-3.77-4.58-3.77-8.76,0-7.84,4.79-17,10.68-20.38,2.62-1.51,5.16-1.71,7.15-.56,2.4,1.39,3.78,4.58,3.78,8.76,0,7.83-4.79,17-10.68,20.38A8.78,8.78,0,0,1,168,374.72ZM176.35,344a8.3,8.3,0,0,0-4.07,1.23c-5.75,3.32-10.43,12.27-10.43,20,0,4,1.28,7,3.52,8.32,1.84,1.06,4.2.86,6.66-.56,5.75-3.32,10.43-12.26,10.43-19.94,0-4-1.29-7-3.53-8.32A5.07,5.07,0,0,0,176.35,344Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,343.36c0,1.3,1,1.79,2.17,1.1l28.16-16.26a4.64,4.64,0,0,0,2.17-3.6c0-1.3-1-1.79-2.17-1.1L193,339.77A4.64,4.64,0,0,0,190.8,343.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,350.93a.47.47,0,0,0,.25-.07l32.5-18.76a.5.5,0,0,0,.18-.68.51.51,0,0,0-.68-.19L190.55,350a.5.5,0,0,0,.25.93Zm41-19.51a.51.51,0,0,0-.68-.19l-40.62,23.46a.5.5,0,0,0,.25.93.47.47,0,0,0,.25-.07l40.62-23.45A.49.49,0,0,0,231.85,331.42Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.87,314.58a.83.83,0,0,1,.46,0,.75.75,0,0,1,.34.18.85.85,0,0,1,.21.31,1,1,0,0,1,.08.37.39.39,0,0,1,0,.14.22.22,0,0,1-.09.1l-.22.13a.11.11,0,0,1-.09,0,.17.17,0,0,1-.07-.1.89.89,0,0,0-.09-.16.46.46,0,0,0-.16-.15.49.49,0,0,0-.25-.06.78.78,0,0,0-.35.11,1.42,1.42,0,0,0-.28.22,1.76,1.76,0,0,0-.24.3,1.49,1.49,0,0,0-.17.36,1.14,1.14,0,0,0-.07.41.67.67,0,0,0,.06.32.32.32,0,0,0,.2.16.93.93,0,0,0,.34,0,4.07,4.07,0,0,0,.51-.07,1.82,1.82,0,0,1,.51,0,.69.69,0,0,1,.34.13.61.61,0,0,1,.19.31,1.55,1.55,0,0,1,.06.51,2.51,2.51,0,0,1-.08.67,3.25,3.25,0,0,1-.24.64,3,3,0,0,1-.38.57,2.65,2.65,0,0,1-.49.46V321a.41.41,0,0,1-.05.18.2.2,0,0,1-.1.12l-.21.12a.09.09,0,0,1-.11,0,.22.22,0,0,1,0-.13v-.55a.84.84,0,0,1-.46.05.73.73,0,0,1-.59-.46,1,1,0,0,1-.09-.42.39.39,0,0,1,0-.14.21.21,0,0,1,.08-.1l.22-.13s.07,0,.09,0,.05,0,.08.11a1.07,1.07,0,0,0,.09.19.65.65,0,0,0,.18.15.46.46,0,0,0,.27,0,.86.86,0,0,0,.38-.13,1.73,1.73,0,0,0,.35-.27,2.6,2.6,0,0,0,.3-.36,2.22,2.22,0,0,0,.2-.41,1.29,1.29,0,0,0,.07-.43.52.52,0,0,0-.08-.31.4.4,0,0,0-.25-.13,1.26,1.26,0,0,0-.39,0l-.52.08a1.38,1.38,0,0,1-.45,0,.51.51,0,0,1-.3-.18.65.65,0,0,1-.17-.33,1.85,1.85,0,0,1-.05-.49,2.91,2.91,0,0,1,.06-.57,3,3,0,0,1,.19-.58,2.48,2.48,0,0,1,.32-.54,2.39,2.39,0,0,1,.44-.46v-.53a.58.58,0,0,1,0-.18.36.36,0,0,1,.11-.13l.21-.12a.07.07,0,0,1,.1,0,.19.19,0,0,1,.05.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.2,315.42a4.58,4.58,0,0,0,.24-.59,2.38,2.38,0,0,0,.08-.64,1,1,0,0,0-.17-.63c-.11-.13-.28-.12-.52,0a1,1,0,0,0-.31.27,1.38,1.38,0,0,0-.22.35,1.9,1.9,0,0,0-.14.4c0,.15-.06.29-.08.43a.43.43,0,0,1-.06.17.21.21,0,0,1-.08.1l-.24.14a.07.07,0,0,1-.09,0,.13.13,0,0,1,0-.1,2.75,2.75,0,0,1,.09-.67,4.45,4.45,0,0,1,.24-.7,3.42,3.42,0,0,1,.39-.64,1.8,1.8,0,0,1,.53-.47,1,1,0,0,1,.52-.16.55.55,0,0,1,.37.16.92.92,0,0,1,.22.43,2.35,2.35,0,0,1,.08.63,3.79,3.79,0,0,1,0,.49,2.36,2.36,0,0,1-.08.45c0,.15-.1.31-.16.47s-.14.32-.23.5l-1.19,2.38,1.63-.94a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.29a.4.4,0,0,1-.14.31l-2.29,1.32a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-.29a.88.88,0,0,1,0-.17,1.65,1.65,0,0,1,.09-.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.71,316.89a.92.92,0,0,1,.07-.26.38.38,0,0,1,.16-.19l.31-.18a.05.05,0,0,1,.08,0,.11.11,0,0,1,0,.1.13.13,0,0,1,0,.06l-.27,1.26c0,.06,0,.13-.07.21a.4.4,0,0,1-.16.18l-.13.08a.09.09,0,0,1-.09,0,.16.16,0,0,1,0-.11h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.4,315.19a.72.72,0,0,0,.08.22.29.29,0,0,0,.14.15.39.39,0,0,0,.25,0,1.55,1.55,0,0,0,.41-.17,2.34,2.34,0,0,0,.31-.24,1.52,1.52,0,0,0,.26-.35,2.65,2.65,0,0,0,.18-.42,2,2,0,0,0,.06-.5,1.11,1.11,0,0,0-.06-.41.38.38,0,0,0-.17-.2.45.45,0,0,0-.26,0,1.25,1.25,0,0,0-.32.14l-.44.26a.08.08,0,0,1-.1,0,.17.17,0,0,1-.05-.13v-.3a.44.44,0,0,1,0-.15l.06-.14.95-2.14-1.52.89a.09.09,0,0,1-.11,0,.22.22,0,0,1,0-.13v-.3a.47.47,0,0,1,0-.17.25.25,0,0,1,.11-.13l2.09-1.21a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.3a.4.4,0,0,1,0,.15.67.67,0,0,1-.07.18l-.94,2.1a1,1,0,0,1,.49-.15.51.51,0,0,1,.38.12.83.83,0,0,1,.24.38,1.93,1.93,0,0,1,.09.64,3.16,3.16,0,0,1-.11.81,3.27,3.27,0,0,1-.28.72,3.07,3.07,0,0,1-.42.58,2,2,0,0,1-.51.42,1.59,1.59,0,0,1-.62.23.69.69,0,0,1-.42-.09A.68.68,0,0,1,245,316a1.71,1.71,0,0,1-.09-.48.23.23,0,0,1,0-.14.24.24,0,0,1,.08-.11l.24-.14a.09.09,0,0,1,.1,0A.15.15,0,0,1,245.4,315.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.77,311.05a3.49,3.49,0,0,0,.24-.59,2.43,2.43,0,0,0,.08-.64,1,1,0,0,0-.17-.63c-.11-.13-.28-.12-.52,0a1,1,0,0,0-.31.27,1.38,1.38,0,0,0-.22.35,2.35,2.35,0,0,0-.14.4c0,.14-.06.29-.08.43a.43.43,0,0,1-.06.17.21.21,0,0,1-.08.1l-.24.14a.07.07,0,0,1-.09,0,.16.16,0,0,1,0-.11,2.74,2.74,0,0,1,.09-.66,4.45,4.45,0,0,1,.24-.7,3.86,3.86,0,0,1,.39-.65,1.91,1.91,0,0,1,.53-.46.91.91,0,0,1,.52-.16.55.55,0,0,1,.37.16.92.92,0,0,1,.22.43,2.35,2.35,0,0,1,.08.63,3.79,3.79,0,0,1,0,.49,2.36,2.36,0,0,1-.08.45,4.19,4.19,0,0,1-.16.46,5.45,5.45,0,0,1-.23.51l-1.19,2.38,1.63-.94a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.29a.39.39,0,0,1,0,.18.34.34,0,0,1-.1.13l-2.29,1.32a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-.29a1.1,1.1,0,0,1,0-.18l.09-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,308.09v1.38a7,7,0,0,1-.09.93,4.32,4.32,0,0,1-.25.86,3.37,3.37,0,0,1-.41.72,2,2,0,0,1-.61.51,1,1,0,0,1-.6.18.6.6,0,0,1-.42-.23,1.36,1.36,0,0,1-.24-.57,3.61,3.61,0,0,1-.09-.84c0-.24,0-.47,0-.69s0-.44,0-.69a4.91,4.91,0,0,1,.09-.94,4,4,0,0,1,.24-.86,3,3,0,0,1,.42-.71,2.16,2.16,0,0,1,.6-.53,1.07,1.07,0,0,1,.61-.17.61.61,0,0,1,.41.24,1.51,1.51,0,0,1,.25.57A4.91,4.91,0,0,1,254,308.09Zm-2.21,2.65a1.72,1.72,0,0,0,.22,1c.15.17.36.17.63,0a1.47,1.47,0,0,0,.63-.73,3.26,3.26,0,0,0,.23-1.28v-1.38a1.63,1.63,0,0,0-.23-1c-.14-.17-.35-.17-.63,0a1.57,1.57,0,0,0-.63.73,3.51,3.51,0,0,0-.22,1.28c0,.25,0,.48,0,.69S251.75,310.5,251.76,310.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,310s.08,0,.1,0a.17.17,0,0,1,0,.13v.55a.39.39,0,0,1,0,.18.2.2,0,0,1-.1.12l-.35.21s-.08,0-.1,0a.17.17,0,0,1-.05-.13v-.55a.41.41,0,0,1,.05-.18.2.2,0,0,1,.1-.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,309.66a.41.41,0,0,1-.05.18.25.25,0,0,1-.1.12l-.22.13a.09.09,0,0,1-.1,0,.22.22,0,0,1,0-.13v-4.5l-.86,1.5a.22.22,0,0,1-.1.11.09.09,0,0,1-.1,0l-.13-.18a.28.28,0,0,1,0-.15.64.64,0,0,1,.06-.18l1.14-2a.31.31,0,0,1,.08-.11l.08-.05.22-.13a.08.08,0,0,1,.1,0,.17.17,0,0,1,.05.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12,307.74a.54.54,0,0,0,.31.44.62.62,0,0,0,.54-.09,1.57,1.57,0,0,0,.33-.26,2.16,2.16,0,0,0,.27-.38,2.87,2.87,0,0,0,.18-.47,2.6,2.6,0,0,0,.06-.56,1.56,1.56,0,0,0-.06-.48.64.64,0,0,0-.18-.27.42.42,0,0,0-.27-.07.78.78,0,0,0-.33.12,1.07,1.07,0,0,0-.32.26,1.51,1.51,0,0,0-.2.26l-.14.22a.34.34,0,0,1-.14.15l-.27.16a.05.05,0,0,1-.08,0,.13.13,0,0,1,0-.1l.15-2.82a.41.41,0,0,1,.05-.18.34.34,0,0,1,.1-.13l1.87-1.08a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.29a.46.46,0,0,1,0,.19.4.4,0,0,1-.1.12l-1.54.89-.09,1.46a1.94,1.94,0,0,1,.25-.27A1.78,1.78,0,0,1,259,305a1,1,0,0,1,.52-.17.6.6,0,0,1,.43.13.93.93,0,0,1,.29.43,2.28,2.28,0,0,1,.11.75,3.43,3.43,0,0,1-.11.86,3.81,3.81,0,0,1-.29.78,3.1,3.1,0,0,1-.43.62,2.34,2.34,0,0,1-.52.44,1.23,1.23,0,0,1-.51.17.72.72,0,0,1-.42-.07.81.81,0,0,1-.3-.33,1.35,1.35,0,0,1-.11-.57.32.32,0,0,1,0-.14.24.24,0,0,1,.08-.11l.25-.14h.08S258.11,307.69,258.12,307.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45,318.33v1.19a.28.28,0,0,1,0,.13.2.2,0,0,1-.07.1l-.15.08a0,0,0,0,1-.07,0,.12.12,0,0,1,0-.09v-1.2l-.77.45a.06.06,0,0,1-.07,0,.13.13,0,0,1,0-.1v-.18a.28.28,0,0,1,0-.13.29.29,0,0,1,.07-.1l.77-.44v-1.17a.28.28,0,0,1,0-.13.2.2,0,0,1,.07-.1l.15-.08a0,0,0,0,1,.07,0,.12.12,0,0,1,0,.09v1.18l.77-.44s.05,0,.07,0a.11.11,0,0,1,0,.1v.18a.25.25,0,0,1,0,.14.22.22,0,0,1-.07.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7,317.15l-.06,0,0,0a.85.85,0,0,1-.36.12.48.48,0,0,1-.31-.1.62.62,0,0,1-.22-.31,1.49,1.49,0,0,1-.09-.56,2.49,2.49,0,0,1,.08-.61,2.78,2.78,0,0,1,.21-.57,2.36,2.36,0,0,1,.32-.48,1.22,1.22,0,0,1,.37-.32.81.81,0,0,1,.41-.13.45.45,0,0,1,.31.12.76.76,0,0,1,.19.33,1.7,1.7,0,0,1,.07.53,1.82,1.82,0,0,1,0,.32c0,.11,0,.23-.08.34a3.37,3.37,0,0,1-.1.34c0,.11-.07.21-.1.3l-.71,2a1,1,0,0,0,0,.1.18.18,0,0,1-.08.09l-.22.13s-.05,0-.06,0a.13.13,0,0,1,0-.08v0l0,0Zm.5-1.7a1,1,0,0,0,0-.32.43.43,0,0,0-.12-.21.32.32,0,0,0-.19-.07.52.52,0,0,0-.25.08.79.79,0,0,0-.24.21,1.24,1.24,0,0,0-.2.29,2.06,2.06,0,0,0-.12.35,1.64,1.64,0,0,0-.05.37,1,1,0,0,0,.05.33.43.43,0,0,0,.12.2.3.3,0,0,0,.2.08.52.52,0,0,0,.24-.08,1,1,0,0,0,.25-.21,1.44,1.44,0,0,0,.31-.64A1.58,1.58,0,0,0,255.2,315.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.09,317.06a.06.06,0,0,1,.08,0,.13.13,0,0,1,0,.1v.4a.31.31,0,0,1,0,.13.15.15,0,0,1-.08.09l-.26.15s-.05,0-.07,0a.13.13,0,0,1,0-.1v-.4a.31.31,0,0,1,0-.13c0-.05,0-.08.07-.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.08,312.43a.08.08,0,0,1,.08,0,.12.12,0,0,1,0,.09v.22s0,.08,0,.12l0,.14-.87,3.94a.56.56,0,0,1,0,.12.22.22,0,0,1-.07.09l-.18.1s-.05,0-.07,0,0-.05,0-.09v0a.11.11,0,0,1,0,0l.87-4-1.28.74a.08.08,0,0,1-.08,0,.12.12,0,0,1,0-.09v-.22a.31.31,0,0,1,0-.13.18.18,0,0,1,.08-.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.52,314.36a.09.09,0,0,1-.06,0l0,0a.72.72,0,0,1-.36.11.42.42,0,0,1-.31-.09.65.65,0,0,1-.22-.32,1.44,1.44,0,0,1-.09-.55,2.49,2.49,0,0,1,.08-.61,2.59,2.59,0,0,1,.22-.57,2,2,0,0,1,.31-.48,1.6,1.6,0,0,1,.37-.33.9.9,0,0,1,.41-.12.45.45,0,0,1,.31.12.7.7,0,0,1,.19.33,1.66,1.66,0,0,1,.07.53,1.91,1.91,0,0,1,0,.32c0,.11-.05.23-.08.34a3.18,3.18,0,0,1-.1.33c0,.11-.07.21-.1.3l-.71,2a1,1,0,0,0,0,.1.18.18,0,0,1-.08.09l-.22.13s0,0-.06,0a.15.15,0,0,1,0-.08V316s0,0,0,0Zm.5-1.69a1,1,0,0,0,0-.32.54.54,0,0,0-.13-.21.26.26,0,0,0-.19-.07.43.43,0,0,0-.25.08.91.91,0,0,0-.24.2,1.57,1.57,0,0,0-.2.3,1.8,1.8,0,0,0-.12.35,1.55,1.55,0,0,0,0,.37,1.06,1.06,0,0,0,0,.33.48.48,0,0,0,.12.2.29.29,0,0,0,.2.07.41.41,0,0,0,.24-.07,1,1,0,0,0,.25-.21,1.81,1.81,0,0,0,.19-.29,2.09,2.09,0,0,0,.13-.35A1.64,1.64,0,0,0,260,312.67Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--info-box--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.84,428.79v-31.4a5.83,5.83,0,0,1,2.64-4.57l108.74-62.65c1.45-.83,2.63-.15,2.63,1.52V363.1a5.83,5.83,0,0,1-2.63,4.56L154.48,430.31C153,431.15,151.84,430.47,151.84,428.79Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,431.07v-31.4a5.84,5.84,0,0,1,2.63-4.57l108.74-62.65c1.46-.84,2.64-.15,2.64,1.52v31.41a5.81,5.81,0,0,1-2.64,4.56L158.54,432.59C157.09,433.43,155.91,432.75,155.91,431.07Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,431.07v-31.4a5.84,5.84,0,0,1,2.63-4.57l108.74-62.65c1.46-.84,2.64-.15,2.64,1.52v31.41a5.81,5.81,0,0,1-2.64,4.56L158.54,432.59C157.09,433.43,155.91,432.75,155.91,431.07Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,421.59a5.68,5.68,0,0,1-2.84-.74c-2.39-1.39-3.77-4.58-3.77-8.75,0-7.84,4.79-17,10.68-20.39,2.62-1.51,5.16-1.7,7.15-.55,2.4,1.38,3.78,4.57,3.78,8.75,0,7.84-4.79,17-10.68,20.38A8.78,8.78,0,0,1,168,421.59Zm8.39-30.67a8.2,8.2,0,0,0-4.07,1.23c-5.75,3.32-10.43,12.27-10.43,20,0,4,1.28,7,3.52,8.31,1.84,1.06,4.2.87,6.66-.55,5.75-3.32,10.43-12.27,10.43-19.95,0-4-1.29-7-3.53-8.32A5.07,5.07,0,0,0,176.35,390.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.67,417.23a.3.3,0,0,1-.15-.05.24.24,0,0,1-.1-.25l.93-5.27-1.27,1.3a.25.25,0,0,1-.42-.22l.67-3.8a.2.2,0,0,1,.06-.13l1.78-1.82,1.71-9.68a.21.21,0,0,1,.12-.17l4.22-2.44a.24.24,0,0,1,.27,0,.24.24,0,0,1,.1.25l-1.17,6.66,1.42-1.45a.24.24,0,0,1,.29-.05.24.24,0,0,1,.13.26l-.67,3.81a.25.25,0,0,1-.06.13l-1.93,2-.64,3.64,6.32-3.66a.26.26,0,0,1,.27,0,.25.25,0,0,1,.1.25l-.72,4.13a.25.25,0,0,1-.13.17l-11,6.36A.28.28,0,0,1,166.67,417.23Zm1.07-6.57a.25.25,0,0,1,.24.29l-1,5.54,10.44-6,.62-3.49-6.33,3.66a.23.23,0,0,1-.26,0,.25.25,0,0,1-.11-.24l.75-4.24a.21.21,0,0,1,.07-.13l1.93-2,.51-2.93-1.42,1.45a.25.25,0,0,1-.42-.21L174,395.4l-3.66,2.11-1.7,9.64a.24.24,0,0,1-.07.13l-1.78,1.82-.51,2.93,1.27-1.3A.24.24,0,0,1,167.74,410.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,390.24c0,1.29,1,1.78,2.17,1.09l28.16-16.26a4.64,4.64,0,0,0,2.17-3.59c0-1.3-1-1.79-2.17-1.1L193,386.64A4.64,4.64,0,0,0,190.8,390.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,397.8a.57.57,0,0,0,.25-.06L223.55,379a.5.5,0,0,0-.5-.86l-32.5,18.76a.5.5,0,0,0,.25.93Zm41-19.51a.49.49,0,0,0-.68-.18l-40.62,23.45a.5.5,0,0,0,.25.93.57.57,0,0,0,.25-.06L231.67,379A.49.49,0,0,0,231.85,378.29Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.22,361.83a.72.72,0,0,1,.8.13,1,1,0,0,1,.21.32,1,1,0,0,1,.08.37.25.25,0,0,1,0,.14.18.18,0,0,1-.09.1L239,363s-.07,0-.09,0,0,0-.08-.11a.56.56,0,0,0-.08-.15.5.5,0,0,0-.42-.21.7.7,0,0,0-.35.11,1.79,1.79,0,0,0-.28.22,1.22,1.22,0,0,0-.24.3,1.49,1.49,0,0,0-.17.36,1.4,1.4,0,0,0-.06.41.67.67,0,0,0,.06.32.26.26,0,0,0,.19.15.78.78,0,0,0,.35,0,4.2,4.2,0,0,0,.5-.07,1.82,1.82,0,0,1,.51,0,.61.61,0,0,1,.34.13.62.62,0,0,1,.2.31,1.88,1.88,0,0,1,.06.51,2.57,2.57,0,0,1-.09.67,2.48,2.48,0,0,1-.24.64,3,3,0,0,1-.38.57,2.65,2.65,0,0,1-.49.46v.53a.58.58,0,0,1,0,.18.49.49,0,0,1-.1.13l-.22.12a.08.08,0,0,1-.1,0,.17.17,0,0,1,0-.13v-.55a.88.88,0,0,1-.47.05.73.73,0,0,1-.35-.15.74.74,0,0,1-.24-.31,1,1,0,0,1-.09-.42.35.35,0,0,1,0-.14c0-.05.05-.09.09-.1l.21-.13a.13.13,0,0,1,.1,0,.17.17,0,0,1,.07.1.62.62,0,0,0,.1.2.5.5,0,0,0,.17.15.59.59,0,0,0,.27,0,.82.82,0,0,0,.38-.13,2.19,2.19,0,0,0,.35-.27,2,2,0,0,0,.3-.36,2.22,2.22,0,0,0,.2-.41,1.29,1.29,0,0,0,.07-.43.46.46,0,0,0-.08-.31.48.48,0,0,0-.24-.14,1.3,1.3,0,0,0-.39,0l-.53.08a1.13,1.13,0,0,1-.45,0,.56.56,0,0,1-.3-.17.84.84,0,0,1-.17-.34,2.21,2.21,0,0,1-.05-.48,2.34,2.34,0,0,1,.07-.57,3,3,0,0,1,.18-.58,3,3,0,0,1,.32-.54,2.45,2.45,0,0,1,.45-.46v-.54a.35.35,0,0,1,0-.17.24.24,0,0,1,.1-.13l.22-.12a.08.08,0,0,1,.1,0,.22.22,0,0,1,0,.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.47,365.5a.41.41,0,0,1-.05.18.27.27,0,0,1-.1.13l-.22.12a.08.08,0,0,1-.1,0,.2.2,0,0,1,0-.13v-4.5l-.86,1.5a.18.18,0,0,1-.1.11.08.08,0,0,1-.1,0l-.13-.18a.33.33,0,0,1,0-.15.64.64,0,0,1,.06-.18l1.14-2a.24.24,0,0,1,.08-.11l.08-.06.22-.12s.08,0,.1,0a.16.16,0,0,1,.05.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.21,364.63a.92.92,0,0,1,.07-.26.43.43,0,0,1,.16-.19l.31-.18a.05.05,0,0,1,.08,0,.13.13,0,0,1,0,.1s0,0,0,.06l-.28,1.26a.74.74,0,0,1-.07.21.34.34,0,0,1-.15.18l-.14.08s-.05,0-.08,0a.13.13,0,0,1,0-.1v0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11,360.61a3,3,0,0,0,.24-.58,2.51,2.51,0,0,0,.08-.65,1,1,0,0,0-.17-.62c-.11-.13-.28-.13-.52,0a1.3,1.3,0,0,0-.31.26,1.38,1.38,0,0,0-.22.35,2.83,2.83,0,0,0-.14.41c0,.14-.06.28-.08.42a.38.38,0,0,1-.06.17.21.21,0,0,1-.08.1l-.24.14a.06.06,0,0,1-.08,0,.12.12,0,0,1,0-.11,4.16,4.16,0,0,1,.09-.66,3.75,3.75,0,0,1,.25-.71,2.81,2.81,0,0,1,.39-.64,1.92,1.92,0,0,1,.52-.47,1.1,1.1,0,0,1,.52-.16.55.55,0,0,1,.37.16,1.17,1.17,0,0,1,.23.43,2.38,2.38,0,0,1,.07.63c0,.18,0,.34,0,.49a3.73,3.73,0,0,1-.09.46,3.16,3.16,0,0,1-.16.46,5.34,5.34,0,0,1-.23.5l-1.18,2.38,1.62-.93a.08.08,0,0,1,.1,0,.17.17,0,0,1,0,.13v.3a.39.39,0,0,1,0,.18.25.25,0,0,1-.1.12l-2.29,1.32a.08.08,0,0,1-.1,0s0-.07,0-.13v-.29a.47.47,0,0,1,0-.17.81.81,0,0,1,.09-.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,361a.56.56,0,0,0,.3.44.61.61,0,0,0,.54-.09,1.64,1.64,0,0,0,.33-.26,2.16,2.16,0,0,0,.27-.38,1.71,1.71,0,0,0,.18-.48,2.43,2.43,0,0,0,.07-.55,1.52,1.52,0,0,0-.07-.48.46.46,0,0,0-.18-.27.37.37,0,0,0-.27-.07.83.83,0,0,0-.33.12,1.42,1.42,0,0,0-.32.25l-.2.26-.13.23a.41.41,0,0,1-.14.15l-.27.16a.07.07,0,0,1-.09,0,.13.13,0,0,1,0-.1l.16-2.82a.39.39,0,0,1,0-.18.28.28,0,0,1,.1-.13l1.87-1.08s.08,0,.1,0a.16.16,0,0,1,0,.13v.29a.41.41,0,0,1,0,.18.27.27,0,0,1-.1.13l-1.54.89-.08,1.46a2.6,2.6,0,0,1,.24-.27,2.47,2.47,0,0,1,.39-.29,1.31,1.31,0,0,1,.53-.17.66.66,0,0,1,.43.13,1,1,0,0,1,.28.44,2,2,0,0,1,.11.75,3.07,3.07,0,0,1-.11.86,3.5,3.5,0,0,1-.28.77,3.32,3.32,0,0,1-.43.63,2.09,2.09,0,0,1-.53.43,1.05,1.05,0,0,1-.5.18.68.68,0,0,1-.43-.08.65.65,0,0,1-.29-.32,1.2,1.2,0,0,1-.12-.57.28.28,0,0,1,0-.15.27.27,0,0,1,.08-.1l.24-.14h.08S247,361,247,361Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.46,355.83v1.38a5.87,5.87,0,0,1-.09.94,3.9,3.9,0,0,1-.25.86,2.63,2.63,0,0,1-.41.71,2.3,2.3,0,0,1-.6.52,1.18,1.18,0,0,1-.61.18.61.61,0,0,1-.41-.24,1.37,1.37,0,0,1-.25-.57,4.91,4.91,0,0,1-.09-.84v-1.38a7.14,7.14,0,0,1,.09-.93,3.75,3.75,0,0,1,.25-.86,3.63,3.63,0,0,1,.41-.72,2,2,0,0,1,.61-.52,1,1,0,0,1,.6-.17.59.59,0,0,1,.41.23,1.36,1.36,0,0,1,.25.58A4.06,4.06,0,0,1,252.46,355.83Zm-2.21,2.66a1.63,1.63,0,0,0,.23,1q.21.24.63,0a1.46,1.46,0,0,0,.62-.73,3.2,3.2,0,0,0,.23-1.27c0-.25,0-.48,0-.69s0-.45,0-.69a1.69,1.69,0,0,0-.23-1c-.14-.16-.35-.17-.62,0a1.49,1.49,0,0,0-.63.74,3.26,3.26,0,0,0-.23,1.28v1.38Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.54,357.77a.08.08,0,0,1,.1,0,.22.22,0,0,1,0,.13v.55a.58.58,0,0,1,0,.18.49.49,0,0,1-.1.13l-.36.2a.08.08,0,0,1-.1,0s0-.07,0-.13v-.54a.37.37,0,0,1,0-.18.28.28,0,0,1,.1-.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.43,353.84l.1-.08.1-.07a1,1,0,0,1,.55-.16.67.67,0,0,1,.43.16,1.1,1.1,0,0,1,.29.46,2.2,2.2,0,0,1,.1.72,3.37,3.37,0,0,1-.1.83,3.9,3.9,0,0,1-.29.79,3.49,3.49,0,0,1-.43.67,2.15,2.15,0,0,1-.55.47,1.19,1.19,0,0,1-.55.17.69.69,0,0,1-.44-.17,1,1,0,0,1-.28-.46,2.18,2.18,0,0,1-.11-.72,2.38,2.38,0,0,1,0-.46,3,3,0,0,1,.09-.43c0-.14.08-.28.12-.42l.14-.39,1-2.74.06-.14a.25.25,0,0,1,.11-.12l.3-.18a.06.06,0,0,1,.08,0,.16.16,0,0,1,0,.11.15.15,0,0,1,0,.07s0,0,0,.05Zm-.67,2.32a1.35,1.35,0,0,0,.06.43.72.72,0,0,0,.17.3.37.37,0,0,0,.27.11.71.71,0,0,0,.37-.1,1.53,1.53,0,0,0,.36-.32,1.73,1.73,0,0,0,.27-.43,2.63,2.63,0,0,0,.24-1,1.11,1.11,0,0,0-.07-.43.52.52,0,0,0-.17-.29.38.38,0,0,0-.27-.12.68.68,0,0,0-.36.11,1.36,1.36,0,0,0-.37.31,1.73,1.73,0,0,0-.27.43,2.84,2.84,0,0,0-.17.49A2.2,2.2,0,0,0,254.76,356.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.22,351.35c0,.24,0,.47,0,.69s0,.44,0,.69a4.91,4.91,0,0,1-.09.94,3.8,3.8,0,0,1-.24.85,2.84,2.84,0,0,1-.42.72,2.3,2.3,0,0,1-.6.52,1,1,0,0,1-.6.17.56.56,0,0,1-.42-.23,1.51,1.51,0,0,1-.25-.57,4.2,4.2,0,0,1-.08-.84c0-.24,0-.47,0-.69s0-.44,0-.69a5.64,5.64,0,0,1,.08-.93,4.32,4.32,0,0,1,.25-.86,2.84,2.84,0,0,1,.42-.72,2,2,0,0,1,.6-.52,1,1,0,0,1,.6-.18.65.65,0,0,1,.42.24,1.36,1.36,0,0,1,.24.57A3.61,3.61,0,0,1,260.22,351.35ZM258,354a1.74,1.74,0,0,0,.23,1q.21.24.63,0a1.57,1.57,0,0,0,.63-.73,3.25,3.25,0,0,0,.22-1.27c0-.25,0-.48,0-.7s0-.44,0-.68a1.66,1.66,0,0,0-.22-1c-.15-.16-.36-.17-.63,0a1.49,1.49,0,0,0-.63.74,3.43,3.43,0,0,0-.23,1.27V354Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.08,366a.06.06,0,0,1-.08,0,.17.17,0,0,1,0-.1v-.19a.28.28,0,0,1,0-.13.21.21,0,0,1,.08-.1l1.15-.66a.06.06,0,0,1,.07,0,.12.12,0,0,1,0,.09v.19a.35.35,0,0,1,0,.14.22.22,0,0,1-.07.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.83,362.78v1a5.38,5.38,0,0,1-.07.69,3.26,3.26,0,0,1-.18.63,2.11,2.11,0,0,1-.31.52,1.46,1.46,0,0,1-.44.38.77.77,0,0,1-.44.13.44.44,0,0,1-.31-.17,1,1,0,0,1-.18-.42,2.8,2.8,0,0,1-.06-.61c0-.18,0-.35,0-.51s0-.33,0-.51a4,4,0,0,1,.06-.69,3.26,3.26,0,0,1,.18-.63,2.24,2.24,0,0,1,.31-.52,1.49,1.49,0,0,1,.44-.39.68.68,0,0,1,.44-.12.42.42,0,0,1,.31.17,1,1,0,0,1,.18.42A3.53,3.53,0,0,1,254.83,362.78Zm-1.63,2a1.32,1.32,0,0,0,.17.75c.11.12.26.12.46,0a1.07,1.07,0,0,0,.46-.54,2.41,2.41,0,0,0,.17-.93v-1a1.24,1.24,0,0,0-.17-.75c-.1-.12-.26-.12-.46,0a1.17,1.17,0,0,0-.46.54,2.68,2.68,0,0,0-.17.94v1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,364.21s0,0,.07,0a.13.13,0,0,1,0,.1v.4a.31.31,0,0,1,0,.13c0,.05,0,.08-.07.09l-.27.15a0,0,0,0,1-.07,0,.15.15,0,0,1,0-.1v-.4a.28.28,0,0,1,0-.13.17.17,0,0,1,.07-.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.38,361.7a2.2,2.2,0,0,0,.18-.43,1.65,1.65,0,0,0,.05-.47.67.67,0,0,0-.12-.46c-.08-.1-.2-.09-.38,0a.71.71,0,0,0-.23.19,1.13,1.13,0,0,0-.16.26,1.32,1.32,0,0,0-.1.3c0,.1-.05.21-.06.31a.5.5,0,0,1,0,.13.22.22,0,0,1-.06.07l-.18.1a0,0,0,0,1-.06,0,.1.1,0,0,1,0-.08,2.31,2.31,0,0,1,.07-.49,2.47,2.47,0,0,1,.18-.52,2.29,2.29,0,0,1,.29-.47,1.35,1.35,0,0,1,.38-.34.83.83,0,0,1,.38-.12.42.42,0,0,1,.27.12.66.66,0,0,1,.17.31,1.68,1.68,0,0,1,.06.47c0,.13,0,.25,0,.36s0,.22-.07.33-.07.23-.11.34-.11.24-.18.37l-.86,1.75,1.19-.69a0,0,0,0,1,.07,0,.12.12,0,0,1,0,.09v.22a.31.31,0,0,1,0,.13.22.22,0,0,1-.07.09l-1.68,1a.06.06,0,0,1-.08,0,.15.15,0,0,1,0-.1v-.22a.5.5,0,0,1,0-.12l.07-.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.77,362a.4.4,0,0,0,.22.32.47.47,0,0,0,.4-.07,1.06,1.06,0,0,0,.24-.19,1.18,1.18,0,0,0,.2-.28,1.71,1.71,0,0,0,.13-.34,1.84,1.84,0,0,0,.05-.41,1.15,1.15,0,0,0-.05-.36.4.4,0,0,0-.13-.19.28.28,0,0,0-.2-.05.62.62,0,0,0-.24.08,1,1,0,0,0-.24.19,1.82,1.82,0,0,0-.14.19l-.1.17a.29.29,0,0,1-.11.11l-.19.11s-.05,0-.07,0a.15.15,0,0,1,0-.08l.12-2.07a.31.31,0,0,1,0-.13s0-.08.07-.09l1.38-.8a.06.06,0,0,1,.07,0,.12.12,0,0,1,0,.09v.22a.31.31,0,0,1,0,.13c0,.05,0,.08-.07.09l-1.14.66-.06,1.07.18-.2a1.82,1.82,0,0,1,.29-.21.84.84,0,0,1,.38-.12.46.46,0,0,1,.32.1.64.64,0,0,1,.21.32,1.62,1.62,0,0,1,.08.54,2.74,2.74,0,0,1-.08.64,2.49,2.49,0,0,1-.21.56,2.29,2.29,0,0,1-.32.47,1.79,1.79,0,0,1-.38.31.83.83,0,0,1-.37.13.49.49,0,0,1-.32-.05.5.5,0,0,1-.21-.24.87.87,0,0,1-.09-.42.23.23,0,0,1,0-.11.14.14,0,0,1,.06-.07l.18-.1a0,0,0,0,1,.06,0S258.76,362,258.77,362Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.14,22.62a3.42,3.42,0,0,0-1.5-3.21h0l-3.86-2.21h0a3.41,3.41,0,0,0-3.53.31L295.93,77.73A10.88,10.88,0,0,0,291,86.26V160a3.44,3.44,0,0,0,1.46,3.19h0l3.95,2.25h0a3.45,3.45,0,0,0,3.49-.34l104.31-60.22a10.88,10.88,0,0,0,4.92-8.53Z",
    style: {
      fill: "#508C9B",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.14,22.62V96.36a10.88,10.88,0,0,1-4.92,8.52L299.9,165.1c-2.41,1.4-4.43.55-4.84-1.87a4.68,4.68,0,0,0,.87-.39l104.32-60.23a10.86,10.86,0,0,0,4.92-8.52V20.36a4.34,4.34,0,0,0-.09-1C407.39,18.51,409.14,19.83,409.14,22.62Z",
    style: {
      fill: "#508C9B",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.21,19.78,311.68,74.23,305,78.1S301.41,80,300,81a9.39,9.39,0,0,0-1.32,1.13,10.17,10.17,0,0,0-2.82,6.36v7.74L295,162.26l-.85-66V88.46a11.78,11.78,0,0,1,3.28-7.54A10.25,10.25,0,0,1,299,79.53c1.47-1,5.07-3,5.07-3l6.71-3.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 97.7 303.27 153.91 303.27 101.66 400.63 45.46 400.63 44.34 303.06 100.67 302.43 101.03 302.43 155.52 400.63 98.83 400.63 97.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 79.92 303.06 136.24 302.64 137.6 400.63 81.03 400.63 79.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 62.13 303.06 118.45 302.64 119.82 400.63 63.25 400.63 62.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 97.99 399.79 99.03 399.79 45.66 400.63 44.62 400.63 97.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.46 105.01 387.62 106.06 387.62 52.69 388.46 51.64 388.46 105.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.29 112.04 375.45 113.08 375.45 59.71 376.29 58.67 376.29 112.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.12 119.06 363.28 120.11 363.28 66.74 364.12 65.69 364.12 119.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.95 126.09 351.11 127.13 351.11 73.76 351.95 72.72 351.95 126.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.78 133.12 338.94 134.16 338.94 80.79 339.78 79.75 339.78 133.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.61 140.14 326.77 141.19 326.77 87.82 327.61 86.77 327.61 140.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.44 147.17 314.6 148.21 314.6 94.84 315.44 93.8 315.44 147.17",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,139.21l-.43-.76c2.93-1.69,4.33-10.74,5.56-18.72s2.38-15.35,4.93-17.17a2.9,2.9,0,0,1,2.51-.61c1.78.5,2.85,3,4,5.71,1,2.41,2.07,4.89,3.5,5.37a2,2,0,0,0,1.68-.28c3.09-1.78,4.48-.19,5.71,1.22s2.43,2.78,5.57,1c2.77-1.6,4-4.8,5.4-8.19s2.74-6.85,5.76-8.6c2.7-1.56,4,0,5.31,1.54,1.59,1.89,3.24,3.84,7.88,1.91a1.56,1.56,0,0,1,1.32,0c1.22.55,1.92,2.61,2.72,5s1.78,5.24,3.27,5.68a2.56,2.56,0,0,0,2.25-.75c2.08-1.64,3.29-5.19,4.45-8.62,1.34-3.93,2.72-8,5.5-9.6,2.3-1.33,3.26-3.76,4.28-6.33,1.15-2.89,2.34-5.87,5.48-7.68s4.62.13,5.74,1.74,2.09,3,4.74,1.49l.43.75c-3.33,1.93-4.75-.11-5.89-1.74s-2-3-4.59-1.49c-2.88,1.66-4,4.5-5.1,7.25-1,2.59-2.1,5.28-4.66,6.76s-3.82,5.35-5.1,9.13c-1.21,3.55-2.46,7.22-4.74,9a3.34,3.34,0,0,1-3,.9c-1.92-.57-2.89-3.44-3.84-6.23-.68-2-1.38-4.07-2.26-4.47a.77.77,0,0,0-.63,0c-5.22,2.18-7.25-.22-8.88-2.15-1.29-1.53-2.14-2.54-4.21-1.35-2.76,1.6-4,4.79-5.38,8.17s-2.74,6.87-5.78,8.62c-3.76,2.18-5.37.34-6.66-1.14s-2.14-2.47-4.62-1a2.81,2.81,0,0,1-2.38.35c-1.81-.6-2.94-3.27-4-5.85-1-2.37-2-4.83-3.42-5.22a2.07,2.07,0,0,0-1.76.49c-2.26,1.61-3.44,9.23-4.58,16.6C307.32,128.44,306,137.3,302.65,139.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,138.18a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.12-1.12-1.08a3,3,0,0,1,1.12-2.38C303.05,136.74,303.56,137.22,303.56,138.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,102.29a3,3,0,0,1-1.13,2.39c-.62.36-1.12-.13-1.12-1.09a3,3,0,0,1,1.12-2.38C313.64,100.85,314.15,101.34,314.15,102.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,112.5a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.13-1.12-1.08a3,3,0,0,1,1.12-2.39C325.31,111.06,325.82,111.54,325.82,112.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.86,114.75a3,3,0,0,1-1.13,2.39c-.62.36-1.12-.13-1.12-1.09a3,3,0,0,1,1.12-2.38C336.35,113.31,336.86,113.8,336.86,114.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.22,97.83a3,3,0,0,1-1.12,2.38c-.62.36-1.13-.13-1.13-1.08a3,3,0,0,1,1.13-2.39C347.72,96.39,348.22,96.87,348.22,97.83Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,101.3a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.13-1.12-1.08a3,3,0,0,1,1.12-2.38C360.93,99.86,361.44,100.34,361.44,101.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,111.17a3,3,0,0,1-1.13,2.38c-.62.36-1.13-.13-1.13-1.08a3,3,0,0,1,1.13-2.39C370.48,109.72,371,110.21,371,111.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.93,93a3,3,0,0,1-1.13,2.39c-.62.35-1.12-.13-1.12-1.09a3,3,0,0,1,1.12-2.38C380.43,91.51,380.93,92,380.93,93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.35,79.14a3,3,0,0,1-1.12,2.38c-.62.36-1.13-.13-1.13-1.08a3,3,0,0,1,1.13-2.39C389.85,77.69,390.35,78.18,390.35,79.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.1,82.19A3,3,0,0,1,400,84.57c-.63.36-1.13-.12-1.13-1.08A2.94,2.94,0,0,1,400,81.11C400.6,80.75,401.1,81.23,401.1,82.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.86,85.23c0,1.3,1,1.79,2.16,1.1l28.17-16.26a4.65,4.65,0,0,0,2.16-3.6c0-1.29-1-1.78-2.16-1.09L305,81.64A4.62,4.62,0,0,0,302.86,85.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85,92.8a.43.43,0,0,0,.25-.07L335.6,74a.49.49,0,0,0,.18-.68.5.5,0,0,0-.68-.19L302.6,91.87a.5.5,0,0,0,.25.93Zm41.06-19.51a.51.51,0,0,0-.68-.19L302.6,96.56a.5.5,0,0,0,.25.93.43.43,0,0,0,.25-.07L343.73,74A.5.5,0,0,0,343.91,73.29Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,42.83c0,1.29,1,1.78,2.16,1.09l10.95-6.33A4.65,4.65,0,0,0,400.34,34c0-1.3-1-1.79-2.16-1.1l-10.95,6.33A4.63,4.63,0,0,0,385.07,42.83Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.14,122.2a3.42,3.42,0,0,0-1.5-3.21h0l-3.86-2.21h0a3.41,3.41,0,0,0-3.53.3L295.93,177.31a10.88,10.88,0,0,0-4.92,8.53v73.73a3.44,3.44,0,0,0,1.46,3.19h0l3.95,2.25h0a3.45,3.45,0,0,0,3.49-.34l104.31-60.22a10.88,10.88,0,0,0,4.92-8.53Z",
    style: {
      fill: "#508C9B",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.14,122.2v73.73a10.88,10.88,0,0,1-4.92,8.53L299.9,264.68c-2.41,1.4-4.43.54-4.84-1.87a4.17,4.17,0,0,0,.87-.4l104.32-60.22a10.87,10.87,0,0,0,4.92-8.52V119.94a4.34,4.34,0,0,0-.09-1C407.39,118.09,409.14,119.4,409.14,122.2Z",
    style: {
      fill: "#508C9B",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.21,119.35l-92.53,54.46L305,177.68s-3.55,1.91-5,2.88a8.23,8.23,0,0,0-1.32,1.13,10.17,10.17,0,0,0-2.82,6.36v7.74l-.85,66-.85-66V188a11.82,11.82,0,0,1,3.28-7.54,10.74,10.74,0,0,1,1.61-1.38c1.47-1,5.07-3,5.07-3l6.71-3.88Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 197.28 303.27 253.49 303.27 201.24 400.63 145.04 400.63 143.92 303.06 200.24 302.43 200.61 302.43 255.1 400.63 198.41 400.63 197.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 179.49 303.06 235.82 302.64 237.18 400.63 180.61 400.63 179.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 161.71 303.06 218.03 302.64 219.4 400.63 162.82 400.63 161.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 197.56 399.79 198.61 399.79 145.24 400.63 144.2 400.63 197.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.46 204.59 387.62 205.64 387.62 152.27 388.46 151.22 388.46 204.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.29 211.62 375.45 212.66 375.45 159.29 376.29 158.25 376.29 211.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.12 218.64 363.28 219.69 363.28 166.32 364.12 165.27 364.12 218.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.95 225.67 351.11 226.71 351.11 173.34 351.95 172.3 351.95 225.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.78 232.69 338.94 233.74 338.94 180.37 339.78 179.32 339.78 232.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.61 239.72 326.77 240.76 326.77 187.4 327.61 186.35 327.61 239.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.44 246.75 314.6 247.79 314.6 194.42 315.44 193.38 315.44 246.75",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,238.36l-.43-.75c3.17-1.83,4.67-1.26,6-.76s2.17.82,4.49-.83c2.7-1.93,4.16-6.93,5.57-11.77,1.56-5.33,3-10.36,6.1-12.13s4.48-.25,5.7,1.11,2.43,2.68,5.58.86c2.78-1.61,4.06-4.53,5.41-7.62s2.74-6.27,5.75-8c2.68-1.54,4-.23,5.29,1,1.52,1.5,3.24,3.2,7.9,1.25,1.88-.78,2.95.51,3.89,1.66,1.3,1.58,2.42,2.94,5.67.38,2.08-1.64,3.29-5.89,4.47-10,1.32-4.67,2.7-9.48,5.48-11.09,2.27-1.31,3.24-5.25,4.27-9.42,1.14-4.63,2.32-9.41,5.49-11.24a2.49,2.49,0,0,1,2.24-.28c1.79.74,2.65,3.86,3.56,7.17.82,3,1.68,6.11,3.12,6.7a1.77,1.77,0,0,0,1.56-.24l.43.75a2.57,2.57,0,0,1-2.32.29c-1.84-.75-2.71-3.92-3.63-7.27-.81-3-1.65-6-3.05-6.59a1.62,1.62,0,0,0-1.48.22c-2.85,1.65-4,6.25-5.08,10.7s-2.09,8.47-4.68,10-3.8,6.08-5.08,10.57-2.46,8.62-4.76,10.44c-3.93,3.09-5.57,1.09-6.88-.51-1-1.24-1.66-1.91-2.89-1.4-5.18,2.16-7.21.17-8.84-1.44-1.29-1.27-2.14-2.11-4.25-.89-2.76,1.59-4,4.51-5.39,7.6s-2.74,6.27-5.77,8c-3.76,2.17-5.36.4-6.65-1s-2.15-2.37-4.63-.94c-2.77,1.6-4.26,6.7-5.69,11.62s-3,10.14-5.9,12.23c-2.7,1.93-4,1.43-5.31.94S305.47,236.73,302.65,238.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,237.34a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.12-1.12-1.08a3,3,0,0,1,1.12-2.38C303.05,235.9,303.56,236.38,303.56,237.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,235.75a3,3,0,0,1-1.13,2.39c-.62.35-1.12-.13-1.12-1.09a3,3,0,0,1,1.12-2.38C313.64,234.31,314.15,234.8,314.15,235.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,211.87a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.13-1.12-1.09a3,3,0,0,1,1.12-2.38C325.31,210.42,325.82,210.91,325.82,211.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.86,213.91a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.12-1.12-1.08a3,3,0,0,1,1.12-2.38C336.35,212.47,336.86,213,336.86,213.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.22,198.15a3,3,0,0,1-1.12,2.38c-.62.36-1.13-.12-1.13-1.08a3,3,0,0,1,1.13-2.38C347.72,196.71,348.22,197.19,348.22,198.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,200.46a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.13-1.12-1.08a3,3,0,0,1,1.12-2.39C360.93,199,361.44,199.5,361.44,200.46Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,202.45a3,3,0,0,1-1.13,2.38c-.62.36-1.13-.12-1.13-1.08a3,3,0,0,1,1.13-2.38C370.48,201,371,201.49,371,202.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.93,181.39a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.13-1.12-1.08a3,3,0,0,1,1.12-2.39C380.43,179.94,380.93,180.43,380.93,181.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.35,160.92a3,3,0,0,1-1.12,2.38c-.62.36-1.13-.12-1.13-1.08a3,3,0,0,1,1.13-2.38C389.85,159.48,390.35,160,390.35,160.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.1,174.09a3,3,0,0,1-1.12,2.38c-.63.36-1.13-.12-1.13-1.08A2.94,2.94,0,0,1,400,173C400.6,172.65,401.1,173.13,401.1,174.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.86,185.27c0,1.29,1,1.78,2.16,1.09l28.17-16.26a4.65,4.65,0,0,0,2.16-3.6c0-1.29-1-1.78-2.16-1.09L305,181.67A4.63,4.63,0,0,0,302.86,185.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85,192.83a.51.51,0,0,0,.25-.06L335.6,174a.5.5,0,0,0-.5-.86L302.6,191.9a.5.5,0,0,0-.18.68A.5.5,0,0,0,302.85,192.83Zm41.06-19.51a.5.5,0,0,0-.68-.18L302.6,196.59a.5.5,0,0,0-.18.68.5.5,0,0,0,.43.25.51.51,0,0,0,.25-.06L343.73,174A.5.5,0,0,0,343.91,173.32Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,142.86c0,1.29,1,1.78,2.16,1.09l10.95-6.32a4.65,4.65,0,0,0,2.16-3.6c0-1.29-1-1.78-2.16-1.09l-10.95,6.32A4.63,4.63,0,0,0,385.07,142.86Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.14,221.78a3.41,3.41,0,0,0-1.5-3.21h0l-3.86-2.21h0a3.41,3.41,0,0,0-3.53.3L295.93,276.89a10.88,10.88,0,0,0-4.92,8.53v73.72a3.44,3.44,0,0,0,1.46,3.2h0l3.95,2.25h0a3.47,3.47,0,0,0,3.49-.34L404.22,304a10.88,10.88,0,0,0,4.92-8.53Z",
    style: {
      fill: "#508C9B",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.14,221.78v73.73a10.88,10.88,0,0,1-4.92,8.53L299.9,364.26c-2.41,1.4-4.43.54-4.84-1.87a4.17,4.17,0,0,0,.87-.4l104.32-60.22a10.89,10.89,0,0,0,4.92-8.52V219.51a4.3,4.3,0,0,0-.09-1C407.39,217.67,409.14,219,409.14,221.78Z",
    style: {
      fill: "#508C9B",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.21,218.93l-92.53,54.46L305,277.26s-3.55,1.91-5,2.88a8.23,8.23,0,0,0-1.32,1.13,10.17,10.17,0,0,0-2.82,6.36v7.74L295,361.42l-.85-66.05v-7.76a11.82,11.82,0,0,1,3.28-7.54,10.74,10.74,0,0,1,1.61-1.38c1.47-1,5.07-3,5.07-3l6.71-3.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 296.86 303.27 353.07 303.27 300.82 400.63 244.62 400.63 243.5 303.06 299.82 302.43 300.19 302.43 354.68 400.63 297.98 400.63 296.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 279.07 303.06 335.4 302.64 336.76 400.63 280.19 400.63 279.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 261.28 303.06 317.61 302.64 318.97 400.63 262.4 400.63 261.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.63 297.14 399.79 298.19 399.79 244.82 400.63 243.78 400.63 297.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.46 304.17 387.62 305.21 387.62 251.84 388.46 250.8 388.46 304.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.29 311.2 375.45 312.24 375.45 258.87 376.29 257.83 376.29 311.2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.12 318.22 363.28 319.27 363.28 265.9 364.12 264.85 364.12 318.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.95 325.25 351.11 326.29 351.11 272.92 351.95 271.88 351.95 325.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.78 332.27 338.94 333.32 338.94 279.95 339.78 278.9 339.78 332.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.61 339.3 326.77 340.34 326.77 286.97 327.61 285.93 327.61 339.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.44 346.32 314.6 347.37 314.6 294 315.44 292.95 315.44 346.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.65,338.36l-.43-.75c3-1.74,4.34-5.33,5.63-8.81,1.16-3.16,2.37-6.42,4.86-8.2a3.57,3.57,0,0,1,2.83-.81c1.58.32,2.63,2,3.65,3.7,1.68,2.74,2.87,4.32,5.19,3,2.68-1.54,3.81-3.51,5-5.6a15.79,15.79,0,0,1,6.27-6.78c2.73-1.58,4.08-8.33,5.38-14.86,1.4-7,2.72-13.64,5.78-15.4a2,2,0,0,1,1.79-.21c1.63.67,2.52,3.78,3.54,7.38,1.15,4,2.46,8.63,4.93,9.82a3.43,3.43,0,0,0,2.93-.08c1.89-.78,2.95.51,3.89,1.66,1.3,1.58,2.42,2.94,5.67.38,2.08-1.64,3.29-5,4.45-8.34,1.34-3.77,2.72-7.67,5.5-9.27,2.28-1.32,3.25-4.56,4.27-8,1.14-3.82,2.33-7.77,5.49-9.59a3.24,3.24,0,0,1,2.68-.48c1.48.48,2.3,2.3,3.1,4.05s1.47,3.27,2.62,3.64a2.58,2.58,0,0,0,2.08-.42l.43.75a3.41,3.41,0,0,1-2.78.5c-1.51-.49-2.34-2.33-3.14-4.11-.72-1.59-1.46-3.22-2.58-3.58a2.45,2.45,0,0,0-2,.4c-2.86,1.65-4,5.43-5.09,9.09s-2.09,7-4.67,8.48-3.83,5.19-5.11,8.81c-1.21,3.41-2.45,6.93-4.73,8.73-3.93,3.09-5.57,1.09-6.88-.51-1-1.24-1.66-1.92-2.89-1.4a4.33,4.33,0,0,1-3.64.05c-2.82-1.36-4.18-6.14-5.38-10.36-.88-3.1-1.8-6.31-3-6.81a1.09,1.09,0,0,0-1,.15c-2.72,1.57-4.06,8.3-5.36,14.82-1.4,7-2.72,13.67-5.8,15.44a15.15,15.15,0,0,0-5.95,6.47,14,14,0,0,1-5.33,5.92c-3.21,1.85-4.88-.88-6.36-3.29-.92-1.5-1.87-3.05-3.08-3.3a2.77,2.77,0,0,0-2.15.67c-2.28,1.62-3.39,4.62-4.56,7.79C307.32,332.73,305.93,336.47,302.65,338.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,337.34a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.12-1.12-1.08a3,3,0,0,1,1.12-2.38C303.05,335.9,303.56,336.38,303.56,337.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.15,320.34a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.13-1.12-1.08a3,3,0,0,1,1.12-2.39C313.64,318.89,314.15,319.38,314.15,320.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.82,326.22a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.12-1.12-1.08a3,3,0,0,1,1.12-2.38C325.31,324.78,325.82,325.26,325.82,326.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.86,313.91a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.12-1.12-1.08a3,3,0,0,1,1.12-2.38C336.35,312.47,336.86,313,336.86,313.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.22,283.51a3,3,0,0,1-1.12,2.38c-.62.36-1.13-.12-1.13-1.08a3,3,0,0,1,1.13-2.38C347.72,282.07,348.22,282.55,348.22,283.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,300.46a3,3,0,0,1-1.13,2.38c-.62.36-1.12-.13-1.12-1.08a3,3,0,0,1,1.12-2.39C360.93,299,361.44,299.5,361.44,300.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,302.45a3,3,0,0,1-1.13,2.38c-.62.36-1.13-.12-1.13-1.08a3,3,0,0,1,1.13-2.38C370.48,301,371,301.49,371,302.45Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.93,284.85a2.93,2.93,0,0,1-1.13,2.38c-.62.36-1.12-.12-1.12-1.08a3,3,0,0,1,1.12-2.38C380.43,283.41,380.93,283.89,380.93,284.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.35,267.48a3,3,0,0,1-1.12,2.38c-.62.36-1.13-.13-1.13-1.08a3,3,0,0,1,1.13-2.39C389.85,266,390.35,266.52,390.35,267.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.1,274.09a3,3,0,0,1-1.12,2.38c-.63.36-1.13-.12-1.13-1.08A2.94,2.94,0,0,1,400,273C400.6,272.65,401.1,273.13,401.1,274.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.86,285.3c0,1.29,1,1.78,2.16,1.09l28.17-16.26a4.65,4.65,0,0,0,2.16-3.59c0-1.3-1-1.79-2.16-1.1L305,281.7A4.63,4.63,0,0,0,302.86,285.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.07,242.89c0,1.3,1,1.79,2.16,1.1l10.95-6.33a4.65,4.65,0,0,0,2.16-3.6c0-1.29-1-1.78-2.16-1.09l-10.95,6.33A4.62,4.62,0,0,0,385.07,242.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.85,292.87a.52.52,0,0,0,.25-.07L335.6,274a.51.51,0,0,0,.18-.69.49.49,0,0,0-.68-.18l-32.5,18.76a.51.51,0,0,0-.18.69A.5.5,0,0,0,302.85,292.87Zm41.06-19.52a.5.5,0,0,0-.68-.18L302.6,296.62a.51.51,0,0,0-.18.69.5.5,0,0,0,.43.25.52.52,0,0,0,.25-.07L343.73,274A.51.51,0,0,0,343.91,273.35Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.24,396c.43,2.66,1.28,5.74,1.94,11.17s-.52,5.62,2.75,19.26c2,8.18,1.51,11.41-3.61,18.17-5.48,7.23-11,5.63-14.47-2.6-3-7-2.71-10.26-2.58-17.48s.11-9.32-.1-15.05c-.19-5,.3-8.48.07-12.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.48,415.8c-.86-7-.94-14.26-1.21-19-.59-10.6,2-31.48.8-47.44l-26.78-3.27c.77,6.23,7.61,34.46,10,51.46,0,0,.59,23,1.86,33.18a1.94,1.94,0,0,0,2.69,1.56,17.67,17.67,0,0,1,12.17-.54A1.93,1.93,0,0,0,457.6,430C457.61,426.21,456.12,421.06,455.48,415.8Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.45,344.41c.1,22-.12,41.57-.9,47.29s-1.11,7.65-2.58,11.65-3.92,9.32-6.11,11.9c0,0-6.3,6.72-4.9,7.42s14.6,2.08,20.5.3S390,416.18,392,407s3.74-22.52,3.74-22.52a5.94,5.94,0,0,1-.6-1.55c-.79-2.63,1.61-9.49,2.22-16.14Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.62,398.18c-.39,2.13-2.22,4.55-3,7.87a59.27,59.27,0,0,0-1.72,11.57c-.27,4.77-.3,5.44-.3,5.44l-1.48-.08s.38-6.89.55-9.91,0-5.25-1.44-5.65C394.19,407.42,394.47,397.78,401.62,398.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.51,383.28c1,2.53,4.17,6.08,5.55,8.49a9.07,9.07,0,0,1,1.13,4.14,4.34,4.34,0,0,1-1.31,3.24,49.78,49.78,0,0,0-4.59,5.08c-1.8,2.42-5.19,8.08-6.13,12.07s-1.48,7.51-4.91,9.5c-2.68,1.54-13.65,3.7-19.21,4.05-7.58.48-9.54-3.16-6.71-6.08s7.66-7.89,8.53-8.52a13.77,13.77,0,0,1,7.05,1c4.24,1.83,5.59,4.29,10,2.07,4-2,5.65-9.48,5.31-20.22C389.88,385.9,395.51,383.28,395.51,383.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.2,194.13c.49,2.77,1.05,5.36,2,6.75,6,8.47,12.18,18.73,13.21,34.47a693.27,693.27,0,0,1,.34,74.59c.26,3.35,2.8,11.49,3.15,30.62.29,15.25-.73,38.94-.73,38.94s-10.95,5.3-20.44,1.65c-3.74-14.57-9.93-49.56-13.6-66.22-3.88-17.56-7.83-38.5-7.83-38.5l-6.57,30.64a88.81,88.81,0,0,1-.25,19.82c-1.21,10.17-9.5,46.05-9.5,46.05s-12.14,3.69-20.3-2c0,0-.7-50.78-.71-62s2.18-77.78,9.23-107a63.51,63.51,0,0,0,.45-6.81C393.68,201.73,426.48,201.27,437.2,194.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.43,374.24c-4.16,3.78-16.89,4.72-21.87,2l1.51,7.93s3.28,2.24,10.52,1.63,9.56-3.5,9.56-3.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.25,367.91c-4.31,1.42-17.14.67-21.84-2.24l.2,6.8s2.65,2.55,9.87,3.31,10.37-1.24,10.37-1.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.34,276.43l-4.72-37.56a23.72,23.72,0,0,1-19-9.14s-.31,9.39,15.12,13.7l5.65,34.63-3.66,29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.33,201.33s7.77,5.92,26.11,5.15,27.24-6.55,27.12-6.87h0a25.83,25.83,0,0,1-1.23-4.78c-.06-.28-.1-.52-.13-.7-10.72,7.14-43.52,7.6-51.51.94,0,0-.1,4.38-.36,6.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.82,200.94c-2.11,4.39-5.25,13.58-5.48,19.89a21.75,21.75,0,0,0,9.45,2.11s1.26-11.06-.76-20.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.19,198.53c3.25,3.62,8.83,11.57,10.82,17.57a21.78,21.78,0,0,1-8.48,4.66s-4.31-10.26-5-19.9Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.84,134.86c-10,2.43-14.17,4.4-19.94,12.45-5,7-18.8,25.83-18.8,25.83l-11.26-14.25-12.15,3.16c4.18,4.83,10.86,29.14,18.52,34.84,4.72,3.52,9.39.18,13.35-3.74,5.92-5.87,18.5-20,18.5-20Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92,134.4c-3.56.31-10.82,1.33-15.24,5.67s-9.77,12.16-16.92,22-7.66,10.61-7.66,10.61l-5.82-7.57s-.13,3.21-4.2,6.16a10.3,10.3,0,0,1-8.7,1.41s4,9.63,6.18,14.35S354.89,199,360.06,199s7.86-3.31,11.59-7,23.57-23.32,23.57-23.32Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92,134.4c-3.56.31-10.82,1.33-15.24,5.67s-9.77,12.16-16.92,22-7.66,10.61-7.66,10.61l-5.82-7.57s-.13,3.21-4.2,6.16a10.3,10.3,0,0,1-8.7,1.41s4,9.63,6.18,14.35S354.89,199,360.06,199s7.86-3.31,11.59-7,23.57-23.32,23.57-23.32Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5,170.69l-1.4,2c5.42,8.07,5.27,12.82,5.27,12.82S368.9,180.78,362.5,170.69Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.55,128.82h0l1.39-1.32v0a1.62,1.62,0,0,1,1.48-.23l15.87,3.54a5.78,5.78,0,0,1,3.67,3.13l12.77,32a1.5,1.5,0,0,1-.13,1.67h0L361.15,169v0a1.67,1.67,0,0,1-1.5.24l-15.87-3.54a5.78,5.78,0,0,1-3.67-3.13l-12.77-32C327,129.76,327.14,129.15,327.55,128.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.61,133a5.7,5.7,0,0,1,1.93,2.31l12.77,32a1.56,1.56,0,0,1-.08,1.64l1.35-1.27,0,0a1.47,1.47,0,0,0,.14-1.67l-12.77-32a5.54,5.54,0,0,0-1.78-2.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.31,167.31l-12.77-32a5.8,5.8,0,0,0-3.68-3.13L329,128.61c-1.48-.32-2.22.54-1.66,1.94l12.77,32a5.78,5.78,0,0,0,3.67,3.13l15.87,3.54C361.12,169.58,361.86,168.71,361.31,167.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.83,142.11l-2.39-6a1.13,1.13,0,0,0-.69-.59l-3-.66c-.27-.06-.41.1-.31.36l2.39,6a1.08,1.08,0,0,0,.69.58l3,.67C348.79,142.54,348.93,142.38,348.83,142.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.36,137.58a2.73,2.73,0,0,0-1.75-1.44c-.71-.16-1.08.23-.82.87a2.68,2.68,0,0,0,1.75,1.44C346.25,138.61,346.62,138.22,346.36,137.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.53,140.61a2.73,2.73,0,0,0-1.75-1.44c-.71-.16-1.08.23-.83.86a2.74,2.74,0,0,0,1.75,1.45C347.41,141.63,347.78,141.25,347.53,140.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.85,148.2c-1.78-2-1.67-2.27-1-3.46a6.83,6.83,0,0,1,5.18-3.46c1.9-.16,3.8-.42,4.83,0s.44,2.53-2,3.37c-3.77,1.31-3.63,2.36-3.63,2.36a50.55,50.55,0,0,1,4.91-1.45,36,36,0,0,1,5.79.2c1.66.07,2.23,2.15-.46,3.19l3,.14c2.14.09,3,1.12,1.48,2.61a3.06,3.06,0,0,1-1.81.94s2.23-.26,2.36.47c.38,2.12-.94,2.84-5.3,4.67-4.16,1.75-4.78,4.17-3.74,5.67,0,0-1.85-.81-3.52-1.7-1.22-.65-2.28-1.42-2-3.25,0,0-2.45.34-2.78-1.17a8,8,0,0,1,.22-3.33,2.71,2.71,0,0,1-1.65-2.37,4.41,4.41,0,0,1,.59-2.78Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.54,148.93a14.17,14.17,0,0,0-2.76,0,9,9,0,0,0-2.54,1.14,32.76,32.76,0,0,0-4.45,3.09,32.12,32.12,0,0,0,4.85-2.39,14.36,14.36,0,0,1,2.29-1.24C342.73,149.33,343.67,149.2,344.54,148.93Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.26,152.62a5.86,5.86,0,0,0-3,.25,16,16,0,0,0-2.7,1.2,27.54,27.54,0,0,0-4.81,3.34,54.92,54.92,0,0,0,5.19-2.64A15.41,15.41,0,0,1,347.26,152.62Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.47,129.77,437,134.91c2.84,1,13.57,7.52,9.82,23.68-1.24,5.34-2.93,12.85-4.46,20.34-1.16,5.73,3.12,16.75,6.58,34.3,0,0-14.19,11.29-42.39,8.1-21.51-2.43-23.84-10.48-23.84-10.48.6-20,2.37-27.76,2.33-35.37a18.33,18.33,0,0,1-3.28-10.64c-.13-7.14,1.74-11,8.14-19.08a136.91,136.91,0,0,1,11.72-13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.88,154.67c-5,11.34-1.62,76-2.06,71.14,0,0-9.27-3.59-10.13-6.68,0-11.64,2.14-35,2.28-43,.15-9.19.06-15.85,3-21.49s14.2-19.5,18.64-21.89C397.05,136.7,391.77,147.88,389.88,154.67Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M389.88,154.67c-5,11.34-1.62,76-2.06,71.14,0,0-9.27-3.59-10.13-6.68,0-11.64,2.14-35,2.28-43,.15-9.19.06-15.85,3-21.49s14.2-19.5,18.64-21.89C397.05,136.7,391.77,147.88,389.88,154.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M408,133.36c-3.13,2.15-17.14,11.78-19.93,30.53,0-8.26,3.11-18.39,6.07-23.19,3.6-5.85,8.38-11.31,13.75-12.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.8,130s.15.24,0,3.77-5.7,30.07-5.8,42.81a415.9,415.9,0,0,0,3.08,51.25s20.54,1.87,28.1-8.35a144,144,0,0,1-7-26.75c-1.5-9.19,4.61-31.67,3-45-.66-5.56-.28-10.55-4.45-11.85-3.44-1.09-8.93-2.53-8.93-2.53Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.8,130s.15.24,0,3.77-5.7,30.07-5.8,42.81a415.9,415.9,0,0,0,3.08,51.25s20.54,1.87,28.1-8.35a144,144,0,0,1-7-26.75c-1.5-9.19,4.61-31.67,3-45-.66-5.56-.28-10.55-4.45-11.85-3.44-1.09-8.93-2.53-8.93-2.53Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.41,117.06c-1-1.93-1.8-4.11-3.35-5.67s-3.58-2.38-5.35-3.55L393,104.06c-6.92-4-6.26-13.19-4.39-17.92,4.17-10.57,15.85-14.19,23-14.34,13.58-.29,20.08,3.43,21.25,10.5a8.93,8.93,0,0,1,7.47,3.78c3.3,4.57,2.9,11.49,1.38,16.43-2.34,7.62-4.85,10.15-8,12.79a22.32,22.32,0,0,0-6.65,8.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.57,117.38c2.45.44,4.38-.78,5.85-2.42,3.27-3.64,3.55-7.32,2-9.76-1.27-2-4.38-3.28-6.55-1.9s-2.38,2.66-3.25,4.32-4.27,1.52-5.12-5.12c-.8-6.19-1.77-11.87-4.82-14.65-4.56-4.15-9.6-3.44-11.39-1-1.86-2.88-4.69-4-7.77-2.35s-5.42,6.31-6.41,18.08c-1,12,1.85,19.46,4.61,21.46,2.09,1.51,4.43,2.19,8.93,2.36l-.43,7.66s-7.88,16.06-7.8,26.34c0,0,3.95-6.39,15.44-15.78l12.48-10.21,1.28-18.94A3.83,3.83,0,0,0,430.57,117.38Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,103a2.08,2.08,0,0,0,2.48,1,1.56,1.56,0,0,0,1.3-2,2.12,2.12,0,0,0-2.49-1A1.56,1.56,0,0,0,411.44,103Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.44,100.92c1.24,0,2,1.69,3.18,1a1.79,1.79,0,0,1-2.41,1C413.65,102.65,413.44,100.92,413.44,100.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,98l4.2-2.18a2.27,2.27,0,0,0-3.12-1.07A2.49,2.49,0,0,0,396,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,102.44a2.11,2.11,0,0,1-2.53.94,1.57,1.57,0,0,1-1.21-2.06,2.09,2.09,0,0,1,2.53-.95A1.58,1.58,0,0,1,401,102.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.08,100.27c-1.25,0-2.05,1.61-3.22.9a1.79,1.79,0,0,0,2.37,1.09C398.8,102,399.08,100.27,399.08,100.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.57,96.13l4.7,1.9A2.44,2.44,0,0,0,416,94.75,2.66,2.66,0,0,0,412.57,96.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.74,88.53a10.94,10.94,0,0,1,1.15,4.57c.12,1.62.15,5.42,1.16,7.71a5.89,5.89,0,0,0,4.38,3.66,7.88,7.88,0,0,0,3.8-.26c.76-.32,2.29-.78,2.72-3.9a4.61,4.61,0,0,1-1.57,1,4.54,4.54,0,0,1-1.41.29,4.26,4.26,0,0,1-3.51-2.1c-1.34-2.14-1.15-5-1.5-7.37-.45-3.07-.87-6.55-3.57-8.15a5.68,5.68,0,0,0-7.69,1.72C411.93,84.48,413.91,87,414.74,88.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,113.47l-6.59,1.9A3.44,3.44,0,0,0,411,117.6,3.21,3.21,0,0,0,413,113.47Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.09,117.74a3.59,3.59,0,0,1,3.71-3.08,3.31,3.31,0,0,1,.33,0,3,3,0,0,1-2.15,2.9A3.85,3.85,0,0,1,409.09,117.74Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.43 99.32 406.16 111.1 399.75 108.68 407.43 99.32",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.65,126.44A41.92,41.92,0,0,0,419.44,124c1.49-.6,3.54-3.24,5.24-6.2,0,0-1.28,5.87-4.52,7.83-4.93,3-13.67,3.43-13.67,3.43Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.9,126.32c1.57-.08,2,.89,4.06,3.25a30.49,30.49,0,0,0,3.91,3.77c-1.92,11.69-11.12,26.26-13.75,40-.11-11.11,2.7-26.22,5.52-43.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.71,239.48c3.19,1,7.28-3.16,8.41-4.58s-.32-4.83-1-7.7,0-7.71-3.42-6.36S449.07,231.76,455.71,239.48Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,136.46c9.51,3,12.44,3.46,17.32,13.64C467,162,476.21,178,478.24,184.63c1.45,4.75.74,7-3.57,14.77-4.51,8.14-17.22,29.13-19.36,31.69-1.9,2.26-.89,7.77,5.62,6.82,0,0-5,4.52-7.67,4-2.35-.44-6-2.57-9.41-9.94-2.13-4.65-.34-7.65,2.92-15.32,2.86-6.74,13-29.45,13-29.45l-15.78-28S436.43,144.62,444,136.46Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.8,135.87c8.94,1.76,10.94,3.29,14.7,8.18s14.48,25.89,17.22,31.63,4.83,11,4.47,13.53-14.39,25.32-14.39,25.32-10.73-1-14.3-9.57l7.26-17.47L443,161.61S434.8,142.4,443.8,135.87Z",
    style: {
      fill: "#508C9B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.8,135.87c8.94,1.76,10.94,3.29,14.7,8.18s14.48,25.89,17.22,31.63,4.83,11,4.47,13.53-14.39,25.32-14.39,25.32-10.73-1-14.3-9.57l7.26-17.47L443,161.61S434.8,142.4,443.8,135.87Z",
    style: {
      opacity: 0.4
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBit1);
export default __webpack_public_path__ + "static/media/bit1.6c5ab3ef52fe110d8c9364923d567974.svg";
export { ForwardRef as ReactComponent };